import { useAppStore } from '../stores/appStore';

export const translations = {
  en: {
    // Search
    searchPlaceholder: 'Say the API #, Well Name, or Facility Type',
    searchPlaceholderHint: 'e.g. "compressor" or "flare"',
    searchResults: 'Search Results',
    noResults: 'No results found',
    byFacilityType: 'By Facility Type',
    noFilteredResults: 'No results match your filters. Try adjusting or clearing filters.',
    tryDifferentSearch: 'Try a different search term or check your filters',
    letters: 'Letters',
    secondLetters: 'Second Letter',
    thirdLetters: 'Third Letter',
    fourthLetters: 'Fourth Letter',
    loadingResults: 'Loading results...',
    noTypeFound: 'No {0} found',
    showingCountOf: 'Showing {0} of {1} results',
    searchingFor: 'Searching for',
    results: 'results',
    result: 'result',
    cachedLabel: 'cached',
    liveLabel: 'live',
    
    // Navigation
    navigate: 'Navigate',
    getDirections: 'Get Directions',
    startNavigation: 'Start Navigation',
    
    // Favorites
    favorites: 'Favorites',
    noFavorites: 'No saved facilities yet',
    tapToSave: 'Tap the star icon on any facility to save it',
    savedFacilities: 'saved facilities',
    savedFacility: 'saved facility',
    removeFromFavorites: 'Remove from favorites',
    addToFavorites: 'Add to favorites',
    
    // Facility types
    all: 'All',
    well: 'Well',
    rig: 'Rig',
    swd: 'SWD',
    facility: 'Facility',
    wells: 'Wells',
    rigs: 'Rigs',
    swds: 'SWDs',
    tankBattery: 'Tank Battery',
    flareStack: 'Flare Stack',
    compressor: 'Compressor',
    gasPlant: 'Gas Plant',
    brineWell: 'Brine Well',
    refinery: 'Refinery',
    treatingPlant: 'Treating Plant',
    wellHead: 'Well Head',
    gasGathering: 'Gas Gathering',
    injectionPlant: 'Injection Plant',
    gasPipeline: 'Gas Pipeline',
    crudePipeline: 'Crude Pipeline',
    waterPipeline: 'Water Pipeline',
    gasStorage: 'Gas Storage',
    belowGradeTank: 'Below Grade Tank',
    meteringStation: 'Metering Station',
    crudePump: 'Crude Pump',
    pumpJack: 'Pump Jack',
    pits: 'Pits',
    pitGeneral: 'Pit (General)',
    pitEmergency: 'Pit (Emergency)',
    pitTemporary: 'Pit (Temporary)',
    pitPermanent: 'Pit (Permanent)',
    pitMultiWell: 'Pit (Multi-well)',
    sump: 'Sump',
    wasteMgmt: 'Waste Mgmt',
    recycling: 'Recycling',
    sewerWastewater: 'Sewer / Wastewater',
    facilitySourceOfficial: 'Official source',
    facilitySourceOfficialShort: 'Official',
    facilitySourceOfficialLowCount: 'Official low count',
    facilitySourceOfficialLowCountShort: 'Low',
    facilitySourceSupplementalPublic: 'Supplemental public source',
    facilitySourceSupplementalPublicShort: 'Public',
    facilitySourcePending: 'Source pending',
    facilitySourcePendingShort: 'Pending',
    facilitySourceUnavailable: 'Source unavailable',
    facilitySourceUnavailableShort: 'Unavailable',
    facilitySourceOfficialMessage: 'This facility card is backed by official coordinate-backed source records.',
    facilitySourceOfficialLowCountMessage: 'This count is low because the official source only has a few records in this district or county.',
    facilitySourceHiddenUnsupportedMessage: 'This card is hidden until a reliable coordinate-backed source exists.',
    facilitySourceSupplementalPublicMessage: 'Supplemental public records are clearly labeled and do not replace official sources.',
    facilitySourceUnavailableMessage: 'No official coordinate-backed source is imported yet.',
    remediate: 'Remediate',
    abatement: 'Abatement',
    abatementPlan: 'Abatement Plan',
    serviceCo: 'Service Co.',
    classIII: 'Class I/II',
    classI: 'Class I',
    classII: 'Class II',
    ocdIncidents: 'OCD Incidents',
    portaPotty: 'Porta Potty',
    wellPad: 'Well Pad',
    frackingSite: 'Fracking Site',
    drillingSite: 'Drilling Site',
    location: 'Nearby',
    activeOps: 'Active Ops',
    more: 'All Types',
    dryHole: 'Dry Hole',
    oilWell: 'Oil Well',
    oilGasWell: 'Oil/Gas Well',
    horizontalWell: 'Horizontal Well',
    directionalWell: 'Directional Well',
    injectionWell: 'Injection Well',
    saltWaterDisposal: 'Salt Water Disposal',
    waterWell: 'Water Well',
    co2Well: 'CO2 Well',
    permitted: 'Permitted',
    canceled: 'Canceled',
    pluggedOil: 'Plugged Oil',
    pluggedGas: 'Plugged Gas',
    pluggedOilGas: 'Plugged Oil/Gas',
    shutInOil: 'Shut-In Oil',
    shutInGas: 'Shut-In Gas',
    storage: 'Storage',
    storageOil: 'Storage Oil',
    storageGas: 'Storage Gas',
    sulfurCore: 'Sulfur Core',
    serviceWell: 'Service Well',
    unknownWell: 'Unknown Well',
    miscellaneous: 'Miscellaneous',
    otherLabel: 'Other',
    waterSupply: 'Water Supply',
    brineMining: 'Brine Mining',
    coreTest: 'Core Test',
    observationWell: 'Observation Well',
    unknownFacility: 'Unknown Facility',
    commercialSwdTx: 'Commercial SWD (TX)',
    tacoTruck: 'Taco Truck',
    tacoTruckName: 'Truck Name',
    enterTruckName: 'Enter taco truck name',
    tacoTruckMarked: 'Taco truck location marked',
    tacoNameExists: 'A taco truck with this name already exists today',
    showTacoLocations: 'Show taco truck locations',
    burger: 'Burger',
    coffee: 'Coffee',
    cafe: 'Cafe',
    shake: 'Shake',
    bakery: 'Bakery',
    foodTruck: 'Food Truck',
    automotive: 'Auto Service',
    parts: 'Parts',
    vape: 'Vape Shop',
    marijuana: 'Dispensary',
    fuel: 'Fuel',
    waterStation: 'Water Station',
    supplies: 'Supplies',
    searchFacilityTypes: 'Search Across {0} Facility Types',
    searchFacilities: 'Search Facilities',
    communityFacilitiesTitle: 'Community Facilities',
    communityFacilitiesSearchPlaceholder: 'Search facilities...',
    communityFacilitiesNoMatch: 'No facilities match your search',
    communityFacilitiesEmpty: 'No facilities added yet',
    communityFacilitiesGoogleMaps: 'Google Maps',
    communityFacilitiesViewPhotos: 'View Photos',
    communityFacilitiesAddPhotoFirst: 'Be first to add a photo!',
    communityFacilitiesLoadFailed: 'Failed to load facilities',
    communityFacilitiesCopyFailed: 'Unable to copy text',
    searchAddress: 'Search Address',
    treating: 'Treating',
    injection: 'Injection',
    // Oil Well alphabetical ranges (10 cards for ~10K each)
    oilWell0B: 'Oil 0-B',
    oilWellCD: 'Oil C-D',
    oilWellEF: 'Oil E-F',
    oilWellGH: 'Oil G-H',
    oilWellIK: 'Oil I-K',
    oilWellLM: 'Oil L-M',
    oilWellNO: 'Oil N-O',
    oilWellPR: 'Oil P-R',
    oilWellST: 'Oil S-T',
    oilWellUZ: 'Oil U-Z',
    // Gas Well (single card)
    gasWell: 'Gas Well',
    // Horizontal Well alphabetical ranges (10 cards for TX)
    horizontal0B: 'Horiz 0-B',
    horizontalCD: 'Horiz C-D',
    horizontalEF: 'Horiz E-F',
    horizontalGH: 'Horiz G-H',
    horizontalIK: 'Horiz I-K',
    horizontalLM: 'Horiz L-M',
    horizontalNO: 'Horiz N-O',
    horizontalPR: 'Horiz P-R',
    horizontalST: 'Horiz S-T',
    horizontalUZ: 'Horiz U-Z',
    gasLine: 'Gas Line',
    crudeLine: 'Crude Line',
    waterLine: 'Water Line',
    gasGather: 'Gas Gather',
    metering: 'Metering',
    belowGrade: 'Below Grade',
    
    // Actions
    copy: 'Copy',
    copied: 'Copied!',
    apiCopied: 'API {0} copied!',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm',
    close: 'Close',
    save: 'Save',
    share: 'Share',
    saveSettings: 'Save Settings',
    submit: 'Submit',
    add: 'Add',
    remove: 'Remove',
    edit: 'Edit',
    
    // Status
    loading: 'Loading...',
    offline: 'Offline',
    online: 'Online',
    active: 'Active',
    inactive: 'Inactive',
    error: 'Error',
    success: 'Success',
    
    // FAB tooltips
    addFacility: 'Add New Facility',
    activeOperations: 'Active Operations',
    toggleTheme: 'Toggle Theme',
    toggleLanguage: 'Cambiar a Español',
    viewOnMap: 'View on Map',
    lightMode: 'Light Mode',
    darkMode: 'Dark Mode',
    highContrast: 'High Contrast',
    normalContrast: 'Normal Contrast',
    
    // Map
    mapView: 'Map View',
    listView: 'List View',
    satellite: 'Satellite',
    terrain: 'Terrain',
    
    // Filters
    allCounties: 'All Counties',
    filterByCounty: 'Filter by County',
    filterByType: 'Filter by Type',
    filterByOperator: 'Filter by Operator',
    filterByStatus: 'Filter by Status',
    allStatus: 'All Status',
    allTypes: 'All Types',
    allOperators: 'All Operators',
    sortAZ: 'Sort A-Z',
    sortZA: 'Sort Z-A',
    clearFilters: 'Clear Filters',
    filter: 'filter',
    filters: 'filters',
    
    // Voice
    tapToSpeak: 'Tap to speak',
    searchHint: 'Say the API #, Well Name, or Facility Type',
    searchHintFallback: 'e.g. "compressor" or "flare"',
    listening: 'Listening...',
    voiceNavigation: 'Voice Navigation',
    speakDestination: 'Speak your destination',
    recentSearches: 'Recent Searches:',
    searchBelow: 'Type to Search',
    voiceNotSupported: 'Voice unavailable',
    
    // Facility details
    apiNumber: 'API Number',
    operator: 'Operator',
    county: 'County',
    status: 'Status',
    distance: 'Distance',
    miles: 'miles',
    feet: 'feet',
    coordinates: 'Coordinates',
    lat: 'LAT',
    lng: 'LNG',
    latitude: 'Latitude',
    longitude: 'Longitude',
    wellName: 'Well Name',
    wellType: 'Well Type',
    pool: 'Pool',
    district: 'District',
    township: 'Township',
    range: 'Range',
    section: 'Section',
    
    // Directions
    turnLeft: 'Turn left',
    turnRight: 'Turn right',
    continueOn: 'Continue on',
    arrive: 'Arrive at destination',
    inMiles: 'in {0} miles',
    inFeet: 'in {0} feet',
    
    // Onboarding
    welcome: 'Welcome',
    getStarted: 'Get Started',
    skip: 'Skip',
    next: 'Next',
    back: 'Back',
    
    // Errors
    locationError: 'Unable to get your location',
    networkError: 'Network error. Please try again.',
    searchError: 'Search failed. Please try again.',
    
    // Time
    lastUpdated: 'Last updated',
    justNow: 'Just now',
    minutesAgo: '{0} minutes ago',
    hoursAgo: '{0} hours ago',
    daysAgo: '{0} days ago',
    
    // Crews
    myCrews: 'My Crews',
    addCrew: 'Add Crew',
    crewName: 'Crew Name',
    crewMembers: 'Crew Members',
    
    // Landing Page - Hero Section
    heroTagline: 'Field Intelligence For Oilfield Crews',
    heroSubtagline: 'Navigate faster. Work safer. Keep better records.',
    heroDescription: 'ZiaWellNav helps crews find wells and facilities, navigate lease roads, complete JSAs and field forms, receive hazard alerts, manage safety records, training, fleet, policies, and company communication from one Telegram Mini App. Every subscription also helps feed local families through WHI Hobbs.',
    alreadyUsingZia: 'Already using Zia?',
    openBot: 'Open @vamosar_race_bot',
    openBotShort: 'Bot',
    landingSubscribeButton: 'Subscribe',
    landingRacePassButton: 'Race Pass $2',
    themeAutoShort: 'Auto',
    themeDarkShort: 'Dark',
    themeLightShort: 'Light',
    freeModeButtonShort: 'Demo',
    freeModeButton: 'Free Demo',
    freeModeButtonDuration: 'Chrome Free Demo · 30 minutes',
    freeModeDeviceNotice: 'Try the app locally on this device. Paid subscriptions and purchase linking stay unchanged.',
    freeModeTestingNotice: 'Chrome Free Demo Mode previews public navigation, search, maps, hazards, weather, favorites, and route handoff. Open ZiaWellNav in Telegram for 100% platform support, signed company records, bot notifications, AI/RAG, forms, timesheets, fleet, policies, training, and subscriptions.',
    landingChromeDemoCardTitle: 'Chrome Free Demo Mode',
    landingChromeDemoCardPercent: '{0}% preview support',
    landingChromeDemoCardDesc: 'Public navigation works here. Signed company workflows open in Telegram.',
    landingChromeDemoWorksTitle: 'Works in Chrome Demo',
    landingChromeDemoTelegramTitle: 'Open in Telegram',
    landingChromeDemoTelegramExtra: 'Phone GPS and Cert Vault sync',
    landingChromeDemoOpenTelegram: 'Open in Telegram',
    landingChromeDemoStart: 'Start Chrome Demo',
    freeModeCountdownFull: 'FREE MODE · {0} MIN LEFT',
    freeModeCountdownShort: 'FREE · {0}M',
    freeModeCountdownChromeDemoFull: 'CHROME DEMO · {0} MIN · 50% PREVIEW',
    freeModeCountdownChromeDemoShort: 'DEMO · {0}M · 50%',
    freeModeDemoEnteredNotice: 'You are previewing public navigation features. Open in Telegram for 100% support.',
    advancedFeaturesTitle: 'Advanced Features',
    advancedFeaturesDesc: 'Built by oilfield workers, for oilfield workers. Powerful tools for the modern oilfield.',
    landingOilfieldFormsTitle: 'Important Oilfield Forms',
    landingOilfieldFormsCount: '{0} field-ready forms included',
    landingOilfieldFormsDesc: 'Field-ready forms for BBS observations, excavation, hot work, incidents, inspections, approvals, and crew communication before work starts.',
    landingSafetyDashboardTitle: 'Safety Dashboard',
    landingSafetyDashboardDesc: 'Run safety as a closed-loop workflow: Action Center, incident review, corrective actions, worker views, acknowledgements, reminders, training/policy links, and exportable audit packets from the Company Dashboard.',
    landingSafetyDashboardCta: 'Open Safety tab',
    landingSafetyDashboardFeatureIncidentReview: 'Action Center',
    landingSafetyDashboardFeatureIncidentReviewDesc: 'Rank critical, overdue, incomplete, and audit-ready safety items so owners know what needs attention first.',
    landingSafetyDashboardFeatureCorrectiveActions: 'Closed-loop timeline',
    landingSafetyDashboardFeatureCorrectiveActionsDesc: 'Track sent, viewed, acknowledged, reminded, completed, and audit-ready events across bulletins, policies, and training.',
    landingSafetyDashboardFeatureBulletins: 'Safety bulletins',
    landingSafetyDashboardFeatureBulletinsDesc: 'Publish lessons learned, record explicit worker views, and track acknowledgements before closeout.',
    landingSafetyDashboardFeatureRecordkeeping: 'Recordkeeping and evidence',
    landingSafetyDashboardFeatureRecordkeepingDesc: 'Keep incident reviews, corrective actions, case status, files, and evidence references tied to the right safety record.',
    landingSafetyDashboardFeatureExceptions: 'Overdue and legacy gaps',
    landingSafetyDashboardFeatureExceptionsDesc: 'Surface incomplete timelines, overdue items, and missing acknowledgements before relying on an audit export.',
    landingSafetyDashboardFeatureExports: 'Audit packet exports',
    landingSafetyDashboardFeatureExportsDesc: 'Export timeline CSV/JSON, cover sheet, acknowledgement reports, evidence index, and optional bundled evidence files.',
    landingTrainingOnboardingTitle: 'Training & Onboarding',
    landingTrainingOnboardingDesc: 'Assign onboarding safety training, quizzes, and worker sign-offs from safety-program modules.',
    landingTrainingOnboardingCta: 'Open Training tab',
    landingTrainingOnboardingFeaturePacks: 'Onboarding packs',
    landingTrainingOnboardingFeaturePacksDesc: 'Start new workers with grouped safety modules instead of assigning each lesson one by one.',
    landingTrainingOnboardingFeatureQuiz: '80% quiz pass score',
    landingTrainingOnboardingFeatureQuizDesc: 'Workers must pass the module quiz before the training can be signed off.',
    landingTrainingOnboardingFeatureSignoff: 'Digital worker sign-off',
    landingTrainingOnboardingFeatureSignoffDesc: 'Capture acknowledgement after the employee has reviewed and passed the training.',
    landingTrainingOnboardingFeatureMatrix: 'Owner completion matrix',
    landingTrainingOnboardingFeatureMatrixDesc: 'Owners can see who is assigned, in progress, overdue, or complete.',
    landingTrainingOnboardingFeatureDueDates: 'Due dates and overdue tracking',
    landingTrainingOnboardingFeatureDueDatesDesc: 'Set target dates and surface training that still needs follow-up.',
    landingTrainingGenerationTitle: 'Training Management & Generation',
    landingTrainingGenerationTemplateCount: '{0} training templates',
    landingTrainingGenerationPackCount: '{0} management packs',
    landingTrainingGenerationTemplateCountDesc: 'Ready for Cyber, Word, Excel, AI, onboarding, safety training, quizzes, assignments, and sign-off tracking.',
    landingTrainingGenerationDesc: 'Generate ready-to-assign training from {0} templates and {1} management packs covering Cyber, Word, Excel, AI, onboarding, and safety, then send them to all linked users, one crew, or selected employees immediately.',
    landingTrainingGenerationCta: 'Open Training tools',
    landingTrainingGenerationFeatureBusinessPacks: '{0} ready-to-assign management packs',
    landingTrainingGenerationFeatureBusinessPacksDesc: 'Use {0} grouped packs for office tools, cybersecurity basics, safe AI use, onboarding, and field safety without building each module by hand.',
    landingTrainingGenerationFeatureQuizzes: 'Quizzes built into training',
    landingTrainingGenerationFeatureQuizzesDesc: 'Each module can include scored quiz questions so workers prove understanding before they sign off.',
    landingTrainingGenerationFeatureSendNow: 'Send to the group immediately',
    landingTrainingGenerationFeatureSendNowDesc: 'Assign a pack to every linked employee, a single crew, or selected users from the same Company Dashboard workflow.',
    landingTrainingGenerationFeatureTracking: 'Track completion and sign-off',
    landingTrainingGenerationFeatureTrackingDesc: 'Owners can see assigned, in-progress, overdue, failed, and completed training with employee acknowledgements attached.',
    landingPolicyManagementTitle: 'Policy Generation & Management',
    landingPolicyManagementTemplateCount: '{0} policy templates',
    landingPolicyManagementTemplateCountDesc: 'Ready for company policy packs, revisions, and employee sign-off.',
    landingPolicyManagementDesc: 'Generate company policy packages from {0} templates, send authenticated employee sign-offs, manage revisions, and keep signed policies available to workers inside the application.',
    landingPolicyManagementCta: 'Review Business access',
    landingPolicyManagementFeatureGenerate: '{0} policy templates and packs',
    landingPolicyManagementFeatureGenerateDesc: 'Build starter HSE, field operations, fleet/equipment, health/exposure, contractor/process safety, or full safety manual packs without starting from a blank document.',
    landingPolicyManagementFeatureSignoff: 'Authenticated sign-off',
    landingPolicyManagementFeatureSignoffDesc: 'Employees acknowledge policies from their verified account so owners can track who signed, when they signed, and what revision they signed.',
    landingPolicyManagementFeatureAccess: 'Employee policy access',
    landingPolicyManagementFeatureAccessDesc: 'Workers can return later and see the policies they signed inside ZiaWellNav instead of searching old files or messages.',
    landingPolicyManagementFeatureRevisions: 'Push revisions to everyone',
    landingPolicyManagementFeatureRevisionsDesc: 'Change a policy revision once, issue it, and push the updated acknowledgement requirement to all assigned users at the same time.',
    landingCyberClassesTitle: 'Cyber Classes',
    landingCyberClassesDesc: 'Six-hour cyber safety classes for crews, owners, and field workers who need practical protection from scams, account theft, and jobsite device risks.',
    landingCyberClassesPrice: '$95 per attendee · 6-hour class',
    landingCyberClassesCta: 'Buy Cyber Class Seats',
    landingCyberClassFeaturePhishing: 'Phishing and social engineering',
    landingCyberClassFeaturePhishingDesc: 'Spot fake links, impersonation, pressure tactics, and messages that target field crews.',
    landingCyberClassFeaturePassword: 'Password and MFA basics',
    landingCyberClassFeaturePasswordDesc: 'Use stronger passwords, passkeys, and multi-factor authentication without overcomplicating work.',
    landingCyberClassFeatureMobile: 'Mobile phone and Telegram safety',
    landingCyberClassFeatureMobileDesc: 'Protect phones, Telegram accounts, codes, and shared work devices from takeover.',
    landingCyberClassFeatureJobsiteWifi: 'Jobsite Wi-Fi and device safety',
    landingCyberClassFeatureJobsiteWifiDesc: 'Understand public Wi-Fi, hotspots, tablets, laptops, and field-device hygiene.',
    landingCyberClassFeaturePaymentScams: 'Payment and scam red flags',
    landingCyberClassFeaturePaymentScamsDesc: 'Recognize invoice changes, gift card scams, fake vendors, and urgent payment requests.',
    landingCyberClassFeatureReporting: 'Reporting suspicious activity',
    landingCyberClassFeatureReportingDesc: 'Know what to document, who to notify, and how to respond before damage spreads.',
    landingCyberClassModalTitle: 'Buy Cyber Class Seats',
    landingCyberClassModalDesc: 'Enter attendee count and contact details. After payment, ZiaWellNav will follow up to schedule the 6-hour class.',
    landingCyberClassAttendeeCount: 'Attendee count',
    landingCyberClassContactName: 'Contact name',
    landingCyberClassContactEmail: 'Contact email',
    landingCyberClassCompanyName: 'Company name (optional)',
    landingCyberClassNotes: 'Scheduling notes (optional)',
    landingCyberClassModalCta: 'Continue to Stripe',
    landingCyberClassAttendeeError: 'Enter 1-{0} attendees.',
    landingCyberClassContactError: 'Contact name and email are required.',
    landingCyberClassCheckoutTotal: '{0} attendee(s) × $95 = ${1}',
    landingBusinessServicesTitle: 'Business Services',
    landingBusinessServicesDesc: 'Purchase practical support services for technology setup, custom software, drone media, and AI workflow planning.',
    landingBusinessServicesNote: 'Choose a service, enter contact details, and continue to Stripe Checkout.',
    landingBusinessServicesCta: 'Buy / Request Service',
    landingBusinessServicesTechSupportTitle: 'Tech Support',
    landingBusinessServicesTechSupportPrice: '$75/hour',
    landingBusinessServicesTechSupportDesc: 'Networking setup and troubleshooting for Mac/Unix, Windows, Linux, and mixed office devices.',
    landingBusinessServicesSoftwareTitle: 'Custom Software Development',
    landingBusinessServicesSoftwarePrice: '$150/hour',
    landingBusinessServicesSoftwareDesc: 'Build app features, automations, dashboards, integrations, and internal tools for your business.',
    landingBusinessServicesDronePhotosTitle: 'Aerial Drone Photos',
    landingBusinessServicesDronePhotosPrice: '$100 flat',
    landingBusinessServicesDronePhotosDesc: 'Capture aerial photos of the business, yard, shop, or premises for records and promotion.',
    landingBusinessServicesDroneVideoTitle: 'Aerial Drone Video',
    landingBusinessServicesDroneVideoPrice: '$200 flat',
    landingBusinessServicesDroneVideoDesc: 'Capture unedited aerial video of the premises for documentation, marketing, or owner review.',
    landingBusinessServicesAiTitle: 'AI Business Integration',
    landingBusinessServicesAiPrice: '$500 assessment',
    landingBusinessServicesAiDesc: 'Map where AI can help your business with forms, documents, training, support, and workflow automation.',
    landingOfficeValueEyebrow: 'Office value from field data',
    landingOfficeValueTitle: 'Turn field activity into office-ready proof',
    landingOfficeValueDesc: 'ZiaWellNav connects inspections, receipts, JSAs, policies, training, hazards, crew status, GPS evidence, and costs into one company dashboard so managers, safety, finance, HR, and owners can act from current records.',
    landingOfficeValueManagerPitch: 'Managers see what is happening, where crews are, which assets are down, and what needs action before the next dispatch.',
    landingOfficeValueFinancePitch: 'Finance gets cleaner timesheets, receipts, job-cost context, mileage evidence, and invoice support without chasing paper.',
    landingOfficeValueSafetyPitch: 'Safety teams keep JSAs, incident reports, training, policy acknowledgements, photos, and GPS-backed audit trails together.',
    landingOfficeValueOwnerPitch: 'Owners get operations, safety, utilization, costs, and risk signals in one dashboard instead of scattered calls and spreadsheets.',
    landingOfficeValueRoleManager: 'Manager visibility',
    landingOfficeValueRoleFinance: 'Finance and job costs',
    landingOfficeValueRoleSafety: 'Safety and compliance',
    landingOfficeValueRoleHr: 'HR and onboarding',
    landingOfficeValueRoleOwner: 'Owner KPIs',
    landingOfficeValueEquipmentTitle: 'Equipment and vehicle control',
    landingOfficeValueEquipmentDesc: 'Pre/post-trip inspections with photos, out-of-service status, PM patterns, repair evidence, and vehicle cost history.',
    landingOfficeValueCostTitle: 'Expenses and job costing',
    landingOfficeValueCostDesc: 'Capture receipts with GPS and time, tag costs to crew, location, and date, then support reimbursement and invoice disputes.',
    landingOfficeValueSafetyTitle: 'Safety and compliance proof',
    landingOfficeValueSafetyDesc: 'Live hazards, JSAs, incident reports, cert expirations, policy acknowledgements, training sign-offs, and export-ready audit trails.',
    landingOfficeValueCrewTitle: 'Crew scheduling and utilization',
    landingOfficeValueCrewDesc: 'See linked crews, hours, availability, certifications, and current status so scheduling and payroll stop depending on scattered calls.',
    landingOfficeValueFieldIntelTitle: 'Field intelligence and routing',
    landingOfficeValueFieldIntelDesc: 'Search wells and facilities, use maps, weather, hazards, production atlas, and worklists to answer client calls and reduce wrong-route time.',
    landingOfficeValueRiskTitle: 'Risk defense and reporting',
    landingOfficeValueRiskDesc: 'Roll up KPIs, trends, GPS and timestamped proof, photos, signatures, and history for disputes, claims, audits, and owner review.',
    landingFieldIntelEyebrow: 'Field intelligence suite',
    landingFieldIntelTitle: 'Know what is happening around your crews',
    landingFieldIntelDesc: 'ZiaWellNav gives owners and field teams operational intelligence for daily reporting, regulatory incidents, active operations, new wells, production signals, market context, and emissions visibility.',
    landingFieldIntelOfficeTitle: 'Built for dispatch, safety, sales, and owners',
    landingFieldIntelOfficeDesc: 'Use field intelligence to brief crews before dispatch, watch nearby risk, spot new activity, track market conditions, and turn daily field observations into searchable company history.',
    landingFieldIntelChipOps: 'Operations signals',
    landingFieldIntelChipRegulatory: 'Regulatory awareness',
    landingFieldIntelChipWells: 'New wells and facilities',
    landingFieldIntelChipMarket: 'Market and emissions',
    landingFieldIntelDailyReportTitle: 'Daily Field Report',
    landingFieldIntelDailyReportDesc: 'Capture what happened today with crew, location, work performed, notes, photos, and job context so the office has a reliable daily record.',
    landingFieldIntelOcdIncidentsTitle: 'OCD incidents nearby',
    landingFieldIntelOcdIncidentsDesc: 'Surface minor, medium, and major OCD incident reports near the job area so JSAs and safety planning start with nearby historical risk.',
    landingFieldIntelActiveOperationsTitle: 'Active Operations',
    landingFieldIntelActiveOperationsDesc: 'Track active work signals and operational activity around the basin so dispatch, sales, and management know where field movement is happening.',
    landingFieldIntelNewWellsDigestTitle: 'New Wells Digest',
    landingFieldIntelNewWellsDigestDesc: 'Review newly surfaced well activity in digest form so teams can spot opportunities, customer movement, and new areas of interest.',
    landingFieldIntelNewWellsNmTitle: 'New Wells NM',
    landingFieldIntelNewWellsNmDesc: 'Focus on New Mexico well activity with location-aware records and links back to the map and well details.',
    landingFieldIntelMarketPulseTitle: 'Market Pulse',
    landingFieldIntelMarketPulseDesc: 'Combine production-atlas context, operator views, commodity signals, and pricing notes so business decisions have current market background.',
    landingFieldIntelEmissionsTitle: 'Emissions Leaderboard',
    landingFieldIntelEmissionsDesc: 'Compare emissions signals and leaderboard views so owners can see operational exposure, trends, and areas that need review.',
    landingBuiltInAiEyebrow: 'Built into the app',
    landingBuiltInAiTitle: 'AI Knowledge Assistant',
    landingBuiltInAiProviderChip: 'Llama, Qwen, Gemma, GPT-OSS, Grok, ChatGPT, Mistral, DeepSeek',
    landingBuiltInAiRecordsChip: 'Company-aware answers with source citations',
    landingBuiltInAiDesc: 'ZiaWellNav includes AI tools for field troubleshooting, voice-note cleanup, JSA and report summaries, hazard wording, and records-aware answers from indexed forms, policies, training, timesheets, safety, and fleet history.',
    landingBuiltInAiPrivacyNote: 'Private company knowledge is filtered by verified Telegram identity: owners can query company records, while workers only see their own or assigned records.',
    landingBuiltInAiFeatureProviders: 'Multiple AI providers',
    landingBuiltInAiFeatureProvidersDesc: 'Choose hosted Cloudflare models like Llama, Qwen, Gemma, and GPT-OSS, or use configured providers such as Grok, ChatGPT, Mistral, DeepSeek, Cocoon, and Ollama.',
    landingBuiltInAiFeatureKnowledge: 'Answers from company records',
    landingBuiltInAiFeatureKnowledgeDesc: 'Ask questions against indexed ZiaWellNav forms, policy templates, training packs, submitted records, timesheets, safety records, and fleet history with citations.',
    landingBuiltInAiFeatureFieldWork: 'Field-ready drafting',
    landingBuiltInAiFeatureFieldWorkDesc: 'Clean up voice notes, summarize JSAs and reports, draft troubleshooting guidance, and turn hazard notes into clear driver-readable copy.',
    landingBuiltInAiFeatureCompanySafe: 'Company-safe access',
    landingBuiltInAiFeatureCompanySafeDesc: 'Signed Telegram auth and server-side permission checks keep private records scoped to owners, assigned workers, and verified company access.',
    landingBotIntegrationEyebrow: 'Custom bot implementation',
    landingBotIntegrationTitle: 'Company Bot Integration',
    landingBotIntegrationPrice: '$1,000 one-time bot integration fee',
    landingBotIntegrationPrivacyChip: 'Privacy is included with company records',
    landingBotIntegrationDesc: 'Custom bot integration adds a branded company Telegram bot, dedicated menus, and private workflow routing so crews, shop, safety, training, dispatch, and owners can communicate through the same ZiaWellNav workflow instead of scattered texts and screenshots.',
    landingBotIntegrationFeeNote: 'The setup fee covers bot creation, menus, routing setup, testing, and handoff. It is optional: private company records, Forms history, and saved dashboards do not require a custom bot.',
    landingBotIntegrationCta: 'Review setup in pricing',
    landingBotIntegrationCompanyBotTitle: 'Company Command Bot',
    landingBotIntegrationCompanyBotDesc: 'A company-branded Telegram bot with menu links for ZiaWellNav, forms, policies, training, fleet, support, and company workspace access.',
    landingBotIntegrationFleetBotTitle: 'Fleet / Shop Routing Bot',
    landingBotIntegrationFleetBotDesc: 'Routes shop requests, PM alerts, repair evidence, closeout updates, and failed routing notices to the right shop contacts.',
    landingBotIntegrationSafetyBotTitle: 'Safety + Training Bot',
    landingBotIntegrationSafetyBotDesc: 'Sends JSA reminders, incident follow-up, training/onboarding assignments, cert prompts, and safety alerts to the workers who need action.',
    landingBotIntegrationAdminBotTitle: 'Owner/Admin Alerts',
    landingBotIntegrationAdminBotDesc: 'Keeps owners and managers informed about approvals, exceptions, exports, and daily work signals without digging through every chat.',
    landingBotIntegrationCommunicationTitle: 'How this improves company communication',
    landingBotIntegrationCommunicationPointRouting: 'Routes messages by workflow so the shop, safety lead, dispatcher, and owner each see the right update.',
    landingBotIntegrationCommunicationPointMissedCalls: 'Reduces missed calls, repeated screenshots, and manual forwarding between crews and office staff.',
    landingBotIntegrationCommunicationPointRecords: 'Keeps communication tied back to ZiaWellNav records, forms, evidence, and company dashboard history.',
    landingBusinessServiceModalTitle: 'Buy / Request Business Service',
    landingBusinessServiceModalDesc: 'Enter contact details and service quantity. After payment, ZiaWellNav will follow up to schedule the work.',
    landingBusinessServiceHourQuantity: 'Hours',
    landingBusinessServiceFixedQuantity: 'Quantity fixed at 1 package',
    landingBusinessServiceContactName: 'Contact name',
    landingBusinessServiceContactEmail: 'Contact email',
    landingBusinessServiceCompanyName: 'Company name (optional)',
    landingBusinessServicePhone: 'Phone (optional)',
    landingBusinessServiceNotes: 'Service notes (optional)',
    landingBusinessServiceModalCta: 'Continue to Stripe',
    landingBusinessServiceSelectionError: 'Select a business service.',
    landingBusinessServiceQuantityError: 'Enter 1-{0} hours.',
    landingBusinessServiceContactError: 'Contact name and email are required.',
    landingBusinessServiceCheckoutTotal: '{0} × {1} = ${2}',
    landingClosePricing: 'Close pricing',
    landingSmsFieldUpdatesChip: 'SMS field updates',
    landingSmsOptInOnlyChip: 'Opt-in only',
    landingSmsTitle: 'Get ZiaWellNav field updates by text',
    landingSmsDesc: 'Permian oilfield updates, app demos, and ZiaWellNav rollout news. We only text verified opt-ins. Reply STOP to opt out.',
    landingSmsVerified: 'Your phone number is verified for ZiaWellNav SMS updates.',
    landingSmsPending: 'Enter the verification code sent to your phone to finish SMS opt-in.',
    landingSmsTestCode: 'Test code: {0}',
    landingSmsMobilePhone: 'Mobile phone',
    landingSmsVerificationCode: 'Verification code',
    landingSmsConsent: 'I agree to receive ZiaWellNav marketing text messages. Message and data rates may apply. Reply STOP to opt out.',
    landingSmsConsentRequired: 'SMS consent is required before opt-in.',
    landingSmsOptInFailed: 'SMS opt-in failed. Please try again.',
    landingSmsVerificationFailed: 'SMS verification failed. Please try again.',
    landingSmsInvalidPhone: 'Enter a valid US mobile phone number.',
    landingSmsInvalidCode: 'Enter the verification code sent to your phone.',
    landingSmsExpiredCode: 'That verification code expired. Request a new code.',
    landingSmsUnauthorized: 'SMS opt-in is temporarily unavailable. Please try again later.',
    landingSmsSubmitting: 'Submitting...',
    landingSmsVerifyPhone: 'Verify phone',
    landingSmsRequestUpdates: 'Request text updates',
    landingFleetManagementTitle: 'Fleet Management',
    landingFleetManagementDesc: 'Track equipment, shop requests, preventive maintenance, repair evidence, costs, downtime, and asset history from one company dashboard.',
    landingFleetManagementCta: 'Open Fleet Management tab',
    landingFleetManagementFeatureAssets: 'Fleet assets',
    landingFleetManagementFeatureAssetsDesc: 'Track trucks, trailers, equipment, ownership details, and asset history from one place.',
    landingFleetManagementFeatureRequests: 'Shop requests',
    landingFleetManagementFeatureRequestsDesc: 'Route repair needs to the shop with status, notes, routing, and notification history.',
    landingFleetManagementFeaturePm: 'PM schedules',
    landingFleetManagementFeaturePmDesc: 'Surface preventive maintenance windows before equipment issues become field downtime.',
    landingFleetManagementFeatureEvidence: 'Evidence photos/files',
    landingFleetManagementFeatureEvidenceDesc: 'Attach photos and files to document repair condition, work completed, and closeout proof.',
    landingFleetManagementFeatureCosts: 'Cost tracking',
    landingFleetManagementFeatureCostsDesc: 'Capture repair costs, downtime, and maintenance signals for owner review.',
    landingFleetManagementFeatureExport: 'Asset history export',
    landingFleetManagementFeatureExportDesc: 'Export fleet records and asset history when customers, owners, or auditors need proof.',
    landingOilfieldFormsCategoryElectrical: 'Electrical Forms',
    landingOilfieldFormsCategoryElectricalSafetyAudits: 'Electrical Safety Audits',
    landingOilfieldFormsCategoryOccidental: 'Occidental Forms',
    landingOilfieldFormsCategoryIncidentNearMiss: 'Incident / Near Miss',
    landingOilfieldFormsCategoryEquipmentInspections: 'Equipment Inspections',
    landingOilfieldFormsCategorySafetyPrograms: 'Safety Programs',
    landingOilfieldFormsCategoryDailyFieldReports: 'Daily Field Reports',
    landingOilfieldFormsCategoryCrewSignOff: 'Crew Sign-Off',
    landingOilfieldFormsCategoryWorkAtHeights: 'Work at Heights',
    landingOilfieldFormEnergizedElectricalWorkPermitBenefit: 'Controls energized work approvals and crew communication.',
    landingOilfieldFormArcFlashShockPpeChecklistBenefit: 'Verifies arc PPE before exposure starts.',
    landingOilfieldFormHotCrossingPhaseHolderBenefit: 'Aligns live-line hazards, tools, and signals.',
    landingOilfieldFormFallProtectionInspectionBenefit: 'Documents harness, lanyard, and SRL readiness.',
    landingOilfieldFormAutoCraneInspectionBenefit: 'Confirms crane controls and lift safeguards.',
    landingOilfieldFormGeneralEquipmentInspectionBenefit: 'Catches defects before equipment reaches location.',
    landingOilfieldFormPumpHosePreOpBenefit: 'Checks pressure gear before pumping work.',
    landingOilfieldFormMaintenanceRequestBenefit: 'Routes repair needs before failures spread.',
    landingOilfieldFormNearMissReportBenefit: 'Turns close calls into corrective action.',
    landingOilfieldFormFirstReportIncidentBenefit: 'Captures incident facts for fast notification.',
    landingOilfieldFormIncidentWitnessStatementBenefit: 'Preserves witness details while memory is fresh.',
    landingOilfieldFormFullIncidentInvestigationBenefit: 'Tracks causes, witnesses, actions, and signoff.',
    landingOilfieldFormFallRescuePlanBenefit: 'Coordinates rescue contacts, access, and timing.',
    landingOilfieldFormFallDistanceClearanceBenefit: 'Verifies clearance before tying off.',
    landingOilfieldFormSuspensionTraumaBenefit: 'Stages rescue equipment and communication readiness.',
    landingOilfieldFormBehaviorBasedSafetyBenefit: 'Captures safe and at-risk behaviors before they become incidents.',
    landingOilfieldFormOnSiteExcavationBenefit: 'Confirms one-call, line locate, and excavation controls.',
    landingOilfieldFormCriticalTaskHotWorkBenefit: 'Checks high-risk hot work and electrical task controls.',
    landingOilfieldFormStopWorkAuthorityBenefit: 'Documents stop-work reasons, corrections, and restart approval.',
    landingOilfieldFormAerialLiftSafetyBenefit: 'Checks lift controls, clearance, and fall protection.',
    landingOilfieldFormHotWorkPermitBenefit: 'Controls sparks, fire watch, PPE, and approval.',
    landingOilfieldFormCraneSignalingBenefit: 'Aligns signalers, communication, visibility, and stop rules.',
    landingOilfieldFormVacuumTruckOperationsBenefit: 'Checks vapors, monitoring, equipment, and emergency readiness.',
    landingOilfieldFormOverheadLinesBenefit: 'Verifies structure support, clearance, and electrical PPE.',
    landingOilfieldFormMedicalRecordsAccessBenefit: 'Tracks exposure record access and privacy authorization.',
    landingOilfieldFormSilicaExposureChecklistBenefit: 'Confirms dust controls, respirators, and training.',
    landingOilfieldFormSilicaPlanReviewBenefit: 'Reviews ECP controls, sampling, and records.',
    landingOilfieldFormAmmoniaAwarenessBenefit: 'Reviews ammonia hazards, PPE, and emergency readiness.',
    landingOilfieldFormPoleTransportSafetyBenefit: 'Checks pole overhang, flags, lighting, and securement.',
    landingOilfieldFormDailyFieldReportBenefit: 'Keeps daily work and hazards visible.',
    landingOilfieldFormCrewSignOffBenefit: 'Records shared understanding with crew signatures.',
    allStates: 'All States',
    checkoutSubscriptionActivated: 'Subscription Activated',
    checkoutTrialStarted: 'Your 7-day free trial has started.',
    checkoutSignInUsing: 'Sign in to ZiaWellNav using:',
    checkoutEmailFallback: 'the email you entered at checkout',
    checkoutStepOpenApp: 'Step 2 - Open the App',
    checkoutOpenTelegram: 'Open ZiaWellNav in Telegram',
    checkoutNewToTelegram: 'New to Telegram?',
    checkoutTelegramInstallHelp: 'Telegram is a free, secure messaging app. ZiaWellNav runs inside it - install Telegram first:',
    checkoutOrLoginBrowser: 'Or Login via Browser',
    checkoutOpenTelegramAfterLogin: 'Then tap "Open ZiaWellNav in Telegram" above',
    arLiveViewTitle: 'AR Live View',
    arLiveViewPlatform: '(iOS)',
    arLiveViewDesc: 'Point your camera and see nearby oil and gas wells overlaid in the field view. Tap a well label to get distance, API number, and type with a 1 to 5 mile adjustable radius.',
    arLiveViewSubtext: 'Find wells with your camera, not just the map.',
    advancedJsaTitle: 'JSA',
    advancedJsaDesc: 'Create a full Job Safety Analysis directly from the main FAB. Add steps, hazards, PPE, emergency contacts, and a muster point, then share to the crew via Telegram and reopen for signing later.',
    advancedJsaSubtext: 'Keep crews in sync with one tap from the main canvas.',
    prePostTripTitle: 'Pre & Post Trip Inspections',
    prePostTripDesc: 'Vehicle checklists with photos, GPS, and time-stamped records. Unlock post-trip after pre-trip and share reports instantly via Telegram.',
    prePostTripSubtext: 'Keep rigs compliant - one active inspection at a time.',
    apiNumberSearchTitle: 'API Number Search',
    apiNumberSearchDesc: 'Jump straight to a well by API. Quick search from the map FAB, with auto-formatting and state detection for NM and TX.',
    apiNumberSearchSubtext: 'Built-in validation to reduce fat-finger errors.',
    safetyGuyReportingTitle: 'Safety Guy Reporting',
    safetyGuyReportingDesc: 'Fast hazard and near-miss reporting with photos, GPS, and Telegram alerts. Push to crews and the logbook quickly.',
    safetyGuyReportingSubtext: 'Keep safety leads in the loop as reports arrive.',
    pavelDurovSagaTitle: 'The Pavel Durov Saga',
    pavelDurovSagaDesc: 'The man who built Telegram, and what it cost him.',
    pavelDurovFounder: 'Founder of Telegram - 1B+ monthly users',
    pavelDurovTelegramLink: '@durov on Telegram',
    pavelReadMore: 'Read more',
    pavelLexFridmanLink: 'Lex Fridman interview',
    pavelPaperAirplaneTitle: 'The Paper Airplane Stunt',
    pavelPaperAirplaneBody: 'Durov folded 5,000-ruble notes, about $155 each, into paper airplanes and threw them from the VK office window in St. Petersburg. Fights broke out below as people scrambled. That paper plane later became Telegram\'s iconic logo.',
    pavelEscapedRussiaTitle: 'Escaped Russia',
    pavelEscapedRussiaBody: 'The FSB demanded he hand over user data on Ukrainian protesters. Durov refused, was forced to sell VK to Kremlin-linked owners at a lowball price, then left Russia for good.',
    pavelPoisonedTitle: 'Poisoned - Almost Died',
    pavelPoisonedBody: 'Hours after refusing Russia\'s FSB demand for Telegram encryption keys, Durov collapsed with acute pain, loss of vision and hearing, burst blood vessels, and could not stand. He later described the episode publicly in a Lex Fridman interview.',
    pavelArrestedTitle: 'Arrested in France',
    pavelArrestedBody: 'French authorities detained him at Le Bourget airport over Telegram moderation policies. He was held for 96 hours and released on bail, while critics worldwide called it an attack on free speech.',
    pavelBuiltMachineTitle: 'Built Like a Machine',
    pavelBuiltMachineBody: 'Every morning: push-ups, squats, cold water, long swims, strict diet, and fasting windows. His point is discipline over short-term comfort.',
    telegramBrowserTitle: 'Telegram Mini App vs Chrome Free Demo',
    telegramBrowserDesc: 'Chrome is a free demo for public field navigation. Telegram is the signed app experience for company records, bot notifications, and paid/private workflows.',
    telegramSupportPercentChip: 'Telegram Mini App: {0}% platform support',
    browserDemoPercentChip: 'Chrome Free Demo: {0}% preview support',
    supportMatrixBasisChip: '10 feature groups: {0} demo + {1} Telegram-only',
    telegramMiniFullAccessTitle: 'Telegram Mini App - 100% platform support',
    browserLimitedAccessTitle: 'Chrome Free Demo Mode - 50% preview',
    telegramFullFeatureInspections: 'Pre/Post Trip Inspections',
    telegramFullFeatureJsa: 'Job Safety Analysis (JSA) + auto sign-off',
    telegramFullFeatureCrew: 'Crew management & invite links',
    telegramFullFeatureMarchingOrders: 'Marching Orders & work timer',
    telegramFullFeatureReceipts: 'Receipts, Cert Vault & OCR',
    telegramFullFeatureTracking: 'Vehicle tracking & friends',
    telegramFullFeatureNotifications: 'All notifications & push alerts',
    telegramFullFeatureSearch: 'Well search, navigation & maps',
    telegramFullFeatureWeather: 'Weather, air quality & hazards',
    telegramFullFeatureMarketplace: 'AI assistant, bidding & marketplace',
    browserFeatureSearch: 'Public well & facility search',
    browserFeatureNavigation: 'Google Maps navigation handoff',
    browserFeatureWeather: 'Hazards, weather & field intelligence',
    browserFeatureHazards: 'Hazard viewing/reporting',
    browserFeatureRoutes: 'Favorites, worklists & route preview',
    browserFeatureInspections: 'Signed forms, inspections, JSA & timesheets',
    browserFeatureCrew: 'Company dashboard, crews, meetings & bot alerts',
    browserFeatureCerts: 'Cert Vault, receipts & synced private records',
    browserFeatureTracking: 'Fleet, policies, training & live worker workflows',
    browserFeatureMarketplace: 'AI/RAG company knowledge, bidding & subscriptions',
    browserLockedFeaturesNote: 'This feature requires signed Telegram Mini App access, not Chrome Demo Mode. Open ZiaWellNav inside Telegram for 100% support.',
    telegramRequiredTitle: 'Open in Telegram for this feature',
    telegramRequiredMessage: 'This feature works in ZiaWellNav, but it requires the full Telegram Mini App signed session. Open @vamosar_race_bot and try again.',
    telegramRequiredChromeDemoContext: 'Chrome Demo previews public navigation; Telegram unlocks company records, forms, AI, timesheets, fleet, policies, training, meetings, and bot notifications.',
    telegramRequiredOpenAction: 'Open in Telegram',
    gpsUnsupportedTitle: 'Open Telegram for phone GPS',
    gpsUnsupportedMessage: 'GPS works in the full Telegram Mini App. Chrome Demo may not provide phone GPS here. Open @vamosar_race_bot on your phone for GPS navigation.',
    gpsUnsupportedChromeDemoContext: 'Chrome Demo can preview public navigation, but phone GPS is most reliable inside the Telegram Mini App.',
    gpsUnsupportedOpenAction: 'Open in Telegram',
    supportedDeviceIphone: 'iPhone',
    supportedDeviceIpad: 'iPad',
    supportedDeviceAndroid: 'Android',
    supportedDeviceMacosApp: 'macOS App',
    supportedDeviceWindowsApp: 'Windows App',
    supportedDeviceChromeosApp: 'ChromeOS App',
    supportedDeviceChromeBrowser: 'Chrome Browser',
    supportedDeviceSafariBrowser: 'Safari Browser',
    
    // Landing Page - Feature Cards
    comingSoon: 'Coming Soon',
    premium: 'Premium',
    exclusive: 'Exclusive',
    voiceNavigationTitle: 'Voice Navigation',
    voiceNavigationDesc: 'Hands-free well search and route help while your hands stay on the wheel',
    voiceNavigationSubtext: 'Speak the well, API, operator, or location',
    landingFieldFormsTitle: 'Important Field Forms',
    landingFieldFormsDesc: 'Complete JSAs, inspections, incident reports, permits, and crew sign-offs in one place.',
    landingFieldFormsSubtext: 'Critical safety forms crews actually use in the field.',
    telegramChannelsTitle: 'Telegram Channels',
    telegramChannelsDesc: 'Private channels, secure messaging & video streaming',
    telegramChannelsSubtext: 'All integrated into Telegram',
    facilityTypesTitle: '62 Facility Types',
    facilityTypesDesc: 'Wells, tanks, compressors, pipelines, SWDs & more',
    facilityTypesSubtext: 'Most well navigators only cover basic wells',
    dragDropLandmarksTitle: 'Drag & Drop Landmarks',
    dragDropLandmarksDesc: 'Drop pins on cattle guards, windmills, and turns. Chart routes through unmarked territory and find your way out when you\'re deep in unfamiliar country.',
    amigosTitle: 'Amigos',
    amigosDesc: 'Coming Soon - Share your location with friends and see each other in real-time on the map.',
    offlineMapsTitle: 'Offline Maps',
    offlineMapsDesc: 'Download entire basins for offline access. No cell signal? No problem.',
    weatherAlertsTitle: 'Weather & Hazards',
    weatherAlertsDesc: 'Real-time weather data and road hazard warnings to keep you safe.',
    crewTrackingTitle: 'Crew Tracking',
    crewTrackingDesc: 'See your crew locations in real-time. Coordinate better, work safer.',
    basinCommunitiesTitle: 'Basin Communities',
    basinCommunitiesDesc: 'Connect with operators in your basin. Share intel, find crews, post jobs.',
    oilfieldMappingTitle: 'Oilfield Mapping',
    oilfieldMappingDesc: '1.4M+ wells and facilities across NM & TX, updated regularly. Find locations earlier than many public maps.',
    oilfieldMappingSubtext: 'Track activity trends as data updates.',
    calicheRoutesTitle: 'Caliche Routes',
    calicheRoutesDesc: 'Navigate roads Google doesn\'t know. Plot routes through unmarked oilfield roads, mark landmarks, and share with your crew.',
    calicheRoutesSubtext: 'Never get lost heading back to the house—even in unfamiliar territory.',
    routePhotosTitle: 'Route Photos',
    routePhotosDesc: 'Snap and share last-mile route photos to facilities. One upload and the whole crew sees it in the app.',
    drawRouteFingerTitle: 'Draw Route with Finger',
    drawRouteFingerDesc: 'Trace a custom path with your finger; it snaps to roads and saves for turn-by-turn navigation.',
    amenitiesTitle: 'Amenities',
    amenitiesDesc: 'Find and share bathrooms, taco trucks, fuel, water, and more—crowd-sourced and easy to filter.',
    mapLayersTitle: 'Map Layers',
    mapLayersDesc: 'Toggle terrain, satellite, night, cyber, roads-only, and topo layers for the exact view you need.',
    ufoRadarTapMoveTitle: 'UFO Radar (Tap & Move)',
    ufoRadarTapMoveDesc: 'Tap anywhere on the map to drop the UFO radar instantly, then tap again to reposition it as you scout facilities.',
    ufoRadarTapMoveSubtext: 'Fast placement + drag-to-adjust control in the field.',
    heavyHaulDirectoryTitle: 'Heavy Haul Directory',
    heavyHaulDirectoryDesc: 'Find heavy haul operators, truck services, and equipment rentals in your area.',
    jobsBoardTitle: 'Jobs Board',
    jobsBoardDesc: 'Post jobs, find work, bid on contracts. Connect directly with operators and contractors.',
    hazardsAlertsTitle: 'Road Hazard Alerts',
    hazardsAlertsDesc: 'Report road hazards, near misses, weather trouble, and field incidents so nearby crews can react faster.',
    landingHazardSubtext: 'Built around safer decisions before and during the drive.',
    dotAlertsTitle: 'Report DOT Officers',
    dotAlertsDesc: 'Drop DOT checkpoint pins to warn nearby crews in real time.',
    certVaultTitle: 'Certs & Licenses',
    certVaultDesc: 'Capture front/back of training cards, licenses, and certs. Stored locally on this device; sync to cloud (Telegram auth) to access on other devices.',
    aiAssistantTitle: 'AI Copilot (Grok)',
    aiAssistantDesc: 'Your personal AI that builds a memory of your routes, frequent stops, and work patterns. The more you drive, the smarter it gets.',
    aiAssistantSubtext: '🧠 Learns your daily grind—constantly improving',
    privacyFirstTitle: 'Privacy-First Design',
    privacyFirstDesc: 'No account needed. API keys hidden server-side. Your location never stored. Anonymous hazard reports.',
    privacyFirstSubtext: 'E2E encryption via Telegram • No tracking • No ads 🔒',
    weatherDataTitle: 'Weather Data',
    weatherDataDesc: 'Powered by Google. Rain, UV, wind, temperature with automatic failover.',
    weatherDataSubtext: 'Flash flood alerts for arroyo safety 🌊',
    nwsWeatherAlertsTitle: 'NWS Weather Alerts',
    nwsWeatherAlertsDesc: 'Live National Weather Service alerts shown across the app and pushed through vamosar_race_bot.',
    nwsWeatherAlertsSubtext: 'Weather risk stays visible while crews work.',
    dataTrustReportTitle: 'Data Trust Report',
    dataTrustReportDesc: 'See whether oilfield data is live, imported on a schedule, compiled from public reports, stale, missing, or estimated.',
    dataTrustReportSubtext: 'Know what the app knows, and where it came from.',
    productionAtlasMarketPulseTitle: 'Production Atlas / Market Pulse',
    productionAtlasMarketPulseDesc: 'Production summaries, commodity pricing context, operator views, and estimate disclaimers.',
    productionAtlasMarketPulseSubtext: 'Oilfield intelligence with clear limits.',
    sosEmergencyCheckInTitle: 'SOS / Emergency Check-In',
    sosEmergencyCheckInDesc: 'Drop an emergency hazard, let responders view, navigate, or use AR toward you, then clear it when safe.',
    sosEmergencyCheckInSubtext: 'Built for fast field response.',
    fullRadWideScanGlobeTitle: 'Full RAD / Wide Scan / 3D Globe',
    fullRadWideScanGlobeDesc: 'Wide-radius facility scan, radar/list mode, and 3D oilfield context for planning before arrival.',
    fullRadWideScanGlobeSubtext: 'See more than the road in front of you.',
    workerProfilesPrivacyTitle: 'Worker Profiles + Privacy Controls',
    workerProfilesPrivacyDesc: 'Public profile cards with role icons, optional business, website, and phone, while Telegram stays hidden unless allowed.',
    workerProfilesPrivacySubtext: 'A field business card with privacy first.',
    englishSpanishTitle: 'English & Spanish',
    englishSpanishDesc: 'Full app support in both languages. Serving the diverse oilfield workforce.',
    englishSpanishSubtext: 'More languages on the way',
    crewsTimesheetsTitle: 'My Crews',
    crewsTimesheetsDesc: 'QR code invites, live GPS tracking, meeting points with check-ins, and weekly timesheets auto-sent to your lead.',
    crewsTimesheetsSubtext: 'BYOD-friendly • Privacy-first location sharing',
    quadNavigationTitle: 'Google Maps Navigation',
    quadNavigationDesc: 'Full waypoint support for caliche routes. Navigate through unmapped dirt roads with GPS coordinates.',
    quadNavigationSubtext: 'The only app with multi-waypoint support',
    landingApiRegistryEyebrow: 'API Registry',
    landingApiRegistryTitle: 'ZiaWellNav API Network',
    landingApiRegistryDesc: 'A public-safe view of the connected services, advanced data sources, and internal Cloudflare routes powering ZiaWellNav.',
    landingApiRegistryTotalLabel: 'API Registry Entries',
    landingApiRegistryActiveExternalLabel: '{0} Active External APIs',
    landingApiRegistryAdvancedLabel: '{0} Advanced Data APIs',
    landingApiRegistryInternalLabel: '~{0} Internal App Routes',
    landingApiRegistryRouteGroupsLabel: '{0} Cloudflare Route Groups',
    landingSmartJsaTitle: 'Smart JSAs',
    landingSmartJsaSubtitle: 'Job Safety Analysis that works with your team, not against them',
    landingSmartJsaCrewNotificationsTitle: 'Crew Notifications',
    landingSmartJsaCrewNotificationsDesc: 'When anyone on your crew pulls a location with the same application, they’re instantly notified that your team has an active JSA they need to sign',
    landingSmartJsaIncidentAwarenessTitle: 'OCD Incident Awareness',
    landingSmartJsaIncidentAwarenessDesc: 'Every time a user starts to add a JSA, OCD incident reports within 1 mile are shown automatically, including minor, medium, and major incidents submitted to OCD',
    landingSmartJsaAutoExpirationTitle: 'Auto-Expiration',
    landingSmartJsaAutoExpirationDesc: 'Once 3 people sign the JSA, it stays active as long as anyone who signed it is on-site. Expires automatically when the last signer leaves',
    landingSmartJsaSafetyTrackingTitle: 'Safety Officer Tracking',
    landingSmartJsaSafetyTrackingDesc: 'Your safety officer can track all JSAs, crew compliance, and signatures inside the Safety panel',
    landingSmartTimesheetsTitle: 'Smart Timesheets',
    landingSmartTimesheetsSubtitle: 'Payroll and compliance that work automatically, not manually',
    landingSmartTimesheetsDailySubmitTitle: 'Automatic Daily Submission',
    landingSmartTimesheetsDailySubmitDesc: 'Time entries are automatically submitted to your company dashboard daily — no manual exports or file transfers needed',
    landingSmartTimesheetsRealtimeTitle: 'Real-Time Dashboard',
    landingSmartTimesheetsRealtimeDesc: 'Your company sees hours and miles in real time. Track crew productivity and billing instantly from anywhere',
    landingSmartTimesheetsCrewVisibilityTitle: 'Crew-Wide Visibility',
    landingSmartTimesheetsCrewVisibilityDesc: 'See all crew hours at a glance. Track who worked where, when, and how long — built for job costing and crew management',
    landingSmartTimesheetsAuditTitle: 'Compliance & Audit Ready',
    landingSmartTimesheetsAuditDesc: 'Timestamps and GPS coordinates create an audit trail. Everything is documented and ready for compliance or dispute resolution',
    googleApisTitle: 'Google APIs',
    googleApisDesc: '22 Google APIs integrated now: places, routes, weather, elevation, tiles, and more.',
    googleApisSubtext: 'Constantly expanding capabilities',
    semiHazmatTitle: 'Semi & Hazmat Routing',
    semiHazmatDesc: 'Routing optimized for semis and hazmat loads. Avoids low bridges, weight limits & restricted roads.',
    semiHazmatSubtext: 'Built for professional drivers',
    cyberThemeTitle: 'Cyber Theme',
    cyberThemeDesc: 'Sleek dark mode with glowing neon accents for night shifts. High contrast mode for bright daylight conditions.',
    cyberThemeSubtext: 'Easy on the eyes, 24/7',
    materialDesignTitle: 'Material Design 3',
    materialDesignDesc: 'Built on Google\'s latest Material Design 3 philosophy. Premium UI with dynamic colors, elevation, and motion.',
    materialDesignSubtext: 'Same design language as Google apps',
    cloudflareTitle: 'Cloudflare Protected',
    cloudflareDesc: 'Enterprise-grade security with global edge network. DDoS protection, SSL, and blazing fast load times from 300+ data centers.',
    cloudflareSubtext: 'D1 database + Workers = instant responses ⚡',
    realTimeDataTitle: 'Real-Time Data',
    realTimeDataDesc: 'Regularly updated facility information from multiple sources',
    realTimeDataSubtext: 'Updates arrive as sources publish',
    offlineTitle: 'Download for Offline',
    offlineDesc: 'Access maps and data in the desert, mountains, or anywhere without signal. Offline downloads work best in Google Chrome; Telegram availability depends on device storage and connection limits—use the Chrome download for best results.',
    offlineSubtext: 'Download all 1.4 million wells for offline search—977K TX + 424K NM.',
    basinSafetyTitle: 'Basin Safety Channels',
    basinSafetyDesc: 'Receive alerts for wrecks, traffic, and field incidents where available',
    basinSafetySubtext: 'Coverage varies by basin',
    readyToStartTitle: 'Ready to Get Started?',
    readyToStartDesc: 'Log in with Telegram for real-time facility data, voice navigation, and basin safety channels. Messaging runs through Telegram with end-to-end encryption.',
    compatibilityTitle: 'Compatibility & Telegram Benefits',
    supportedDevicesTitle: 'Supported Devices',
    supportedDevicesDesc: 'iPhone, iPad, Android, and Telegram Desktop app for macOS, Windows, and ChromeOS. Also works great on Chrome and Safari browsers.',
    telegramBenefitsTitle: 'Why Telegram Mini App',
    telegramBenefitsDesc: 'Instant login, end‑to‑end encrypted messaging, and faster updates for crews in the field.',
    telegramBenefitInstant: 'Instant login — no passwords, just your Telegram account',
    telegramBenefitEncrypted: 'End-to-end encrypted messaging for all crew comms',
    telegramBenefitUpdates: 'Faster push updates for crews in the field',
    freeTrialHeading: '🎁 7-Day Free Trial',
    forFieldProfessionals: 'For Field Professionals',
    individualPrice: '$10',
    individualSubheading: 'Field-user tools for navigation, forms, JSA, timers, timesheets, certs, AI, and alerts',
    individualAccessNote: 'Individual plans do not include Company Dashboard. Choose Business for company crew management, policies, training, fleet, safety, and records.',
    individualFeature1: '✓ 1.4 Million Wells & Facilities (NM + TX)',
    individualFeature2: '✓ Voice Navigation & Turn-by-Turn Directions',
    individualFeature3: '✓ Pre/Post Trip Vehicle Inspections',
    individualFeature4: '✓ Job Safety Analysis (JSA) with Crew Sign-Off',
    individualFeature5: '✓ Personal Crew Tools & Marching Orders',
    individualFeature6: '✓ Work Timer & Timesheets',
    individualFeature7: '✓ AI Assistant (Grok)',
    individualFeature8: '✓ Road Hazard Reporting & Alerts',
    individualFeature9: '✓ Weather, Air Quality & Pollen Data',
    individualFeature10: '✓ Cert & License Vault',
    individualFeature11: '✓ Expense Receipts & Photo Ticket OCR',
    individualFeature12: '✓ Community Routes, Poop Pins & Taco Trucks',
    individualFeature13: '✓ Offline Maps & Background Sync (PWA)',
    individualFeature14: '✓ English & Spanish',
    individualFeature15: '✓ Jobs Board & Services Marketplace',
    individualFeature16: '✓ Google Maps Navigation Handoff',
    businessPlansHeading: 'Business Plans',
    starterLabel: 'STARTER',
    starterPrice: '$7',
    perUserMonth: '/user/mo',
    starterRange: '5-25 users',
    teamLabel: 'TEAM',
    teamPrice: '$6',
    teamRange: '26-100 users',
    fleetLabel: 'FLEET',
    fleetPrice: '$5',
    fleetRange: '101-250 users',
    enterpriseLabel: 'ENTERPRISE',
    enterprisePrice: '$4',
    enterpriseRange: '251+ users',
    founding50Heading: '🏆 Founding 50 Program',
    founding50Desc: 'Any oilfield service company in Lea County (Hobbs, Lovington, Eunice, Tatum, etc.) • First 50 companies',
    founding50Price: '$4/user/mo locked for 3 years (annual prepay)',
    founding50Spots: 'spots remaining',
    founding50Locked: 'Rate locked for 3 years • Up to 250 seats at founding rate',
    // Pricing card feature lists (emoji prefix, used in PricingSection.tsx)
    pricingIndFeature1: '🗺️ 1.4M+ Wells & Facilities — NM & TX with voice nav',
    pricingIndFeature2: '📋 DOT Inspections, JSA & Digital Signatures',
    pricingIndFeature3: '⏱️ Work Timer, Timesheets & Personal Crew Tools',
    pricingIndFeature4: '🤖 AI Assistant, Weather, Hazards & Alerts',
    pricingIndFeature5: '📱 Offline maps, receipts, certs & bilingual (EN/ES)',
    pricingIndFeatureSubtext: '20+ tools for oilfield professionals',
    pricingIndFeatureMonthlyCharity: '💚 10% goes to Weekend Hunger Initiative',
    pricingIndFeatureYearlyBonus: '🎁 2 months FREE ($20 savings)',
    pricingIndFeatureYearlyCharity: '💚 20% goes to Weekend Hunger Initiative',
    pricingBizFeature1: '👥 Everything in Individual for every paid user',
    pricingBizFeature2: '🏢 Company Dashboard: policies, training, fleet, safety & records',
    pricingBizFeature3: '💰 Volume pricing from $4/user/mo (100+ users)',
    pricingBizFeature4: '🎯 Dedicated support & company verification',
    pricingBizFeatureCharity: '💚 10% monthly / 20% annual to Weekend Hunger Initiative',
    allBusinessPlansInclude: 'All Business Plans Include:',
    businessFeature1: '✓ Everything in Individual for every paid user',
    businessFeature2: '✓ Company Dashboard for policies, training, fleet, safety, records, and crew invites',
    businessFeature3: '✓ Volume pricing from $4/user/mo (100+ users)',
    businessFeature4: '✓ Dedicated support & company verification',
    businessAccessNote: 'Business plans include Company Dashboard for company crews, policies, training, fleet, safety, and records.',
    comparisonHeading: 'Individual vs Business',
    individualPlanTitle: 'Individual — $10/mo',
    businessPlanTitle: 'Business — $4-7/user/mo',
    privacyFirstHeading: '🔒 Your Privacy First:',
    privacyFirstText: 'No account required—Telegram handles authentication. All API keys (Google, OpenWeather) are server-side only; you never see or transmit them. Your location is processed client-side and never stored on our servers. Hazard reporter identity is always anonymous—only basin-level alerts, no exact coordinates. E2E encrypted via Telegram. Auto-delete after 24 hours. No tracking, no ads, no data sales.',
    pricingDisclaimer: '💡 7-day trial applies to the selected plan • Company Dashboard requires Business • Cancel anytime',
    loginTermsText: 'By logging in, you agree to Telegram\'s',
    termsOfService: 'Terms of Service',
    and: 'and',
    privacyPolicy: 'Privacy Policy',
    madeWithLove: 'Made with ❤️ by',
    ziatechsLink: 'Zia Techs',
    charityText: 'We donate a percentage of every subscription to',
    packsForHunger: 'WHI Hobbs',
    donationBadgeLabel: 'WHI Hobbs',
    donationMilestoneMessage: '🎉 Amazing! You\'ve helped provide {0} meals!',
    donationFirstTimeMessage: '💚 Welcome! Your subscription donates to WHI Hobbs via Stripe Connect.',
    // Flock Cameras
    // Worker Profile
    workerProfileTitle: 'What\'s Your Role?',
    workerProfileDesc: 'Pick your oilfield worker type. Other workers will see your card in AR.',
    workerProfileSaved: 'Worker profile saved!',
    workerProfileSkip: 'Skip for now',
    flockCameraTitle: 'Flock Camera',
    flockCameraAlert: '🐦 Flock Camera Ahead',
    flockCameraAlertDesc: 'ALPR camera reported {0} away',
    flockCameraReported: 'Flock camera reported!',
    flockCameraVoteHelpful: 'Still There',
    flockCameraGone: 'Gone',
    copyright: '© 2026 Zia Well Nav',

    // Community Impact Section
    communityImpactTitle: 'Community Impact',
    communityImpactDesc: 'A portion of every subscription supports WHI Hobbs, helping feed families in the same towns that support the oilfield.',
    viewImpactReport: 'View Impact Report',
    monthlyDonation: 'of monthly subscriptions',
    annualDonation: 'all commercial subscriptions',
    packsForHungerDesc: 'The Weekend Hunger Initiative delivers weekend food bags to over 1,200 Hobbs ISD students facing food insecurity every Friday. Each bag contains nutritious meals to ensure no child goes hungry when school meals aren\'t available.',
    quarterlyImpact: '📊 We publish quarterly impact reports showing exactly how your subscription helps feed local kids.',
    dailyImpact: '📊 Daily donations posted on-chain • Receipts and totals published in-app.',
    
    
    // FAB labels (more comprehensive)
    search: 'Search',
    aiAssistant: 'AI Assistant',
    favoritesTooltip: 'Favorites',
    mapSettings: 'Map Settings',
    calicheRoutesTooltip: 'Caliche Routes',
    activity: 'Activity',
    jobs: 'Jobs',
    suggestions: 'Suggestions',
    timer: 'Timer',
    networkStatus: 'Network Status',
    qrShare: 'QR Share',
    voice: 'Voice',
    services: 'Services',
    basinCommunity: 'Basin Community',
    crews: 'Crews',
    friends: 'Friends',
    
    // Common UI elements
    openWellNavigator: 'Open Well Navigator',
    subscription: 'Subscription',
    subscriptionInfo: 'Subscription Info',
    individual: 'Individual',
    business: 'Business',
    perMonth: '/month',
    perYear: '/year',
    savePercent: 'Save {0}%',
    choosePlan: 'Choose Your Plan',
    trialSubheading: '7-day trial on selected plan • Individual is field-user access • Business includes Company Dashboard',
    monthly: 'Monthly',
    annualTwoMonthsFree: 'Annual (2 months FREE)',
    saveYearly: 'Save $20/year (2 months free!)',
    goesToPacksForHunger: 'goes to Weekend Hunger Initiative',
    startingCheckout: 'Starting Checkout...',
    startFreeTrial: 'Start 7-Day Free Trial',
    howManyLicenses: 'How many licenses do you need?',
    tierLabel: 'Tier',
    usersLabel: 'users',
    seatSubtotalLabel: 'Seat subtotal',
    documentationFeeLabel: 'Documentation fee',
    businessTotalLabel: 'Business total',
    charitySeatsOnlyNote: 'Includes 20% of the documentation fee',
    customBotSetupLabel: 'Custom bot setup',
    customBotSetupTitle: 'Add Custom Bot Integration',
    customBotSetupDescription: 'Optional company-branded Telegram bot for company announcements, meeting reminders, training and policy prompts, form follow-ups, crew links, and support routing. Private company records stay private without a custom bot; this add-on improves branded communication.',
    customBotSetupPrice: '$1,000 one-time setup',
    customBotDesiredName: 'Desired bot name or username',
    customBotContactEmail: 'Setup contact email',
    customBotUseCase: 'Use case or setup notes',
    startTrialForUsers: 'Start Trial for {0} Users',
    charityBannerTitle: '10% monthly / 20% annual to Weekend Hunger Initiative 🎒',
    charityBannerDesc: 'Daily donations posted on-chain • Receipts published in-app',
    stripeFooter: 'Payment secured by Stripe 🔒 • Auto-charges after 7-day trial if not canceled',
    preparingCheckout: 'Preparing secure checkout…',
    minLicensesError: 'Minimum {0} licenses required for business plans',
    maxLicensesError: 'Maximum {0} licenses supported in self-serve checkout',
    features: 'Features',
    
    // Messages & Toasts
    homeSaved: 'Home location saved!',
    navigatingHome: 'Navigating home...',
    locationCaptured: 'Location captured! Add a name and save.',
    geolocationNotSupported: 'Geolocation is not supported by your browser',
    failedToSave: 'Failed to save',
    routeDeleted: 'Route deleted',
    routeSaved: 'Route saved',
    photoUploaded: 'Photo uploaded',
    addFavoritesFirst: 'Add some favorites first to see them on the map!',
    
    // Directions & Navigation
    findingNearestWell: 'Finding nearest well...',
    couldNotSearch: 'Could not search for "{0}". {1}',
    noCachedResults: 'No cached results available.',
    pleaseTryAgain: 'Please try again.',
    
    // Cache & Data
    cacheVerified: 'Cache Verified: All cached data is valid',
    noCachedData: 'No cached data to verify. Download some basins first.',
    failedToVerify: 'Failed to verify cache integrity',
    cacheImported: 'Cache Imported: Team cache has been merged successfully',
    failedToImport: 'Failed to import cache',
    historyCleared: 'History Cleared: Search history has been removed',
    failedToClear: 'Failed to clear search history',
    cacheCleared: 'Cache Cleared: All cached data has been removed',
    failedToClearCache: 'Failed to clear cache',
    dataUpdated: 'Data Updated: Facility data was updated overnight',
    
    // Voice Navigation specific
    voiceSearchNotSupported: 'Voice search is not supported on Android Telegram. Please use the search bar to type your search, or tap the facility type buttons below!',
    speakToSearch: 'Speak to search',
    typeToSearch: 'Type to search',
    voiceNotSupportedDevice: 'Voice recognition not supported on this device. Try typing your search instead.',
    commandNotRecognized: 'Command not recognized. Try again.',
    commandNotImplemented: 'Command not implemented yet',
    failedToProcessCommand: 'Failed to process command',
    locationAccessRequired: 'Location access required',
    searchFailedRetry: 'Search failed. Please try again.',
    gpsCrewActive: 'GPS & Crew Active',
    gpsActive: 'GPS Active',
    gpsControls: 'GPS Controls',
    gpsSharingRequiredTitle: '🔒 Location Sharing Required',
    gpsSharingRequiredMessageNamed: 'As a member of "{0}", your location must be shared with your crew for safety coordination. Only crew owners can modify this setting.',
    gpsSharingRequiredMessageGeneric: 'As a crew member, your location must be shared with your crew for safety coordination. Only crew owners can modify this setting.',
    understood: 'Understood',
    gpsLocationOn: 'Location ON',
    gpsLocationOff: 'Location OFF',
    gpsRequiredForNavigation: 'Required for navigation',
    gpsSharingRequiredLabel: '🔒 Sharing Required',
    gpsCrewSharingOn: 'Crew Sharing ON',
    gpsCrewSharingOff: 'Crew Sharing OFF',
    gpsLockedByMembershipNamed: 'Locked by {0} membership',
    gpsLockedByMembershipGeneric: 'Locked by crew membership',
    gpsShareWithCrew: 'Share with your crew',
    arBackToVoiceNavigation: 'Back to voice navigation',
    arRecoverFrozenView: 'Recover from frozen AR view',
    arStalledTapRecover: 'AR appears stalled — tap to recover',
    arNoCameraFound: 'No camera found on this device.',
    arFindWithCamera: 'Find with Camera',
    arWaitingForGps: 'Waiting for GPS',
    arWaitingGpsBeforeCamera: 'Waiting for GPS before finding facilities with the camera.',
    arWaitingGpsLocation: 'Waiting for GPS location',
    arFinding: 'Finding',
    arLoadingLower: 'loading',
    arFoundCount: '{0} found',
    arAllFacilities: 'All Facilities',
    arMoreTypes: 'More Types',
    arWideScan: 'Wide Scan',
    arBirds: 'Birds',
    arDots: 'Dots',
    arOperators: 'Operators',
    arAllOps: 'All Ops',
    arFacilityTypes: 'Facility Types',
    arLoadMore: 'Load More',
    arTapToExpand: 'Tap to expand',
    safetyWindSockH2S: 'H2S',
    safetyWindSockRunCrosswind: 'RUN CROSSWIND',
    safetyWindSockRunToward: 'RUN {0}',
    safetyWindSockWindFrom: 'Wind from',
    safetyWindSockDownwind: 'Downwind',
    safetyWindSockUnavailable: 'Wind unavailable',
    safetyWindSockStale: 'Stale',
    safetyWindSockUpdated: 'Updated {0}',
    safetyWindSockGusts: 'Gusts {0} mph',
    safetyWindSockAria: 'H2S crosswind guidance. Wind from {0} at {1} mph. Run {2}.',
    safetyWindSockUnavailableAria: 'H2S crosswind guidance unavailable. GPS and weather are needed.',
    
    // Location Errors
    locationPermissionDenied: '📍 Location permission denied. Please enable location in your browser/device settings to report bear sightings.',
    locationUnavailable: '📍 Location unavailable. Make sure GPS is enabled on your device.',
    locationTimeout: '📍 Location request timed out. Please try again in an area with better GPS signal.',
    locationErrorGeneric: '📍 Could not get your location. Please check your location settings and try again.',
    
    // Hazard/Bear Reporting
    failedToReportBear: '⚠️ Failed to report bear. Please check your internet connection and try again.',
    hazardReportTitle: 'Report Road Hazard',
    hazardReportedTitle: 'Hazard Reported!',
    hazardReportedThanks: 'Thank you for helping keep other drivers safe.',
    hazardLocationRequired: 'Location required',
    hazardUpdateLocation: 'Update',
    hazardGetLocation: 'Get Location',
    hazardTypePrompt: 'What type of hazard?',
    hazardDetailsLabel: 'Additional Details (optional)',
    hazardDetailsPlaceholder: "e.g., 'Northbound lane only', 'Near mile marker 42'",
    hazardInfoText: 'Other drivers can vote to confirm or dismiss hazards. Reports with multiple confirmations stay longer, while disputed reports are removed faster.',
    hazardReporting: 'Reporting...',
    hazardReportButton: 'Report Hazard',
    hazardLocationAccuracyWarning: '⚠️ Location accuracy is ±{0}m. If this feels off, try again.',
    hazardLocationErrorDefault: 'Could not get your location. Please enable GPS and try again.',
    hazardLocationUnavailable: 'Unable to get location.',
    hazardCrashLabel: 'Crash',
    hazardCrashDesc: 'Vehicle accident or collision on the road',
    hazardCrashDuration: '3 hours',
    hazardSlowdownLabel: 'Slowdown',
    hazardSlowdownDesc: 'Traffic backup or slow moving vehicles',
    hazardSlowdownDuration: '1 hour',
    hazardConstructionLabel: 'Construction',
    hazardConstructionDesc: 'Road work or construction zone',
    hazardConstructionDuration: '8 hours',
    hazardLaneClosureLabel: 'Lane Closure',
    hazardLaneClosureDesc: 'One or more lanes blocked',
    hazardLaneClosureDuration: '4 hours',
    hazardObjectOnRoadLabel: 'Object on Road',
    hazardObjectOnRoadDesc: 'Debris, tire, animal, or obstacle in roadway',
    hazardObjectOnRoadDuration: '1 hour',
    hazardFloodedRoadLabel: 'Flooded Road',
    hazardFloodedRoadDesc: 'Water covering roadway - turn around, don\'t drown',
    hazardFloodedRoadDuration: '6 hours',
    hazardLowVisibilityLabel: 'Low Visibility',
    hazardLowVisibilityDesc: 'Fog, dust storm, smoke, or heavy rain',
    hazardLowVisibilityDuration: '2 hours',
    hazardCopLabel: 'Cop',
    hazardCopDesc: 'Law enforcement spotted - becomes checkpoint after 30 min',
    hazardCopDuration: '30 min + ghost',
    hazardSafetyInspectorLabel: 'Safety Inspector',
    hazardSafetyInspectorDesc: 'Safety inspector spotted - work site checkpoint',
    hazardSafetyInspectorDuration: '30 min + ghost',
    hazardFireLabel: 'Fire',
    hazardFireDesc: 'Active fire reported. Stay clear and follow safety protocols.',
    hazardFireDuration: '4 hours',
    hazardDotOfficerLabel: 'DOT Officer',
    hazardDotOfficerDesc: 'DOT officer spotted - inspection checkpoint ahead',
    hazardDotOfficerDuration: '30 min + ghost',
    hazardPersonalInjuryLabel: 'Personal Injury',
    hazardPersonalInjuryDesc: 'You are injured - alerts nearby workers for help',
    hazardPersonalInjuryDuration: '4 hours',
    hazardInjuredWorkerLabel: 'Injured Worker',
    hazardInjuredWorkerDesc: 'Another worker is injured - report their location for help',
    hazardInjuredWorkerDuration: '4 hours',
    hazardTruckBrokeDownLabel: 'Truck Broke Down',
    hazardTruckBrokeDownDesc: 'Broken down truck on road - warns drivers of obstruction',
    hazardTruckBrokeDownDuration: '4 hours',
    
    // Route Messages
    routeNoLandmarks: 'Route has no landmarks',
    routeNoFinish: 'Route has no finish location',
    route: 'route',
    routes: 'routes',
    points: 'points',
    inAppNav: 'In-App Nav',
    viewRoute: 'View Route',
    googleMaps: 'Google Maps',
    calicheRoute: 'Caliche route',
    routeFromMainRoad: 'Route from main road',
    routeToFacility: 'Route to facility',
    routesNoneTitle: 'No routes shared yet',
    routesNoneSubtitle: 'Be the first to draw a route!',
    routesSortedByVotes: '{0} {1} • sorted by votes',
    routesCountLabel: '{0} {1}',
    topRoute: 'TOP ROUTE',
    showNotes: 'Show notes',
    hideNotes: 'Hide notes',
    anonymousUser: 'Anonymous',
    routesShareTitle: 'Caliche Route',
    routesShareStartLabel: 'Start',
    routesShareFindMore: 'Find more',
    routesLoadFailed: 'Failed to load routes',
    routesLoadError: 'Error loading routes',
    waypointTurn: 'Turn',
    waypointLandmark: 'Landmark',
    waypointGate: 'Gate',
    waypointWarning: 'Warning',
    waypointMarker: 'Marker',
    routeReviewTitle: 'Review Route',
    routeLandmarksCaptured: '{0} / {1} landmarks captured',
    routeNameLabel: 'Route Name *',
    routeNamePlaceholder: 'e.g., Main Access from Highway 285',
    routeDescriptionLabel: 'Description (optional)',
    routeDescriptionPlaceholder: 'Tips for other drivers...',
    routeDifficultyLabel: 'Difficulty:',
    routeDifficultyEasy: 'Easy',
    routeDifficultyModerate: 'Med',
    routeDifficultyHard: 'Hard',
    routeSurfaceLabel: 'Surface:',
    routeSurfacePaved: 'Paved',
    routeSurfaceCaliche: 'Caliche',
    routeSurfaceDirt: 'Dirt',
    routeDestinationLabel: 'Destination: {0}{1}',
    routePhotosMarkedForRetake: '{0} {1} marked for retake',
    routeLandmarksWithoutPhotos: '{0} {1} without photos - they can still be submitted',
    routeCapturedPhotosLabel: 'Captured Photos:',
    routeNeedsRetakeLabel: 'Needs retake',
    routeNoPhotosCaptured: 'No photos captured',
    routeSaveWithoutPhotos: 'Route can still be saved without photos',
    routeSaveDraft: 'Save Draft',
    routeSaving: 'Saving...',
    routePublishing: 'Publishing...',
    routePublish: 'Publish',
    routeNameRequiredError: 'Please enter a route name',
    routeRetakeBeforePublishError: 'Please retake or remove photos marked as needing attention before publishing.',
    routeLandmarkLabel: 'Landmark {0}',
    photo: 'photo',
    photos: 'photos',
    landmark: 'landmark',
    landmarks: 'landmarks',
    routeRecordingDefaultName: 'Route Recording',
    recordingLabel: 'REC',
    autoCaptureOn: 'Auto-capture ON',
    autoCaptureOff: 'Auto-capture OFF (manual only)',
    routeProgress: 'Route Progress',
    waypointsProgress: '{0}/{1} waypoints',
    nextWaypoint: 'NEXT WAYPOINT',
    waypointNumber: 'Waypoint {0}',
    capturingPhoto: '📸 Capturing Photo...',
    waypoint: 'Waypoint',
    lastCapture: 'Last capture',
    savedLabel: '✓ Saved',
    acquiringGps: 'Acquiring GPS...',
    failedToExportCache: 'Failed to export cache',
    
    // Dialog Titles
    downloadOfflineMap: 'Download Offline Map',
    
    // Dialog Content
    selectBasin: 'Select which basin you\'ll be working in:',
    selectCounty: 'Select county to filter wells, or search all:',
    searchPlaceholderFull: 'Search wells, operators, API numbers...',
    
    // Onboarding/Help
    voiceSearchTitle: 'Voice Search',
    voiceSearchDesc: 'Hands-free search while driving. Say a well, API, operator, or location.',
    voiceSearchIOS: 'iOS: Tap the search bar, then "Tap to Voice Search" and speak.',
    voiceSearchAndroid: 'Android: Tap the search bar, then the mic icon on the keyboard (bottom-left).',
    dayAndNight: 'Day & Night',
    chipComingSoon: '🔜 Coming Soon',
    chipOptOut: 'Opt-Out',
    chip32Types: '62 Types',
    chip3Options: '3 Options',
    chip22GoogleApis: '22 Google APIs',
    chipCDLReady: 'CDL Ready',
    chipGoogleM3: 'Google M3',
    chipGlobalCDN: 'Global CDN',
    fabButtonsTitle: 'FAB Buttons',
    tapToOpen: '• Tap: Open the feature',
    longPressToDrag: '• Long press: Drag to reorder or move',
    moveFabsBetweenZones: '• Drag between top, left, right, and bottom zones',
    helpCoreFeaturesTitle: 'Core Features',
    helpCoreFeaturesDesc: 'The main field tools most crews use inside the app.',
    helpCoreFeatureVoiceSearchTitle: 'Voice Search',
    helpCoreFeatureVoiceSearchDesc: 'Search hands-free while driving by saying a well, API, operator, facility, or location.',
    helpCoreFeatureVoiceSearchHint: 'Find it: Search bar: Voice Search',
    helpCoreFeatureHazardsTitle: 'Hazards',
    helpCoreFeatureHazardsDesc: 'Report and view road hazards, cops, DOT, weather trouble, and field incidents.',
    helpCoreFeatureHazardsHint: 'Find it: FAB: Hazards / Report Hazard',
    helpCoreFeature2dMapTitle: '2D Map',
    helpCoreFeature2dMapDesc: 'Use the normal map view for wells, favorites, hazards, layers, and routes.',
    helpCoreFeature2dMapHint: 'Find it: FAB: View on Map',
    helpCoreFeatureArViewTitle: 'AR View',
    helpCoreFeatureArViewDesc: 'Point the camera to see nearby wells and facilities in the field view.',
    helpCoreFeatureArViewHint: 'Find it: AR View',
    helpCoreFeatureApiQuickDialTitle: 'API Quick Dial',
    helpCoreFeatureApiQuickDialDesc: 'Enter a known API number fast and jump straight to the well.',
    helpCoreFeatureApiQuickDialHint: 'Find it: FAB: Quick Dial API #',
    helpCoreFeatureApiListTitle: 'API List',
    helpCoreFeatureApiListDesc: 'Browse API numbers and wells when you do not have the exact number memorized.',
    helpCoreFeatureApiListHint: 'Find it: FAB: Browse API Numbers',
    helpCoreFeatureFavoritesTitle: 'Favorites',
    helpCoreFeatureFavoritesDesc: 'Save important wells and facilities so you can reopen or navigate to them quickly.',
    helpCoreFeatureFavoritesHint: 'Find it: FAB: Favorites',
    helpCoreFeatureFacilityChipsTitle: 'Facility Chips',
    helpCoreFeatureFacilityChipsDesc: 'Browse wells and facilities by type instead of typing a search.',
    helpCoreFeatureFacilityChipsHint: 'Find it: FAB: Facility Chips',
    helpCoreFeatureJsaTitle: 'JSA',
    helpCoreFeatureJsaDesc: 'Build a Job Safety Analysis with hazards, PPE, emergency contacts, and crew sign-off.',
    helpCoreFeatureJsaHint: 'Find it: FAB: New JSA',
    helpCoreFeaturePrePostTripTitle: 'Pre/Post Trip',
    helpCoreFeaturePrePostTripDesc: 'Complete vehicle inspection forms before and after the drive.',
    helpCoreFeaturePrePostTripHint: 'Find it: Menu: Pre/Post Trip',
    helpCoreFeatureSearchTitle: 'Search',
    helpCoreFeatureSearchDesc: 'Search by well name, API, operator, facility, or address.',
    helpCoreFeatureSearchHint: 'Find it: FAB: Search Facilities',
    helpCoreFeatureAiTitle: 'AI',
    helpCoreFeatureAiDesc: 'Ask the AI copilot for help with routes, wells, forms, and field questions.',
    helpCoreFeatureAiHint: 'Find it: FAB: AI',
    
    // SearchResults UI
    selectALetter: 'Select a first letter to drill down',
    removeFromFavoritesTooltip: 'Remove from Favorites',
    addToFavoritesTooltip: 'Add to Favorites',
    viewDetailsAction: 'View Details',
    viewDetailsTooltip: 'View Details',
    viewOnMapTooltip: 'View on Map',
    shareTooltip: 'Share',
    inAppNavTooltip: 'In-App Nav',
    googleTooltip: 'Google',
    appleTooltip: 'Apple',
    wazeTooltip: 'Waze',
    photoGalleryTooltip: 'Photo Gallery',
    shownOfTotal: '{0}/{1} shown',
    loadingMore: 'Loading more...',
    facilityPhotos: '{0} Photos',
    
    // Crew Panel
    timesheet: 'Timesheet',
    refresh: 'Refresh',
    locationSharing: 'Location Sharing',
    locationVisible: 'Your location is visible to crew members',
    locationPrivate: 'Your location is private (BYOD friendly)',
    createCrew: 'Create Crew',
    joinCrew: 'Join Crew',
    description: 'Description (optional)',
    descriptionPlaceholder: 'What\'s this crew for?',
    create: 'Create',
    inviteCode: 'Invite Code',
    inviteCodePlaceholder: 'e.g., ABC123',
    join: 'Join',
    members: 'members',
    member: 'member',
    inviteCodeCopied: 'Invite code copied!',
    inviteShared: 'Invite shared!',
    confirmLeave: 'Are you sure you want to leave this crew?',
    leftCrew: 'You left the crew',
    confirmDelete: 'Are you sure you want to delete this crew? This action cannot be undone.',
    crewDeleted: 'Crew deleted',
    activeMeetings: 'Active Meetings',
    checkIns: '{0} check-ins',
    radiusMeters: '{0}m radius',
    checkIn: 'Check In',
    setMeetingPoint: 'Set Meeting Point',
    leadTimesheetSettings: 'Lead & Timesheet Settings',
    createMeetingPoint: 'Create Meeting Point',
    meetingLocationDesc: 'This will create a meeting point at your current location.',
    meetingName: 'Meeting Name',
    meetingNamePlaceholder: 'e.g., Morning Standup',
    checkInRadius: 'Check-in Radius: {0}m',
    makeAdmin: 'Make Admin',
    removeAdmin: 'Remove Admin',
    removeFromCrew: 'Remove from Crew',
    scanToJoin: 'Scan to Join',
    orShareCode: 'Or share this code:',
    leadName: 'Lead/Supervisor Name',
    leadNamePlaceholder: 'e.g., John Smith',
    leadEmail: 'Lead Email',
    leadEmailPlaceholder: 'e.g., lead@company.com',
    companyName: 'Company Name',
    companyNamePlaceholder: 'e.g., ABC Energy Services',
    autoSubmitTimesheet: 'Auto-submit timesheet weekly',
    submitOn: 'Submit On',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    settingsSaved: 'Settings saved!',
    timesheetSettingsDesc: 'Configure where weekly timesheets are sent automatically.',
    liveMemberLocations: 'Live Member Locations',
    noMembersSharedLocation: 'No members have shared their location recently.',
    submitWeeklyTimesheet: 'Submit Weekly Timesheet',
    timesheetSubmitDesc: 'This will submit the current week\'s timesheet to your lead ({0}).',
    noEmailConfigured: 'no email configured',
    week: 'Week',
    notesOptional: 'Notes (optional)',
    notesPlaceholder: 'Any additional notes for your lead...',
    noLeadEmailWarning: 'No lead email configured. Please set up lead settings first.',
    submitToLead: 'Submit to Lead',
    locationNotAvailable: 'Location not available. Please enable location services.',
    roleUpdated: 'Role updated to {0}',
    memberRemoved: 'Member removed',
    failedToShare: 'Failed to share invite',
    confirmRemove: 'Remove {0}?',
    notPartOfCrews: "You're not part of any crews yet.",
    createOrJoinCrew: 'Create one or join with an invite code!',
    
    // MorningPulse
    loadingBasinPulse: 'Loading basin pulse...',
    unableToLoadPulse: 'Unable to Load Basin Pulse',
    noDataAvailable: 'No data available',
    digestStaleFallback: 'Showing data from {0} — current period has no new entries yet.',
    freshnessBannerStale: '{0} data source(s) stale — some info may be outdated.',
    freshnessBannerMissing: '{0} data source(s) unavailable — coverage incomplete.',
    layerSourceUnavailable: 'Layer source unavailable — showing 0 results.',
    tryAgain: 'Try Again',
    activeCount: 'active',
    hazard: 'hazard',
    hazards: 'hazards',
    homeSafe: 'home safe',
    activeHazards: 'Active Hazards',
    worker: 'Worker',
    reports: 'reports',
    confirms: 'confirms',
    homeSafeCheck: 'Home safe ✓',
    madeItHome: 'Made it home',
    guardian: 'guardian',
    trusted: 'trusted',
    verified: 'verified',
    activeWorker: 'active',
    newWorker: 'new',
    
    // ErrorBoundary
    somethingWentWrong: 'Something went wrong',
    errorDescription: 'The app encountered an unexpected error. Your saved favorites are safe - try reloading.',
    reloadApp: 'Reload App',
    
    // ProductionChart
    loadingProductionData: 'Loading production data...',
    productionDataUnavailable: 'Production data may not be available for all wells',
    productionNoData: 'No production data available',
    productionLoadFailed: 'Failed to load production data',
    productionHistoryTitle: 'Production History',
    productionWellTitle: '{0} Production',
    productionLatestWellRateLabel: 'OIL BBL/DAY',
    productionLatestLeaseLabel: 'LATEST LEASE MONTH',
    productionLatestReportedMonth: 'Latest reported month',
    productionProducingDays: '{0} producing days',
    productionGasRate: 'Gas {0} mcf/day',
    productionWaterRate: 'Water {0} bbl/day',
    productionLeaseOil: 'Oil',
    productionLeaseGas: 'Gas',
    productionLeaseCondensate: 'Condensate',
    productionTotalsOil: 'Total Oil (bbls)',
    productionTotalsGas: 'Total Gas (mcf)',
    productionTotalsWater: 'Total Water (bbls)',
    productionTotalsCondensate: 'Total Condensate (bbls)',
    productionSourceTxLease: 'Data source: TX RRC PDQ lease production • Last {0} months',
    productionSourceNmWell: 'Data source: NM OCD C-115 Reports • Last {0} months',
    productionSeriesOil: 'Oil',
    productionSeriesGas: 'Gas',
    productionSeriesWater: 'Water',
    productionSeriesCondensate: 'Condensate',
    productionUnitBbls: 'bbls',
    productionUnitMcf: 'mcf',
    productionChartArea: 'Area',
    productionChartBar: 'Bar',
    productionChartMix: 'Mix',
    productionIntelligenceTitle: 'Production Intelligence',
    productionNetValuePerDay: 'NET VALUE / DAY',
    productionBrentUnavailable: 'BRENT N/A',
    productionBrentUnavailableLong: 'Energy prices unavailable',
    productionBrentUnavailableChart: 'Energy prices are unavailable. Oil, gas, water, and mix views still show production volumes.',
    productionBrentWaterPrice: 'Brent ${0} • Water ${1}/bbl',
    productionEnergyPrices: 'WTI ${0} • Brent ref ${1} • Henry Hub ${2} • Water ${3}/bbl',
    productionOilRateShort: 'OIL + COND',
    productionGasRateShort: 'GAS',
    productionWaterRateShort: 'WATER',
    productionWaterPenaltyShort: 'WATER COST/DAY',
    productionViewNet: 'NET',
    productionViewOil: 'OIL',
    productionViewGas: 'GAS',
    productionViewWater: 'WATER',
    productionViewMix: 'MIX',
    productionSeriesOilRate: 'Oil rate',
    productionSeriesCondensateRate: 'Condensate rate',
    productionSeriesLiquidRate: 'Liquid rate',
    productionSeriesGasRate: 'Gas rate',
    productionSeriesWaterRate: 'Water rate',
    productionSeriesOilValue: 'Oil value',
    productionSeriesGasValue: 'Gas value',
    productionSeriesGrossValue: 'Gross value',
    productionSeriesWaterPenalty: 'Water penalty',
    productionSeriesNetValue: 'Net value',
    
    // SuggestionsDialog
    suggestFeature: 'Suggest a Feature',
    supportRequest: 'Support Request',
    featureRequest: 'Feature Request',
    bugReport: 'Bug Report',
    improvement: 'Improvement',
    thankYou: 'Thank You!',
    suggestionSubmitted: 'Your suggestion has been submitted. We appreciate your feedback!',
    supportSubmitted: 'Your support request has been submitted. We will follow up soon.',
    category: 'Category',
    title: 'Title',
    titlePlaceholder: 'Brief summary of your suggestion',
    supportTitlePlaceholder: 'Brief summary of your issue',
    suggestionDescription: 'Description',
    suggestionDescriptionPlaceholder: 'Describe your suggestion in detail. What problem does it solve? How would it work?',
    supportDescription: 'Issue Details',
    supportDescriptionPlaceholder: 'Describe the problem, steps to reproduce, and any screenshots or error messages.',
    suggestFeatureEmailLabel: 'Feature requests? Email',
    suggestFeatureEmailAddress: 'sales@ziatechs.com',
    suggestFeatureTelegramLabel: 'You can also message us on Telegram:',
    submitSuggestion: 'Submit Suggestion',
    submitSupportRequest: 'Submit Support Request',
    submitting: 'Submitting...',
    fillBothFields: 'Please fill in both title and description',
    newFeature: 'New Feature',
    navigation: 'Navigation',
    mapMarkers: 'Map & Markers',
    other: 'Other',
    
    // DrawOverAppsPrompt
    drawOverEnhanceNav: 'Enhance Your Navigation',
    drawOverDesc: 'Enable "Draw Over Apps" permission for Telegram to make it easier to return to ZiaWellNav while using other apps.',
    drawOverWhyEnable: 'Why Enable Draw Over Apps?',
    drawOverWhyEnableDesc: 'When you switch away from Telegram to another app, ZiaWellNav can show navigation overlays on top of your screen. This makes it easier to get back to navigation without opening Telegram again.',
    drawOverOpenSettings: 'Open Settings',
    drawOverOpenSettingsDesc: 'Tap the button below to open your device settings. Look for "Display over other apps" or "Draw over other apps" permission.',
    drawOverEnableForTelegram: 'Enable for Telegram',
    drawOverEnableForTelegramDesc: 'Find Telegram in the list and enable the permission. Once enabled, come back here and tap "Done".',
    drawOverSkip: 'Skip for now',
    drawOverNext: 'Next',
    drawOverDone: 'Done',
    
    // GoHomeFAB
    goHomeSetLocation: 'Set Home Location',
    goHomeUpdateLocation: 'Update Home Location',
    goHomeTooltip: 'Go to {0} (hold to edit)',
    goHomeTooltipNoHome: 'Set Home Location',
    goHomeLocationDesc: 'Your home location is used for the "Go Home" navigation and to auto-stop the timer when you arrive.',
    goHomeCurrent: 'Current: <strong>{0}</strong>',
    goHomeLocationCaptured: 'Location captured!',
    goHomeUseCurrentLocation: 'Use Current Location',
    goHomeGettingLocation: 'Getting Location...',
    goHomeNameLabel: 'Home Name (optional)',
    goHomeNamePlaceholder: 'e.g., My House, The Ranch',
    goHomeSaveButton: 'Save Home',
    goHomeNavigateQuestion: 'Navigate Home?',
    goHomeNavigateTo: 'Navigate to <strong style="color: {0}">{1}</strong>?',
    goHomeNavigateDesc: 'This will open Google Maps with directions to your home location.',
    goHomeAutoStopNote: '✓ Timer will auto-stop when you arrive',
    goHomeGoButton: 'Go Home',
    goHomeNavigateTitle: '🏠 Navigate Home',
    goHomeNavigateMessage: 'Go to {0}',
    goHomeGoogleMaps: '🗺️ Google Maps',
    goHomeAppleMaps: '🍎 Apple Maps',
    goHomeWaze: '👻 Waze',
    goHomeToastSaved: '🏠 Home location saved!',
    goHomeToastFailed: 'Failed to save home location',
    goHomeToastLocationCaptured: '📍 Location captured! Add a name and save.',
    goHomeToastGeoNotSupported: 'Geolocation is not supported by your browser',
    goHomeToastLocationError: 'Could not get location',
    goHomeToastPermissionDenied: 'Location permission denied. Please enable location in your browser settings.',
    goHomeToastLocationUnavailable: 'Location unavailable. Please try again.',
    goHomeToastLocationTimeout: 'Location request timed out. Please try again.',
    goHomeToastNavigating: '🚗 Navigating home...',
    
    // WorkTimerFAB
    workTimerStartTooltip: 'Start Timer',
    workTimerPauseTooltip: 'Pause (hold to stop)',
    workTimerResumeTooltip: 'Resume (hold to stop)',
    workTimerSelectCrew: 'Select Crew for Time Entry',
    workTimerWhichCrew: 'Which crew should this time be logged to?',
    workTimerStopQuestion: 'Stop Timer?',
    workTimerCurrentTime: 'Current time: <strong style="color: {0}">{1}</strong>',
    workTimerLoggingTo: 'Logging to: {0}',
    workTimerKeepRunning: 'Keep Running',
    workTimerStopButton: 'Stop Timer',
    workTimerYoureHome: "You're Home!",
    workTimerArrivedAt: "It looks like you've arrived at <strong>{0}</strong>.",
    workTimerTotalTime: 'Total time: <strong style="color: {0}">{1}</strong>',
    workTimerStopQuestion2: 'Would you like to stop the timer?',
    workTimerFailedStart: 'Failed to start',
    workTimerFailedPause: 'Failed to pause',
    workTimerFailedResume: 'Failed to resume',
    workTimerFailedStop: 'Failed to stop',
    
    // UserSupportFAB
    userSupportTooltip: 'Contact Support ($1/message)',
    
    // VPNWarningSnackbar
    vpnWarningMessage: 'VPN detected! This may affect navigation accuracy. Consider disabling your VPN for better GPS performance.',
    vpnDetected: 'VPN Detected',
    vpnLearnMore: 'Learn More',
    vpnWhyAffects: 'Why does VPN affect navigation?',
    vpnInterferenceIntro: 'VPNs can interfere with location services in several ways:',
    vpnIPLocation: 'IP-based location may show wrong area',
    vpnGPSBackup: 'Some GPS services use network location as backup',
    vpnMapTiles: 'Map tile loading may be slower',
    vpnBestResults: 'For best results in the oil field, disable VPN while navigating.',
    
    // OfflineSyncIndicator
    offlineTooltip: 'Offline - {0} submission{1} pending',
    offlineSyncing: 'Syncing...',
    offlinePendingTap: '{0} pending{1} - Tap to sync',
    offlineAllSynced: 'All synced',
    
    // ExpiredTrialBanner
    trialEnded: 'Your trial has ended. Upgrade to unlock all premium features!',
    trialEndingSoon: '{0} — Upgrade now to keep access',
    upgradeNow: '✨ Upgrade Now',
    
    // SearchPanel
    searchButtonText: 'Search wells by API, operator, or location...',
    searchInputPlaceholder: 'Search wells...',
    searchResultsWillAppear: 'Search results will appear here...',
    
    // Profile Card
    profilePhone: 'Phone',
    profileEmail: 'Email',
    profileSharePhone: 'Share Phone',
    profileEnterPhone: 'Enter phone',
    profileSave: 'Save',
    profileEmailNotLinked: 'Not linked',
    profilePhoneNotShared: 'Not shared',
    profilePhoneOpenTelegram: 'Open in Telegram to share',

    // TelegramLogin
    telegramLoginLoading: 'Loading...',
    telegramLoginOpenBot: 'Open @{0} in Telegram',

    // QRShareDialog
    qrShareTitle: 'Share VAMOS AR',
    qrLoadingReferral: 'Loading referral info...',
    qrSuccessfulReferrals: '{0} successful referral{1}!',
    qrScanOrShare: 'Scan this QR code or share the link below',
    qrCopyLink: 'Copy Link',
    qrCopied: 'Copied!',
    qrShareButton: 'Share',
    qrEarnCredits: 'Earn Credits by Sharing',
    qrFreeUserSignup: 'Free user signs up',
    qrUserConvertsPaid: 'User converts to paid',
    qrBusinessSignup: 'Business signs up',
    qrFiveReferrals: '5 referrals milestone',
    qrFreeMonth: '1 FREE MONTH',
    qrShareText: '🛢️ Check out ZiaWellNav - the ultimate oil field navigation app!\n\n📍 Find wells, rigs, and SWDs across the Permian Basin\n🗺️ Turn-by-turn GPS navigation to any facility\n👥 Create and manage your crews\n🔧 Find oilfield services near you\n\nFREE while in development! Join now:',
    
    // PollenAlertWidget
    pollenLoadingData: 'Loading pollen data...',
    pollenLabel: 'Pollen',
    pollenPlantsInSeason: '{0} plants in season',
    pollenInSeasonPlants: 'In-Season Plants:',
    pollenMorePlants: '+{0} more',
    
    // NearbyServicesWidget
    nearbyServicesTitle: 'Nearby Services',
    nearbyGasStations: 'Gas Stations',
    nearbyRestaurants: 'Restaurants',
    nearbyHotels: 'Hotels',
    nearbyMedical: 'Medical',
    nearbyAutoRepair: 'Auto Repair',
    nearbyStores: 'Stores',
    nearbyATMs: 'ATMs',
    nearbyFindingPlaces: 'Finding nearby {0}...',
    nearbyNoPlaces: 'No {0} found within 20 miles',
    nearbyNavigateTo: '🧭 Navigate to {0}',
    nearbyChooseApp: 'Choose navigation app',
    nearbyGoogleMaps: '🗺️ Google Maps',
    nearbyAppleMaps: '🍎 Apple Maps',
    nearbyWaze: '👻 Waze',
    nearbyOpenNow: 'Open now',
    nearbyClosed: 'Closed',
    nearbyOpen: 'Open',
    nearbyGetDirections: 'Get Directions',
    
    // AutoCaptureCamera
    cameraError: 'Camera Error',
    cameraStarting: 'Starting camera...',
    
    // AirQualityWidget
    aqiPrefix: 'AQI',
    aqiError: 'AQI: {0}',
    aqiGood: 'Good',
    aqiModerate: 'Moderate',
    aqiUnhealthySensitive: 'Unhealthy (Sensitive)',
    aqiUnhealthy: 'Unhealthy',
    aqiVeryUnhealthy: 'Very Unhealthy',
    aqiHazardous: 'Hazardous',
    aqiRespiratoryWarning: 'Consider respiratory protection',
    aqiIndexLabel: 'Air Quality Index',
    aqiPollutants: 'Pollutants',
    aqiHealthAdvisory: 'Health Advisory',
    aqiUpdated: 'Updated: {0}',
    aqiDataUnavailable: 'Air quality data unavailable',
    aqiFetchFailed: 'Air quality fetch failed',
    
    // ElevationWidget
    elevSafe: 'SAFE',
    elevCaution: 'CAUTION',
    elevWarning: 'WARNING',
    elevDanger: 'DANGER',
    elevProfile: 'Elevation Profile',
    elevFailed: 'Failed to fetch elevation',
    elevUnavailable: 'Elevation unavailable',
    elevMaxGrade: 'Max Grade',
    elevTotalAscent: 'Total Ascent',
    elevTotalDescent: 'Total Descent',
    elevFeet: 'ft',
    elevMiles: 'mi',
    elevUphill: 'Uphill',
    elevDownhill: 'Downhill',
    elevGrade: 'Grade',
    elevLoading: 'Calculating elevation...',
    
    // WeatherOverlay
    weatherWindCalm: 'CALM',
    weatherWindModerate: 'MODERATE',
    weatherWindCaution: 'CAUTION - GUSTY',
    weatherWindWarning: 'WARNING - STRONG WIND',
    weatherWindDanger: 'DANGER - HIGH WIND',
    weatherWindHurricane: 'HURRICANE FORCE',
    weatherWindWarningLabel: '{0} - {1} mph',
    weatherFloodLow: 'Low flood risk',
    weatherFloodModerate: 'Moderate flood risk - Be cautious near dry washes',
    weatherFloodHigh: '⚠️ HIGH flash flood risk - Avoid low areas and washes!',
    weatherFloodExtreme: '⚠️ EXTREME FLASH FLOOD RISK - Seek high ground immediately!',
    weatherThunderstormWarning: 'Thunderstorm Warning',
    weatherHeavyRain: 'Heavy Rain Alert',
    weatherThunderstormWarningDesc: '{0}% chance of thunderstorms. Seek shelter and avoid open areas.',
    weatherHeavyRainDesc: '{0}% precipitation probability. Monitor for flash flood conditions.',
    weatherProviderGoogle: 'Google Weather',
    weatherWind: 'Wind',
    weatherTemp: 'Temp',
    weatherFeelsLike: 'Feels Like',
    weatherHumidity: 'Humidity',
    weatherVisibility: 'Visibility',
    weatherClouds: 'Clouds',
    weatherUVIndex: 'UV Index',
    weatherPrecipProb: 'Precip',
    weatherUpdated: 'Updated: {0}',
    weatherWindGusts: '(gusts {0} mph)',
    weatherAlertCount: '{0} {1}',
    alert: 'alert',
    alerts: 'alerts',
    weatherWindSpeedLabel: 'Wind Speed',
    weatherGusts: 'Gusts',
    weatherGustsUpTo: 'Gusts up to {0} mph',
    weatherUnavailable: 'Weather data unavailable',
    weatherFetchFailed: 'Weather fetch failed',
    weatherNotConfigured: 'Weather API not configured',
    weatherSixDayForecast: '6-Day Forecast',
    weatherTemperatureTrend: 'Temperature Trend',
    weatherWindTrend: 'Wind Trend',
    weatherSixDayHighLow: '6-day high / low',
    weatherSixDayWindGust: '6-day sustained / gust',
    weatherTrendUnavailable: 'Forecast trend unavailable',
    weatherNow: 'Now',
    today: 'Today',

    // OfflineCacheManager
    offlineCacheTitle: 'Offline Cache',
    offlineCacheLowSignalTag: 'For Low Signal Areas',
    offlineCacheMapTilesTab: 'Map Tiles',
    offlineCacheFacilityDataTab: 'Facility Data',
    offlineCacheTotalCached: 'Total Cached',
    offlineCacheMapTiles: 'Map Tiles',
    offlineCacheAreasCached: 'Areas Cached',
    offlineCacheRefresh: 'Refresh',
    offlineCacheClearAllMapCache: 'Clear All Map Cache',
    offlineCacheDownloading: 'Downloading: {0}',
    offlineCacheProgressTiles: '{0} / {1} tiles',
    offlineCacheFailedCount: '{0} failed',
    offlineCacheWorkAreasTitle: 'Permian Basin Work Areas',
    offlineCacheCachedTiles: 'Cached: {0} tiles ({1} MB)',
    offlineCacheEstimatedTiles: '~{0} tiles • ~{1} MB',
    offlineCacheClearCache: 'Clear Cache',
    offlineCacheDownloadingButton: 'Downloading...',
    offlineCacheDownloadButton: 'Download',
    offlineCacheMapTilesLabel: 'Map Tiles',
    offlineCacheMapTilesHelp: 'Download map tiles for areas where you frequently work. Once cached, maps will load even without cell signal.',
    offlineCacheFacilityData: 'Facility Data',
    offlineCacheBasinsCached: 'Basins Cached',
    offlineCacheVerified: 'Verified',
    offlineCacheVerifyIntegrity: 'Verify Integrity',
    offlineCacheClearAllFacilityCache: 'Clear All Facility Cache',
    offlineCacheDownloadByBasin: 'Download Facility Data by Basin',
    offlineCacheDownloadedCounties: 'Downloaded • {0}',
    offlineCacheUpdateButton: 'Update',
    offlineCacheFacilityDataLabel: 'Facility Data',
    offlineCacheFacilityDataHelp: 'Download well and facility information for offline search. Search works without internet once data is cached.',
    offlineCacheLoadFailed: 'Failed to load cache data. Make sure the API is running.',
    offlineCacheBasinDownloadFailed: 'Failed to download {0}. Please try again.',
    offlineCacheIntegrityFailed: 'Cache integrity check failed. Consider re-downloading.',
    offlineCacheVerifyFailed: 'Failed to verify cache integrity.',
    offlineBasinDelaware: 'Delaware Basin',
    offlineBasinPermian: 'Permian Basin',
    offlineBasinSanJuan: 'San Juan Basin',
    offlineBasinRaton: 'Raton Basin',
    offlineBasinTxPermian: 'TX Permian Basin',
    offlineBasinDelawareCounties: 'Eddy + Lea (NM)',
    offlineBasinPermianCounties: 'Southeast NM',
    offlineBasinSanJuanCounties: 'Northwest NM',
    offlineBasinRatonCounties: 'Northeast NM',
    offlineBasinTxPermianCounties: 'Midland, Ector, Andrews, + more',
    
    // StreetViewModal
    streetViewTitle: 'Street View Preview',
    streetViewNorth: 'North',
    streetViewEast: 'East',
    streetViewSouth: 'South',
    streetViewWest: 'West',
    streetViewNotAvailable: 'Street View not available at this location',
    streetViewUnavailable: 'Street View unavailable',
    streetViewLoading: 'Loading Street View...',
    streetViewFailed: 'Failed to load Street View',
    streetViewRotateLeft: 'Rotate left',
    streetViewRotateRight: 'Rotate right',
    streetViewPitchUp: 'Look up',
    streetViewPitchDown: 'Look down',
    streetViewClose: 'Close',
    streetViewPanorama: 'Full Panorama',
    streetViewMetadata: 'Street View Metadata',
    
    // PhotoGallery
    photoNoPhotos: 'No photos yet',
    photoTapToAdd: 'Tap to add the first photo',
    photoDeleteConfirm: 'Delete this photo? This cannot be undone.',
    photoDeleted: 'Photo deleted',
    photoDeleteFailed: 'Failed to delete photo',
    photoReportTitle: 'Report Photo',
    photoReportMessage: 'Why are you reporting this photo?',
    photoReportInappropriate: '🚫 Inappropriate',
    photoReportWrongLocation: '❌ Wrong Location',
    photoReportSpam: '📧 Spam',
    photoReportSubmitted: 'Report submitted. Thank you!',
    photoReportFailed: 'Failed to submit report',
    photoOf: 'Photo {0} of {1}',
    photoFullscreen: 'View fullscreen',
    photoSwipeToNavigate: 'Swipe to navigate',
    photo360: '360°',
    photoFacilityPhoto: 'Facility photo',
    photoDelete: 'Delete',
    photoReport: 'Report',
    
    // OnboardingDialog
    onboardingTitle: 'Offline Data',
    onboardingSubtitle: 'Download for field use',
    onboardingDescription: 'Access wells & facilities even without cell signal.',
    onboardingPriority: '⭐ Priority',
    onboardingRecommended: 'Recommended',
    onboardingAllCounties: '📦 All Counties',
    onboardingCompleteCoverage: 'Complete coverage • 32 NM counties',
    onboardingFastCDN: 'Fast CDN Mode',
    onboardingDontShowAgain: 'Don\'t show again',
    onboardingDownloading: 'Downloading...',
    onboardingSkipForNow: 'Skip for now',
    onboardingContinueUsing: 'Continue Using App',
    onboardingBackgroundNote: 'You can close this and continue using the app. Downloads run in background.',
    onboardingRemaining: '{0} remaining',

    // Timer Locations (Home/Work)
    timerLocationsTooltip: 'Timer locations',
    timerLocationsTitle: 'Home + Work Setup',
    timerLocationsSubtitleOnboarding: 'Used for your work timer',
    timerLocationsSubtitleEdit: 'Edit saved locations',
    timerLocationsPrivacy1: 'Saved on your device only.',
    timerLocationsPrivacy2: 'We don\u2019t save or view your home/work address on our servers.',
    timerLocationsPurpose: 'This helps start/stop the timer by location (so your hours can be recorded and shared via Telegram).',
    timerLocationsHomeLabel: 'Home address',
    timerLocationsWorkLabel: 'Work address',
    timerLocationsAddressPlaceholder: 'Search an address\u2026',
    timerLocationsUseCurrentLocation: 'Use current location',
    timerLocationsSkipForNow: 'Skip for now',
    timerLocationsClose: 'Close',
    timerLocationsSave: 'Save',
    timerLocationsConfirmIncomplete: 'Save with only one location set? We\u2019ll remind you later until both are set.',
    timerLocationsLocationRequired: 'Location required',
    timerLocationsLocationFailed: 'Unable to get your location',
    
    // LocationPermissionDialog  
    locationPermissionTitle: 'Location Access',
    locationPermissionDescription: 'ZiaWellNav wants to access your location',
    locationPermissionGrant: 'Allow',
    locationPermissionLater: 'Not Now',
    locationPermissionNever: 'Never Allow',
    locationPermissionIndefinitely: 'Allow Indefinitely',
    locationPermissionIndefinitelyDesc: 'Always allow location access without asking again',
    locationPermissionSession: 'Allow While Using App',
    locationPermissionSessionDesc: 'Allow until you close the app or for 24 hours',
    locationPermissionOnce: 'Allow Once',
    locationPermissionOnceDesc: 'Allow just this one time, ask again next time',
    
    // SubscriptionPanel
    subscriptionTitle: 'Upgrade to Premium',
    subscriptionMonthly: 'Monthly',
    subscriptionYearly: 'Yearly',
    subscriptionFreeTrial: 'Free Trial',
    subscriptionSubscribe: 'Subscribe Now',
    subscriptionCancel: 'Cancel Anytime',
    subscriptionFeature1: 'Unlimited searches',
    subscriptionFeature2: 'Offline maps',
    subscriptionFeature3: 'Premium support',
    
    // WellDetailsModal
    wellDetailsTitle: 'Well Details',
    wellDetailsAPI: 'API Number',
    wellDetailsOperator: 'Operator',
    wellDetailsStatus: 'Status',
    wellDetailsType: 'Type',
    wellDetailsLocation: 'Location',
    wellDetailsElevation: 'Elevation',
    wellDetailsDepth: 'Depth',
    wellDetailsProduction: 'Production',
    wellDetailsClose: 'Close',
    
    // AddFacilityForm
    addFacilityTitle: 'Add Facility',
    addFacilityName: 'Facility Name',
    addFacilityType: 'Facility Type',
    addFacilityLocation: 'Location',
    addFacilityNotes: 'Notes',
    addFacilitySubmit: 'Submit',
    addFacilityCancel: 'Cancel',
    
    // HomeSpeedDial
    homeAndLocation: 'Home & Location',
    homeResetMapView: 'Reset Map View',
    homeSetLocation: 'Set Home Location',
    homeUpdateHome: 'Update Home',
    homeNavigateHome: 'Navigate Home',
    
    // FriendsPanel
    friendsTitle: 'Friends',
    friendsShareInvite: 'Share Invite Link',
    friendsShareLocation: 'Share My Location',
    friendsShareLocationDesc: 'Let friends see your real-time location on the map',
    friendsTabFriends: 'Friends',
    friendsTabRequests: 'Requests',
    friendsAddByUsername: 'Add Friend by Username',
    friendsNoFriends: 'No friends yet. Add friends to share locations!',
    friendsNoPendingRequests: 'No pending friend requests',
    friendsLocationAvailable: 'Location available',
    friendsWaitingLocation: 'Waiting for location...',
    friendsLocationNotShared: 'Location not shared',
    friendsStopSharing: 'Stop sharing location',
    friendsStartSharing: 'Share your location',
    friendsNavigateTo: 'Navigate to friend',
    friendsRemoveFriend: 'Remove friend',
    friendsAddFriend: 'Add Friend',
    friendsEnterUsername: 'Enter your friend\'s Telegram username',
    friendsSendRequest: 'Send Request',
    friendsWantsToBeFriend: 'Wants to be your friend',
    // Vehicle Inspection
    preTrip: 'Pre-Trip',
    postTrip: 'Post-Trip',
    preTripUnlocksAfter: 'Post-Trip unlocks after you save a Pre-Trip.',
    vehicleInspection: 'Vehicle Inspection',
    vehicleType: 'Vehicle Type',
    otherVehicle: 'Other vehicle',
    unitNumber: 'Truck # / Unit #',
    truckTagNumber: 'Truck Tag #',
    trailerNumber: 'Trailer #',
    trailerTagNumber: 'Trailer Tag #',
    equipmentNumbers: 'Equipment # (items on trailer — comma separated)',
    equipmentNumbersPlaceholder: 'e.g. EQ-101, EQ-202',
    odometer: 'Odometer',
    engineHours: 'Engine Hours',
    addEngineHours: 'Add engine hours',
    defectsNotes: 'Defects / Notes',
    hasTrailer: 'Has Trailer',
    yourName: 'Your Name',
    shareNote: 'Note for Telegram share (optional)',
    shareNotePlaceholder: 'e.g. Pre/Post trip reports for Truck 12',
    driverSeatInCab: 'Driver Seat (In-Cab)',
    driverSideFront: 'Driver Side Front',
    frontOfVehicle: 'Front of Vehicle',
    passengerSideFront: 'Passenger Side Front',
    rearOfVehicle: 'Rear of Vehicle',
    underHoodEngine: 'Under Hood / Engine',
    emergencyEquipment: 'Emergency Equipment',
    trailerWalkAround: 'Trailer Walk-Around',
    ratingGreat: 'Great',
    ratingOk: 'OK',
    ratingBad: 'Bad',
    submitPreTrip: 'Save Pre-Trip Inspection',
    submitPostTrip: 'Save Post-Trip Inspection',
    inspectionSaved: 'Inspection saved!',
    preTripHistory: 'Pre-Trip History',
    postTripHistory: 'Post-Trip History',
    viewPreTripHistory: 'Pre-Trip History',
    viewPostTripHistory: 'Post-Trip History',
    preTripReminderToast: 'Complete your pre-trip inspection before heading out.',
    postTripReminderToast: 'You’re back at {0}. Complete your post-trip inspection.',
    noInspectionsFound: 'No inspections found',
    signatureRequired: 'Please sign or type your name to submit.',
    walkAroundChecklist: 'Walk-Around Checklist',
    signAndSubmit: 'Sign & Submit',
    typeYourName: 'Type Your Name',
    drawSignature: 'Draw Signature',
    clearSignature: 'Clear',
    sendToTelegram: 'Send to Telegram',
    sendToCrew: 'Send to Crew',
    shareInspection: 'Share Inspection',
    inspectionType: 'Inspection Type',
    vehicleInfo: 'Vehicle Info',
    checklistComplete: 'Checklist complete',
    defectsFound: 'Defects found',
    noDefects: 'No defects',
    tapToRate: 'Tap to rate',
    locationRecorded: 'Location recorded',
    addPhoto: 'Add Photo',
    viewPhotos: 'View Photos',
    inspectionDetails: 'Inspection Details',
    submittedBy: 'Submitted by',
    submittedAt: 'Submitted at',
    closeInspection: 'Close',
    // JSA (Job Safety Analysis)
    jsaHistory: 'JSA History',
    jobSafetyAnalysis: 'Job Safety Analysis',
    locationAndJob: 'Location & Job',
    hazardsAndControls: 'Hazards & Controls',
    emergencyInfo: 'Emergency Info',
    reviewAndSign: 'Review & Sign',
    apiNumberLabel: 'API Number',
    apiNumberPlaceholder: '30-039-12345',
    wellFacilityName: 'Well / Facility Name',
    operatorLabel: 'Operator',
    otherOperator: 'Other Operator',
    countyLabel: 'County',
    otherCounty: 'Other County',
    stateLabel: 'State',
    otherState: 'Other State',
    jobTypeLabel: 'Job Type',
    otherJobType: 'Other Job Type',
    jobDescriptionLabel: 'Job Description',
    describeJobStep: 'Describe job step...',
    addStep: 'Add Step',
    removeStep: 'Remove Step',
    hazardLabel: 'Hazard',
    customHazard: 'Custom hazard...',
    controlMitigation: 'Control / mitigation',
    riskLevelLabel: 'Risk Level',
    riskLow: 'Low',
    riskMedium: 'Medium',
    riskHigh: 'High',
    riskCritical: 'Critical',
    addHazard: 'Add Hazard',
    removeHazard: 'Remove Hazard',
    ppeRequiredLabel: 'PPE Required',
    windDirectionLabel: 'Wind Direction',
    musterPointLabel: 'Muster Point',
    selectMusterPoint: 'Select Muster Point',
    musterPointPin: 'Pin',
    musterPointDraw: 'Draw',
    tapMapDropPin: 'Tap the map to drop a muster point pin. Drag to reposition.',
    drawFingerHighlight: 'Draw with your finger to highlight the muster area.',
    nearestHospitalLabel: 'Nearest Hospital',
    hospitalDirectionsLabel: 'Hospital Directions',
    emergencyContacts: 'Emergency Contacts',
    addContact: 'Add Contact',
    contactName: 'Name',
    contactPhone: 'Phone',
    contactRole: 'Role',
    h2sPresent: 'H₂S Present',
    h2sReading: 'H₂S Reading (ppm)',
    stopWorkAuthority: 'Stop Work Authority',
    stopWorkAcknowledge: 'I acknowledge Stop Work Authority — I will stop work if conditions become unsafe.',
    signerName: 'Your Name / Signature',
    signerRole: 'Role / Title',
    addSigner: 'Add Another Signer',
    removeSigner: 'Remove Signer',
    saveAndSignJsa: 'Save & Sign JSA',
    shareJsa: 'Share JSA for Signing',
    jsaSaved: 'JSA saved & signed!',
    noJsasFound: 'No JSAs found',
    jsaStep1: 'Step 1',
    jsaStep2: 'Step 2',
    jsaStep3: 'Step 3',
    jsaStep4: 'Step 4',
    jsaNumber: 'JSA #',
    jsaStatus: 'Status',
    jsaActive: 'active',
    jsaCompleted: 'completed',
    jsaDraft: 'draft',
    jsaCreatedAt: 'Created',
    jsaOpenForSigning: 'Open for Signing',
    jsaAlreadySigned: 'Already Signed',
    jsaSignedBy: 'Signed by',
    jsaAt: 'at',
    drawYourSignature: 'Draw your signature',
    clearSignatureDraw: 'Clear',
    typeInsteadDraw: 'Type Instead',
    drawInstead: 'Draw Instead',
    enterNamePlaceholder: 'Enter your name...',
    jobSteps: 'Job Steps',
    noStepsAdded: 'No steps added yet',
    noHazardsAdded: 'No hazards added yet',
    notesLabel: 'Notes',
    company: 'Company',
    // WellDetailsModal
    routePreviewLabel: '📍 Route Preview',
    distanceLabel: 'Distance',
    estTimeLabel: 'Est. Time',
    viaSummary: 'via {0}',
    calicheRoutesLabel: '🛣️ Caliche Routes',
    routeFromLabel: 'From: {0}',
    waypointsCount: '{0} waypoints',
    wellOperatorLabel: 'Operator',
    wellCountyLabel: 'County',
    wellBasinLabel: 'Basin',
    wellCoordsLabel: 'Coords',
    wellRegulatoryTitle: 'Regulatory Detail',
    wellTxRegulatoryTitle: 'Texas Regulatory Detail',
    wellRegulatorySubtitle: 'Lease, field, pool, depth, lifecycle, and wellbore profile markers for this well.',
    wellLeaseProductionBadge: 'Lease Production',
    wellRegulatoryLoading: 'Loading enriched well detail...',
    wellRegulatoryEmpty: 'No regulatory detail is available for this well yet.',
    wellRegulatoryLease: 'Lease',
    wellRegulatoryDistrict: 'District',
    wellRegulatoryOilGas: 'Oil/Gas',
    wellRegulatoryWellNumber: 'Well Number',
    wellRegulatoryField: 'Field',
    wellRegulatoryPool: 'Pool',
    wellRegulatoryWellType: 'Well Type',
    wellRegulatorySpud: 'Spud',
    wellRegulatoryCompletion: 'Completion',
    wellRegulatoryPlugDate: 'Plug Date',
    wellRegulatoryTotalDepth: 'Total Depth',
    wellRegulatoryLateral: 'Lateral',
    wellTxPermitTitle: 'Texas Permit Detail',
    wellTxPermitSubtitle: 'Latest matched RRC drilling permit for this well.',
    wellTxPermitLoading: 'Loading matched permit detail...',
    wellTxPermitPermit: 'Permit',
    wellTxPermitStatus: 'Status',
    wellTxPermitPermitDate: 'Permit Date',
    wellTxPermitSubmitted: 'Submitted',
    wellTxPermitType: 'Permit Type',
    wellTxPermitOperatorNumber: 'Operator No.',
    wellTxPermitField: 'Field',
    wellTxPermitPlannedDepth: 'Planned Depth',
    wellTxPermitLateral: 'Lateral',
    wellTxH2STitle: 'Texas H2S Record',
    wellTxH2SSubtitle: 'Official TX RRC Form H-9 compliance data matched to this site.',
    wellTxH2SLoading: 'Loading matched H-9 detail...',
    wellTxH2SReportedPpm: 'Reported H2S',
    wellTxH2SReportedFlow: 'Reported Flow',
    wellTxH2SRoe100: '100 ppm ROE',
    wellTxH2SRoe500: '500 ppm ROE',
    wellTxH2SApprovalDate: 'H-9 Approved',
    wellTxH2STermDate: 'H-9 Term Date',
    wellTxH2SAmendedDate: 'H-9 Amended',
    wellTxH2SDrillDepth: 'Drilling Compliance Depth',
    wellTxH2SOperator: 'Operator',
    wellTxH2SOperatorNumber: 'Operator No.',
    wellTxH2SLease: 'Lease / Facility',
    wellTxH2SFacilityNumber: 'Lease / Facility No.',
    wellTxH2SFacilityId: 'Facility ID',
    wellTxH2SFacilityType: 'Facility Type',
    wellTxH2SField: 'Field',
    wellTxH2SCounty: 'County',
    wellTxH2SMatchBasis: 'Match Basis',
    wellTxH2SSource: 'Source',
    wellTxH2SComments: 'Comments',
    wellTxH2SMatchLease: 'Lease Number Match',
    wellTxH2SMatchFacilityNumber: 'Facility Number Match',
    wellTxH2SMatchFacilityId: 'Facility ID Match',
    wellTxH2STermActive: 'Term Active',
    wellTxH2STermExpired: 'Term Expired',
    wellTxH2SCard: 'H2S Record',
    wellTxOfficialWaterTitle: 'Texas Official Water',
    wellTxOfficialWaterSubtitle: 'Official RRC W-10/G-10 status-test water rate. Not a monthly produced-water total.',
    wellTxOfficialWaterLoading: 'Loading official TX water test rate...',
    wellTxOfficialWaterRate: 'Water Test Rate',
    wellTxOfficialWaterSource: 'Source Form',
    wellTxOfficialWaterTestDate: 'Test Date',
    wellTxOfficialWaterEffectiveDate: 'Effective Date',
    wellTxOfficialWaterCycle: 'Cycle Month',
    wellTxOfficialWaterLeaseKey: 'Lease Key',
    wellTxOfficialWaterMatchedApi: 'Matched API',
    wellTxOfficialWaterMatch: 'Match Confidence',
    wellTxOfficialWaterAvailable: 'Official',
    wellTxOfficialWaterUnavailable: 'Unavailable',
    wellTxOfficialWaterUnavailableText: 'Official TX water test rate unavailable.',
    wellTxOfficialWaterWarning: 'Official test rate, not monthly produced-water total.',
    wellLifecycleTitle: 'Lifecycle Timeline',
    wellLifecycleSubtitle: 'Key permitting, drilling, completion, and production milestones.',
    wellLifecycleLoading: 'Loading lifecycle detail...',
    wellLifecycleEmpty: 'No lifecycle milestones are available for this site yet.',
    wellLifecyclePermitSubmitted: 'Permit Submitted',
    wellLifecyclePermitApproved: 'Permit Approved',
    wellLifecycleSpud: 'Spud',
    wellLifecycleCompletion: 'Completion',
    wellLifecycleFirstProduction: 'First Production',
    wellLifecycleLatestProduction: 'Latest Production',
    wellLifecyclePlug: 'Plug Date',
    wellLifecycleLatestActivity: 'Latest Activity',
    wellLifecycleLatestActivityPermit: 'Permit',
    wellLifecycleLatestActivityProduction: 'Production',
    wellLifecycleLatestActivityCompletion: 'Completion',
    wellLifecycleLatestActivityPlug: 'Plug',
    wellLifecycleLatestActivitySpud: 'Spud',
    wellTxActivityTitle: 'Texas Activity Snapshot',
    wellTxActivitySubtitle: 'Current operator identity and recent lease production for this well.',
    wellTxActivityLoading: 'Loading recent Texas activity...',
    wellTxActivityOperator: 'Operator',
    wellTxActivityOperatorNumber: 'Operator No.',
    wellTxActivityLease: 'Lease',
    wellTxActivityField: 'Field',
    wellTxActivityLatestMonth: 'Latest Reported Month',
    wellTxActivityLatestVolumes: 'Latest Volumes',
    wellTxActivityTrailing3: '3-Month Total',
    wellTxActivityTrailing6: '6-Month Total',
    wellTxActivityTrailing12: '12-Month Total',
    wellTxActivityTrendUp: 'Trend Up',
    wellTxActivityTrendDown: 'Trend Down',
    wellTxActivityTrendFlat: 'Trend Flat',
    wellTxActivityOilAmount: '{0} bbl oil',
    wellTxActivityGasAmount: '{0} mcf gas',
    wellTxActivityCondensateAmount: '{0} bbl cond.',
    wellTxViolationTitle: 'Texas Violation Detail',
    wellTxViolationSubtitle: 'Recent RRC inspection findings matched to this well or lease.',
    wellTxViolationLoading: 'Loading matched violation detail...',
    wellTxViolationCount: '{0} recent',
    wellTxViolationOpenCount: '{0} open',
    wellTxViolationInspection: 'Inspection',
    wellTxViolationPenalty: 'Penalty',
    wellTxViolationInspected: 'Inspected',
    wellTxViolationResolved: 'Resolved',
    wellTxViolationApiMatch: 'API Match',
    wellTxViolationLeaseMatch: 'Lease Match',
    wellNearbyOpsTitle: 'Nearby Ops Context',
    wellNearbyOpsSubtitle: 'Lease siblings and the closest supporting Texas facilities.',
    wellNearbyOpsLoading: 'Loading nearby ops context...',
    wellNearbyOpsEmpty: 'No nearby ops context is available for this site yet.',
    wellNearbyOpsSameLease: 'Same Lease Siblings',
    wellNearbyOpsSameField: 'Same Field Wells',
    wellNearbyOpsRoutes: 'Routes',
    wellNearbyOpsNearestSwd: 'Nearest SWD',
    wellNearbyOpsNearestGasPlant: 'Nearest Gas Plant',
    wellNearbyOpsNearestPipeline: 'Nearest Pipeline',
    wellNearbyOpsMiles: '{0} mi',
    wellFacilityOpsTitle: 'Facility Detail',
    wellFacilityOpsSwdTitle: 'SWD Detail',
    wellFacilityOpsRigTitle: 'Rig Detail',
    wellFacilityOpsPipelineTitle: 'Pipeline Detail',
    wellFacilityOpsSubtitle: 'Operational and registry detail for this facility.',
    wellFacilityOpsLoading: 'Loading facility detail...',
    wellFacilityDetailPermit: 'Permit',
    wellFacilityDetailSerial: 'Serial',
    wellFacilityDetailCapacity: 'Capacity',
    wellFacilityDetailCapacityMcf: 'Plant Capacity',
    wellFacilityDetailWellDepth: 'Well Depth',
    wellFacilityDetailWellType: 'Well Type',
    wellFacilityDetailPool: 'Pool',
    wellFacilityDetailRigType: 'Rig Type',
    wellFacilityDetailContractor: 'Contractor',
    wellFacilityDetailCurrentWell: 'Current Well',
    wellFacilityDetailSystem: 'System',
    wellFacilityDetailSubsystem: 'Subsystem',
    wellFacilityDetailCommodity: 'Commodity',
    wellFacilityDetailDiameter: 'Diameter',
    wellFacilityDetailSystemType: 'System Type',
    wellFacilityDetailLength: 'Length',
    wellFacilityDetailInterstate: 'Interstate',
    wellFacilityDetailCommonCarrier: 'Common Carrier',
    wellFacilityDetailDistrict: 'District',
    wellFacilityDetailSymbology: 'Symbology',
    wellFacilityDetailSource: 'Source',
    wellFacilityDetailYes: 'Yes',
    wellFacilityDetailNo: 'No',
    unknownLabel: 'Unknown',
    notAvailable: 'N/A',
    wellRelatedWells: 'Related Wells',
    wellRelatedWellsSubtitle: 'Nearby context from the same lease or matching field/pool records.',
    wellLoadingDetail: 'Loading detail',
    wellRouteCountSingle: '{0} Route',
    wellRouteCountMultiple: '{0} Routes',
    wellRouteToDestination: 'Route to {0}',
    googleMapsBtn: 'Google Maps',
    createJsaBtn: 'Create JSA',
    createJobSafetyAnalysis: 'Create Job Safety Analysis',
    startInAppNav: 'Visual 2D Route',
    startArNav: 'Start AR Navigation',
    arNavigation: 'AR Navigation',
    calculating: 'Calculating...',
    appLoadingBrand: 'Loading ZiaWellNav...',
    inspectionReportTitle: 'Vehicle Inspection Report',
    downloadPdfBtn: 'Download PDF',
    loadingInspection: 'Loading inspection...',
    inspectionLoadFailedHttp: 'Failed to load inspection (HTTP {0})',
    inspectionLoadFailed: 'Failed to load inspection',
    jsaReportTitle: 'JSA Report',
    loadingJsa: 'Loading JSA...',
    jsaNotFound: 'JSA not found',
    jsaLoadFailedHttp: 'Failed to load JSA (HTTP {0})',
    jsaLoadFailed: 'Failed to load JSA',
    jsaSitePhotoLimitToast: 'JSA site photos are limited to 6',
    jsaSitePhotoLimitDetail: 'Only 6 site photos can be attached to a JSA',
    jsaSavedSignedWithPhotoFailures: 'JSA saved & signed. {0} site photo{1} did not upload.',
    jsaSavedSignedNumber: 'JSA {0} saved & signed!',
    failedToSaveJsa: 'Failed to save JSA',
    signThisJsa: 'Sign this JSA: {0}{1}',
    signJsaTitle: 'Sign JSA',
    failedToShareJsa: 'Failed to share JSA',
    optionalJsaPhotosPdf: 'Optional photos are included in the JSA PDF.',
    previousJsaTemplateLoaded: 'Previous JSA loaded as template - modify as needed',
    jsaAutoExpiresDistance: 'JSA auto-expires when all signatories are this far from the site',
    jsaSummaryTitle: 'JSA Summary',
    signJsa: 'Sign JSA',
    archivedJsa: 'Archived JSA',
    archivedJsaReadOnly: '{0} has been archived and cannot be edited or signed. View the PDF for a record.',
    activeJsaNeedsSignature: 'Active JSA at {0} needs your signature',
    stationaryJsaPrompt: 'You’ve been on location {0}+ minutes at {1}. Complete a JSA?',
    jsaSavedToast: 'JSA saved',
    shareViaTelegram: 'Share via Telegram',
    timesheetPanelTitle: 'My Timesheet',
    timesheetMyTime: 'My Time',
    timesheetCrewTime: 'Crew Time',
    thisWeek: 'This Week',
    thisMonth: 'This Month',
    unknownUser: 'Unknown User',
    inProgress: 'In Progress',
    hoursThisWeek: 'Hours This Week',
    milesThisWeek: 'Miles This Week',
    exportCsv: 'Export CSV',
    dailyBreakdown: 'Daily Breakdown',
    timeEntriesCount: 'Time Entries ({0})',
    noTimeEntriesPeriod: 'No time entries found for this period. Start the timer to begin tracking!',
    gpsTrailPoints: 'GPS Trail ({0} points)',
    viewMapTrail: 'View Map Trail',
    noGpsDataRecorded: 'No GPS data recorded for this entry',
    submittedTimesheets: 'Submitted Timesheets',
    timesheetSubmittedStatus: 'Submitted',
    timesheetAcknowledgedStatus: 'Acknowledged',
    timesheetRejectedStatus: 'Rejected',
    timesheetDraftStatus: 'Draft',
    gpsTrailTitle: 'GPS Trail - {0}',
    noGpsCoordinatesEntry: 'No GPS coordinates recorded for this entry',
    timesheetLeadEmailDetail: 'Lead email: {0}',
    timesheetChargeReadyDetail: '{0}/{1} entries charge-ready for {2}.',
    timesheetNoUnsubmittedDetail: 'No unsubmitted completed entries for {0}.',
    verifyingSubscription: 'Verifying subscription...',
    subscriptionGateSubtitle: 'Subscribe to access navigation, safety & AI tools',
    subscriptionActivating: 'Activating subscription...',
    subscriptionRequiredAccess: 'Subscription required to access the app.',
    subscriptionVerifyFailed: 'Unable to verify your subscription right now. Check your connection or link your purchase.',
    subscriptionLinkTitle: 'Already paid? Link your purchase',
    subscriptionLinkSubtitle: 'Use your current Telegram account first. If that cannot find the purchase, link by Stripe checkout email.',
    linkTelegramPurchaseBtn: 'Link with Telegram',
    subscriptionEmailFallbackLabel: 'Or link by purchase email',
    purchaseEmailPlaceholder: 'you@email.com',
    linkPurchaseBtn: 'Link Purchase',
    linkingPurchase: 'Linking...',
    purchaseLinkedLoading: 'Purchase linked! Loading your subscription...',
    purchaseLinkedRefreshing: 'Purchase linked! Refreshing...',
    purchaseNotFound: 'No purchase found for that email.',
    telegramPurchaseNotFound: 'No purchase found for this Telegram account.',
    subscriptionShowPlans: 'Need to subscribe? View plans ▼',
    subscriptionHidePlans: 'Hide plans ▲',
    // CertVaultDialog
    businessSeatsTitle: 'Business Seats',
    businessSeatsDesc: 'Enter the billing email you used at checkout to load your seat keys. Share a key or link with each teammate; each key can be claimed once.',
    loadBtnLabel: 'Load',
    loadFromCloudBtn: 'Load from Cloud',
    syncToCloudBtn: 'Sync to Cloud',
    passphraseLabel: 'Passphrase (optional)',
    passphraseHelperText: 'Adds extra encryption; must match on all devices.',
    cardTitleLabel: 'Card Title',
    categoryOrCourse: 'Category / Course',
    issuerLabel: 'Issuer',
    issuedLabel: 'Issued',
    expiresLabel: 'Expires',
    addFrontBtn: 'Add Front',
    replaceFrontBtn: 'Replace Front',
    addBackBtn: 'Add Back (optional)',
    replaceBackBtn: 'Replace Back',
    saveCardBtn: 'Save Card',
    noCardsSaved: 'No cards saved yet.',
    frontLabel: 'Front',
    backLabel: 'Back',
    claimBtn: 'Claim',
    pasteLicenseKey: 'Paste license key',
    claimLicenseDesc: 'Or paste a license key to claim this seat for your account.',
    certSyncing: 'Syncing…',
    // LandmarksBottomSheet
    tapToSelectThenMap: 'Tap to select, then tap map',
    dragLandmarksOntoMap: 'Drag landmarks onto map',
    closeLandmarks: 'Close landmarks',
    undoLandmarkTooltip: 'Undo last landmark ({0} placed)',
    noLandmarksToUndo: 'No landmarks to undo',
  },
  es: {
    // Search
    searchPlaceholder: 'Diga el # API, Nombre del Pozo, o Tipo',
    searchPlaceholderHint: 'ej. "compresor" o "quemador"',
    searchResults: 'Resultados de Búsqueda',
    noResults: 'No se encontraron resultados',
    byFacilityType: 'Por Tipo de Instalación',
    noFilteredResults: 'Ningún resultado coincide con tus filtros. Ajusta o limpia los filtros.',
    tryDifferentSearch: 'Prueba otra búsqueda o revisa tus filtros',
    letters: 'Letras',
    secondLetters: 'Segunda letra',
    thirdLetters: 'Tercera letra',
    fourthLetters: 'Cuarta letra',
    loadingResults: 'Cargando resultados...',
    noTypeFound: 'No se encontraron {0}',
    showingCountOf: 'Mostrando {0} de {1} resultados',
    searchingFor: 'Buscando',
    results: 'resultados',
    result: 'resultado',
    cachedLabel: 'en caché',
    liveLabel: 'en vivo',
    
    // Navigation
    navigate: 'Navegar',
    getDirections: 'Obtener Direcciones',
    startNavigation: 'Iniciar Navegación',
    
    // Favorites
    favorites: 'Favoritos',
    noFavorites: 'Aún no hay instalaciones guardadas',
    tapToSave: 'Toca el ícono de estrella para guardar',
    savedFacilities: 'instalaciones guardadas',
    savedFacility: 'instalación guardada',
    removeFromFavorites: 'Eliminar de favoritos',
    addToFavorites: 'Agregar a favoritos',
    
    // Facility types
    all: 'Todo',
    well: 'Pozo',
    rig: 'Plataforma',
    swd: 'SWD',
    facility: 'Instalación',
    wells: 'Pozos',
    rigs: 'Plataformas',
    swds: 'SWDs',
    tankBattery: 'Batería de Tanques',
    flareStack: 'Quemador',
    compressor: 'Compresor',
    gasPlant: 'Planta de Gas',
    brineWell: 'Pozo de Salmuera',
    refinery: 'Refinería',
    treatingPlant: 'Planta de Tratamiento',
    wellHead: 'Cabezal de Pozo',
    gasGathering: 'Recolección de Gas',
    injectionPlant: 'Planta de Inyección',
    gasPipeline: 'Tubería de Gas',
    crudePipeline: 'Tubería de Crudo',
    waterPipeline: 'Tubería de Agua',
    gasStorage: 'Almacén de Gas',
    belowGradeTank: 'Tanque Subterráneo',
    meteringStation: 'Estación de Medición',
    crudePump: 'Bomba de Crudo',
    pumpJack: 'Bomba de Balancín',
    pits: 'Fosas',
    pitGeneral: 'Fosa (General)',
    pitEmergency: 'Fosa (Emergencia)',
    pitTemporary: 'Fosa (Temporal)',
    pitPermanent: 'Fosa (Permanente)',
    pitMultiWell: 'Fosa (Multi-pozo)',
    sump: 'Sump',
    wasteMgmt: 'Gestión de Residuos',
    recycling: 'Reciclaje',
    sewerWastewater: 'Alcantarillado / Aguas Residuales',
    facilitySourceOfficial: 'Fuente oficial',
    facilitySourceOfficialShort: 'Oficial',
    facilitySourceOfficialLowCount: 'Conteo oficial bajo',
    facilitySourceOfficialLowCountShort: 'Bajo',
    facilitySourceSupplementalPublic: 'Fuente pública suplementaria',
    facilitySourceSupplementalPublicShort: 'Pública',
    facilitySourcePending: 'Fuente pendiente',
    facilitySourcePendingShort: 'Pendiente',
    facilitySourceUnavailable: 'Fuente no disponible',
    facilitySourceUnavailableShort: 'No disp.',
    facilitySourceOfficialMessage: 'Esta tarjeta de instalación está respaldada por registros oficiales con coordenadas.',
    facilitySourceOfficialLowCountMessage: 'Este conteo es bajo porque la fuente oficial solo tiene pocos registros en este distrito o condado.',
    facilitySourceHiddenUnsupportedMessage: 'Esta tarjeta está oculta hasta que exista una fuente confiable con coordenadas.',
    facilitySourceSupplementalPublicMessage: 'Los registros públicos suplementarios se etiquetan claramente y no reemplazan las fuentes oficiales.',
    facilitySourceUnavailableMessage: 'Todavía no hay una fuente oficial con coordenadas importada.',
    remediate: 'Remediación',
    abatement: 'Mitigación',
    abatementPlan: 'Plan de Atenuación',
    serviceCo: 'Servicio',
    classIII: 'Clase I/II',
    classI: 'Clase I',
    classII: 'Clase II',
    ocdIncidents: 'Incidentes OCD',
    portaPotty: 'Letrina Portátil',
    wellPad: 'Plataforma de Pozo',
    frackingSite: 'Sitio de Fractura',
    drillingSite: 'Sitio de Perforación',
    location: 'Cerca de mí',
    activeOps: 'Ops Activas',
    more: 'Todos los tipos',
    dryHole: 'Pozo Seco',
    oilWell: 'Pozo de Aceite',
    oilGasWell: 'Pozo de Aceite/Gas',
    horizontalWell: 'Pozo Horizontal',
    directionalWell: 'Pozo Direccional',
    injectionWell: 'Pozo de Inyección',
    saltWaterDisposal: 'Disposición de Agua Salada',
    waterWell: 'Pozo de Agua',
    co2Well: 'Pozo CO2',
    permitted: 'Permitido',
    canceled: 'Cancelado',
    pluggedOil: 'Taponado (Aceite)',
    pluggedGas: 'Taponado (Gas)',
    pluggedOilGas: 'Taponado (Aceite/Gas)',
    shutInOil: 'Cerrado (Aceite)',
    shutInGas: 'Cerrado (Gas)',
    storage: 'Almacenamiento',
    storageOil: 'Almacenamiento de Aceite',
    storageGas: 'Almacenamiento de Gas',
    sulfurCore: 'Núcleo de Azufre',
    serviceWell: 'Pozo de Servicio',
    unknownWell: 'Pozo Desconocido',
    miscellaneous: 'Misceláneo',
    otherLabel: 'Otro',
    waterSupply: 'Suministro de Agua',
    brineMining: 'Extracción de Salmuera',
    coreTest: 'Prueba de Núcleo',
    observationWell: 'Pozo de Observación',
    unknownFacility: 'Instalación Desconocida',
    commercialSwdTx: 'SWD Comercial (TX)',
    tacoTruck: 'Camión de Tacos',
    tacoTruckName: 'Nombre del Camión',
    enterTruckName: 'Ingresa el nombre del camión de tacos',
    tacoTruckMarked: 'Ubicación del camión de tacos marcada',
    tacoNameExists: 'Un camión de tacos con este nombre ya existe hoy',
    showTacoLocations: 'Mostrar ubicaciones de camiones de tacos',
    burger: 'Hamburguesa',
    coffee: 'Café',
    cafe: 'Cafetería',
    shake: 'Malteada',
    bakery: 'Panadería',
    foodTruck: 'Camión de Comida',
    automotive: 'Servicio Automotriz',
    parts: 'Refacciones',
    vape: 'Tienda de Vapeo',
    marijuana: 'Dispensario',
    fuel: 'Combustible',
    waterStation: 'Estación de Agua',
    supplies: 'Suministros',
    searchFacilityTypes: 'Buscar en {0} Tipos de Instalaciones',
    searchFacilities: 'Buscar Instalaciones',
    communityFacilitiesTitle: 'Instalaciones Comunitarias',
    communityFacilitiesSearchPlaceholder: 'Buscar instalaciones...',
    communityFacilitiesNoMatch: 'No hay instalaciones que coincidan con tu búsqueda',
    communityFacilitiesEmpty: 'Aún no hay instalaciones agregadas',
    communityFacilitiesGoogleMaps: 'Google Maps',
    communityFacilitiesViewPhotos: 'Ver Fotos',
    communityFacilitiesAddPhotoFirst: '¡Sé el primero en agregar una foto!',
    communityFacilitiesLoadFailed: 'No se pudieron cargar las instalaciones',
    communityFacilitiesCopyFailed: 'No se pudo copiar el texto',
    searchAddress: 'Buscar Dirección',
    treating: 'Tratamiento',
    injection: 'Inyección',
    // Oil Well alphabetical ranges (10 cards for ~10K each)
    oilWell0B: 'Petróleo 0-B',
    oilWellCD: 'Petróleo C-D',
    oilWellEF: 'Petróleo E-F',
    oilWellGH: 'Petróleo G-H',
    oilWellIK: 'Petróleo I-K',
    oilWellLM: 'Petróleo L-M',
    oilWellNO: 'Petróleo N-O',
    oilWellPR: 'Petróleo P-R',
    oilWellST: 'Petróleo S-T',
    oilWellUZ: 'Petróleo U-Z',
    // Gas Well (single card)
    gasWell: 'Pozo de Gas',
    // Horizontal Well alphabetical ranges (10 cards for TX)
    horizontal0B: 'Horiz 0-B',
    horizontalCD: 'Horiz C-D',
    horizontalEF: 'Horiz E-F',
    horizontalGH: 'Horiz G-H',
    horizontalIK: 'Horiz I-K',
    horizontalLM: 'Horiz L-M',
    horizontalNO: 'Horiz N-O',
    horizontalPR: 'Horiz P-R',
    horizontalST: 'Horiz S-T',
    horizontalUZ: 'Horiz U-Z',
    gasLine: 'Línea de Gas',
    crudeLine: 'Línea de Crudo',
    waterLine: 'Línea de Agua',
    gasGather: 'Rec. de Gas',
    metering: 'Medición',
    belowGrade: 'Subterráneo',
    
    // Actions
    copy: 'Copiar',
    copied: '¡Copiado!',
    apiCopied: 'API {0} copiado!',
    delete: 'Eliminar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    close: 'Cerrar',
    save: 'Guardar',
    share: 'Compartir',
    saveSettings: 'Guardar Configuración',
    submit: 'Enviar',
    add: 'Agregar',
    remove: 'Quitar',
    edit: 'Editar',
    
    // Status
    loading: 'Cargando...',
    offline: 'Sin Conexión',
    online: 'En Línea',
    active: 'Activo',
    inactive: 'Inactivo',
    error: 'Error',
    success: 'Éxito',
    
    // FAB tooltips
    addFacility: 'Agregar Nueva Instalación',
    activeOperations: 'Operaciones Activas',
    toggleTheme: 'Cambiar Tema',
    toggleLanguage: 'Switch to English',
    viewOnMap: 'Ver en Mapa',
    lightMode: 'Modo Claro',
    darkMode: 'Modo Oscuro',
    highContrast: 'Alto Contraste',
    normalContrast: 'Contraste Normal',
    
    // Map
    mapView: 'Vista de Mapa',
    listView: 'Vista de Lista',
    satellite: 'Satélite',
    terrain: 'Terreno',
    
    // Filters
    allCounties: 'Todos los Condados',
    filterByCounty: 'Filtrar por Condado',
    filterByType: 'Filtrar por Tipo',
    filterByOperator: 'Filtrar por Operador',
    filterByStatus: 'Filtrar por Estado',
    allStatus: 'Todos los Estados',
    allTypes: 'Todos los Tipos',
    allOperators: 'Todos los Operadores',
    sortAZ: 'Ordenar A-Z',
    sortZA: 'Ordenar Z-A',
    clearFilters: 'Limpiar Filtros',
    filter: 'filtro',
    filters: 'filtros',
    
    // Voice
    tapToSpeak: 'Toca para hablar',
    searchHint: 'Diga el # API, Nombre del Pozo, o Tipo',
    searchHintFallback: 'ej. "compresor" o "quemador"',
    listening: 'Escuchando...',
    voiceNavigation: 'Navegación por Voz',
    speakDestination: 'Diga su destino',
    recentSearches: 'Búsquedas Recientes:',
    searchBelow: 'Escribe para Buscar',
    voiceNotSupported: 'Voz no disponible',
    
    // Facility details
    apiNumber: 'Número API',
    operator: 'Operador',
    county: 'Condado',
    status: 'Estado',
    distance: 'Distancia',
    miles: 'millas',
    feet: 'pies',
    coordinates: 'Coordenadas',
    lat: 'LAT',
    lng: 'LNG',
    latitude: 'Latitud',
    longitude: 'Longitud',
    wellName: 'Nombre del Pozo',
    wellType: 'Tipo de Pozo',
    pool: 'Piscina',
    district: 'Distrito',
    township: 'Municipio',
    range: 'Rango',
    section: 'Sección',
    
    // Directions
    turnLeft: 'Gire a la izquierda',
    turnRight: 'Gire a la derecha',
    continueOn: 'Continúe en',
    arrive: 'Llegue a su destino',
    inMiles: 'en {0} millas',
    inFeet: 'en {0} pies',
    
    // Onboarding
    welcome: 'Bienvenido',
    getStarted: 'Comenzar',
    skip: 'Omitir',
    next: 'Siguiente',
    back: 'Atrás',
    
    // Errors
    locationError: 'No se pudo obtener su ubicación',
    networkError: 'Error de red. Inténtelo de nuevo.',
    searchError: 'Error en la búsqueda. Inténtelo de nuevo.',
    
    // Time
    lastUpdated: 'Última actualización',
    justNow: 'Ahora mismo',
    minutesAgo: 'hace {0} minutos',
    hoursAgo: 'hace {0} horas',
    daysAgo: 'hace {0} días',
    
    // Crews
    myCrews: 'Mis Equipos',
    addCrew: 'Agregar Equipo',
    crewName: 'Nombre del Equipo',
    crewMembers: 'Miembros del Equipo',
    
    // Landing Page - Hero Section
    heroTagline: 'Inteligencia de Campo Para Equipos Petroleros',
    heroSubtagline: 'Navega más rápido. Trabaja más seguro. Conserva mejores registros.',
    heroDescription: 'ZiaWellNav ayuda a las cuadrillas a encontrar pozos e instalaciones, navegar caminos petroleros, completar JSAs y formularios de campo, recibir alertas de peligro, y gestionar registros de seguridad, capacitación, flota, políticas y comunicación de la compañía desde una Mini App de Telegram. Cada suscripción también ayuda a alimentar familias locales a través de WHI Hobbs.',
    alreadyUsingZia: '¿Ya usas Zia?',
    openBot: 'Abrir @vamosar_race_bot',
    openBotShort: 'Bot',
    landingSubscribeButton: 'Suscribirse',
    landingRacePassButton: 'Pase de carrera $2',
    themeAutoShort: 'Auto',
    themeDarkShort: 'Oscuro',
    themeLightShort: 'Claro',
    freeModeButtonShort: 'Demo',
    freeModeButton: 'Demo gratis',
    freeModeButtonDuration: 'Demo gratis de Chrome · 30 minutos',
    freeModeDeviceNotice: 'Prueba la app localmente en este dispositivo. Las suscripciones pagadas y la vinculación de compras no cambian.',
    freeModeTestingNotice: 'El Modo Demo gratis de Chrome muestra navegación pública, búsqueda, mapas, peligros, clima, favoritos y envío de rutas. Abre ZiaWellNav en Telegram para 100% de soporte de plataforma, registros firmados de empresa, notificaciones del bot, IA/RAG, formularios, hojas de tiempo, flota, políticas, capacitación y suscripciones.',
    landingChromeDemoCardTitle: 'Modo Demo gratis de Chrome',
    landingChromeDemoCardPercent: '{0}% vista previa',
    landingChromeDemoCardDesc: 'La navegación pública funciona aquí. Los flujos firmados de empresa se abren en Telegram.',
    landingChromeDemoWorksTitle: 'Funciona en Chrome Demo',
    landingChromeDemoTelegramTitle: 'Abrir en Telegram',
    landingChromeDemoTelegramExtra: 'GPS del teléfono y sincronización de bóveda de certificados',
    landingChromeDemoOpenTelegram: 'Abrir en Telegram',
    landingChromeDemoStart: 'Iniciar demo de Chrome',
    freeModeCountdownFull: 'MODO GRATIS · QUEDAN {0} MIN',
    freeModeCountdownShort: 'GRATIS · {0}M',
    freeModeCountdownChromeDemoFull: 'DEMO CHROME · {0} MIN · 50% VISTA PREVIA',
    freeModeCountdownChromeDemoShort: 'DEMO · {0}M · 50%',
    freeModeDemoEnteredNotice: 'Estás viendo una vista previa de navegación pública. Abre en Telegram para 100% de soporte.',
    advancedFeaturesTitle: 'Funciones Avanzadas',
    advancedFeaturesDesc: 'Hecho por trabajadores petroleros, para trabajadores petroleros. Herramientas potentes para el campo petrolero moderno.',
    landingOilfieldFormsTitle: 'Formularios Importantes del Campo Petrolero',
    landingOilfieldFormsCount: '{0} formularios listos para campo incluidos',
    landingOilfieldFormsDesc: 'Formularios listos para BBS, excavacion, trabajo caliente, incidentes, inspecciones, aprobaciones y comunicacion de cuadrilla antes de iniciar.',
    landingSafetyDashboardTitle: 'Dashboard de Seguridad',
    landingSafetyDashboardDesc: 'Administra seguridad como un flujo cerrado: Action Center, revision de incidentes, acciones correctivas, vistas de trabajadores, reconocimientos, recordatorios, enlaces de capacitacion/politicas y paquetes de auditoria exportables desde Company Dashboard.',
    landingSafetyDashboardCta: 'Abrir pestaña de Seguridad',
    landingSafetyDashboardFeatureIncidentReview: 'Action Center',
    landingSafetyDashboardFeatureIncidentReviewDesc: 'Ordena elementos criticos, vencidos, incompletos y listos para auditoria para que el dueno sepa que atender primero.',
    landingSafetyDashboardFeatureCorrectiveActions: 'Linea de tiempo cerrada',
    landingSafetyDashboardFeatureCorrectiveActionsDesc: 'Rastrea eventos enviados, vistos, reconocidos, recordados, completados y listos para auditoria en boletines, politicas y capacitacion.',
    landingSafetyDashboardFeatureBulletins: 'Boletines de seguridad',
    landingSafetyDashboardFeatureBulletinsDesc: 'Publica lecciones aprendidas, registra vistas explicitas de trabajadores y rastrea reconocimientos antes del cierre.',
    landingSafetyDashboardFeatureRecordkeeping: 'Recordkeeping y evidencia',
    landingSafetyDashboardFeatureRecordkeepingDesc: 'Mantiene revisiones de incidentes, acciones correctivas, estado de casos, archivos y referencias de evidencia conectadas al registro correcto.',
    landingSafetyDashboardFeatureExceptions: 'Vencidos y brechas legacy',
    landingSafetyDashboardFeatureExceptionsDesc: 'Muestra lineas de tiempo incompletas, elementos vencidos y reconocimientos faltantes antes de depender de una exportacion de auditoria.',
    landingSafetyDashboardFeatureExports: 'Exportaciones de paquete de auditoria',
    landingSafetyDashboardFeatureExportsDesc: 'Exporta CSV/JSON de timeline, portada, reportes de reconocimiento, indice de evidencia y archivos de evidencia opcionales.',
    landingTrainingOnboardingTitle: 'Capacitacion e Incorporacion',
    landingTrainingOnboardingDesc: 'Asigna capacitacion de seguridad de incorporacion, cuestionarios y firmas de trabajadores desde modulos de programas de seguridad.',
    landingTrainingOnboardingCta: 'Abrir pestaña de Capacitacion',
    landingTrainingOnboardingFeaturePacks: 'Paquetes de incorporacion',
    landingTrainingOnboardingFeaturePacksDesc: 'Inicia a nuevos trabajadores con modulos de seguridad agrupados en vez de asignar cada leccion una por una.',
    landingTrainingOnboardingFeatureQuiz: 'Puntaje minimo de 80%',
    landingTrainingOnboardingFeatureQuizDesc: 'Los trabajadores deben aprobar el cuestionario del modulo antes de firmar la capacitacion.',
    landingTrainingOnboardingFeatureSignoff: 'Firma digital del trabajador',
    landingTrainingOnboardingFeatureSignoffDesc: 'Captura la confirmacion despues de que el empleado revise y apruebe la capacitacion.',
    landingTrainingOnboardingFeatureMatrix: 'Matriz de finalizacion del dueno',
    landingTrainingOnboardingFeatureMatrixDesc: 'Los duenos pueden ver quien esta asignado, en progreso, vencido o completo.',
    landingTrainingOnboardingFeatureDueDates: 'Fechas limite y vencidos',
    landingTrainingOnboardingFeatureDueDatesDesc: 'Define fechas objetivo y muestra la capacitacion que necesita seguimiento.',
    landingTrainingGenerationTitle: 'Gestion y Generacion de Capacitacion',
    landingTrainingGenerationTemplateCount: '{0} plantillas de capacitacion',
    landingTrainingGenerationPackCount: '{0} paquetes de gestion',
    landingTrainingGenerationTemplateCountDesc: 'Listas para Cyber, Word, Excel, IA, incorporacion, seguridad, cuestionarios, asignaciones y seguimiento de firmas.',
    landingTrainingGenerationDesc: 'Genera capacitacion lista para asignar desde {0} plantillas y {1} paquetes de gestion que cubren Cyber, Word, Excel, IA, incorporacion y seguridad, y enviala de inmediato a todos los usuarios vinculados, una cuadrilla o empleados seleccionados.',
    landingTrainingGenerationCta: 'Abrir herramientas de Capacitacion',
    landingTrainingGenerationFeatureBusinessPacks: '{0} paquetes de gestion listos para asignar',
    landingTrainingGenerationFeatureBusinessPacksDesc: 'Usa {0} paquetes agrupados para herramientas de oficina, ciberseguridad basica, uso seguro de IA, incorporacion y seguridad de campo sin crear cada modulo a mano.',
    landingTrainingGenerationFeatureQuizzes: 'Cuestionarios dentro de la capacitacion',
    landingTrainingGenerationFeatureQuizzesDesc: 'Cada modulo puede incluir preguntas calificadas para que los trabajadores demuestren entendimiento antes de firmar.',
    landingTrainingGenerationFeatureSendNow: 'Enviar al grupo de inmediato',
    landingTrainingGenerationFeatureSendNowDesc: 'Asigna un paquete a todos los empleados vinculados, una sola cuadrilla o usuarios seleccionados desde el mismo Company Dashboard.',
    landingTrainingGenerationFeatureTracking: 'Rastrear finalizacion y firma',
    landingTrainingGenerationFeatureTrackingDesc: 'Los duenos pueden ver capacitacion asignada, en progreso, vencida, fallida y completada con reconocimientos del empleado adjuntos.',
    landingPolicyManagementTitle: 'Generacion y Gestion de Politicas',
    landingPolicyManagementTemplateCount: '{0} plantillas de politicas',
    landingPolicyManagementTemplateCountDesc: 'Listas para paquetes de politicas, revisiones y firma de empleados.',
    landingPolicyManagementDesc: 'Genera paquetes de politicas de compania desde {0} plantillas, envia firmas autenticadas de empleados, administra revisiones y mantiene las politicas firmadas disponibles para los trabajadores dentro de la aplicacion.',
    landingPolicyManagementCta: 'Revisar acceso Business',
    landingPolicyManagementFeatureGenerate: '{0} plantillas y paquetes de politicas',
    landingPolicyManagementFeatureGenerateDesc: 'Crea paquetes starter HSE, operaciones de campo, flota/equipo, salud/exposicion, contratista/seguridad de procesos o manual completo de seguridad sin empezar desde un documento en blanco.',
    landingPolicyManagementFeatureSignoff: 'Firma autenticada',
    landingPolicyManagementFeatureSignoffDesc: 'Los empleados reconocen politicas desde su cuenta verificada para que los duenos rastreen quien firmo, cuando firmo y que revision firmo.',
    landingPolicyManagementFeatureAccess: 'Acceso del empleado a politicas',
    landingPolicyManagementFeatureAccessDesc: 'Los trabajadores pueden volver despues y ver las politicas que firmaron dentro de ZiaWellNav en vez de buscar archivos o mensajes viejos.',
    landingPolicyManagementFeatureRevisions: 'Enviar revisiones a todos',
    landingPolicyManagementFeatureRevisionsDesc: 'Cambia una revision una vez, emitela y envia el nuevo requisito de reconocimiento a todos los usuarios asignados al mismo tiempo.',
    landingCyberClassesTitle: 'Clases de Ciberseguridad',
    landingCyberClassesDesc: 'Clases de seis horas para cuadrillas, duenos y trabajadores de campo que necesitan proteccion practica contra estafas, robo de cuentas y riesgos de dispositivos en el trabajo.',
    landingCyberClassesPrice: '$95 por asistente · clase de 6 horas',
    landingCyberClassesCta: 'Comprar asientos de clase cyber',
    landingCyberClassFeaturePhishing: 'Phishing e ingenieria social',
    landingCyberClassFeaturePhishingDesc: 'Detecta enlaces falsos, suplantacion, presion y mensajes que atacan a cuadrillas de campo.',
    landingCyberClassFeaturePassword: 'Contrasenas y MFA basico',
    landingCyberClassFeaturePasswordDesc: 'Usa mejores contrasenas, passkeys y autenticacion multifactor sin complicar el trabajo.',
    landingCyberClassFeatureMobile: 'Seguridad de celular y Telegram',
    landingCyberClassFeatureMobileDesc: 'Protege telefonos, cuentas de Telegram, codigos y dispositivos de trabajo compartidos.',
    landingCyberClassFeatureJobsiteWifi: 'Wi-Fi y dispositivos en campo',
    landingCyberClassFeatureJobsiteWifiDesc: 'Entiende Wi-Fi publico, hotspots, tablets, laptops e higiene de dispositivos de campo.',
    landingCyberClassFeaturePaymentScams: 'Alertas de pagos y estafas',
    landingCyberClassFeaturePaymentScamsDesc: 'Reconoce cambios de factura, tarjetas de regalo, proveedores falsos y solicitudes urgentes de pago.',
    landingCyberClassFeatureReporting: 'Reportar actividad sospechosa',
    landingCyberClassFeatureReportingDesc: 'Conoce que documentar, a quien avisar y como responder antes de que el dano se extienda.',
    landingCyberClassModalTitle: 'Comprar asientos de clase cyber',
    landingCyberClassModalDesc: 'Ingresa cantidad de asistentes y datos de contacto. Despues del pago, ZiaWellNav dara seguimiento para programar la clase de 6 horas.',
    landingCyberClassAttendeeCount: 'Cantidad de asistentes',
    landingCyberClassContactName: 'Nombre de contacto',
    landingCyberClassContactEmail: 'Correo de contacto',
    landingCyberClassCompanyName: 'Nombre de compania (opcional)',
    landingCyberClassNotes: 'Notas de programacion (opcional)',
    landingCyberClassModalCta: 'Continuar a Stripe',
    landingCyberClassAttendeeError: 'Ingresa 1-{0} asistentes.',
    landingCyberClassContactError: 'Nombre y correo de contacto son requeridos.',
    landingCyberClassCheckoutTotal: '{0} asistente(s) × $95 = ${1}',
    landingBusinessServicesTitle: 'Servicios Empresariales',
    landingBusinessServicesDesc: 'Compra servicios practicos para soporte tecnico, software personalizado, medios con drone y planeacion de flujos con IA.',
    landingBusinessServicesNote: 'Elige un servicio, ingresa datos de contacto y continua a Stripe Checkout.',
    landingBusinessServicesCta: 'Comprar / Solicitar Servicio',
    landingBusinessServicesTechSupportTitle: 'Soporte Tecnico',
    landingBusinessServicesTechSupportPrice: '$75/hora',
    landingBusinessServicesTechSupportDesc: 'Configuracion de redes y solucion de problemas para Mac/Unix, Windows, Linux y dispositivos mixtos de oficina.',
    landingBusinessServicesSoftwareTitle: 'Desarrollo de Software Personalizado',
    landingBusinessServicesSoftwarePrice: '$150/hora',
    landingBusinessServicesSoftwareDesc: 'Crea funciones de app, automatizaciones, dashboards, integraciones y herramientas internas para tu negocio.',
    landingBusinessServicesDronePhotosTitle: 'Fotos Aereas con Drone',
    landingBusinessServicesDronePhotosPrice: '$100 fijo',
    landingBusinessServicesDronePhotosDesc: 'Captura fotos aereas del negocio, patio, taller o instalaciones para registros y promocion.',
    landingBusinessServicesDroneVideoTitle: 'Video Aereo con Drone',
    landingBusinessServicesDroneVideoPrice: '$200 fijo',
    landingBusinessServicesDroneVideoDesc: 'Captura video aereo sin editar de las instalaciones para documentacion, marketing o revision del dueno.',
    landingBusinessServicesAiTitle: 'Integracion de IA al Negocio',
    landingBusinessServicesAiPrice: '$500 evaluacion',
    landingBusinessServicesAiDesc: 'Mapea donde la IA puede ayudar a tu negocio con formularios, documentos, capacitacion, soporte y automatizacion.',
    landingOfficeValueEyebrow: 'Valor de oficina desde datos de campo',
    landingOfficeValueTitle: 'Convierte actividad de campo en prueba lista para oficina',
    landingOfficeValueDesc: 'ZiaWellNav conecta inspecciones, recibos, JSAs, politicas, capacitacion, riesgos, estado de cuadrillas, evidencia GPS y costos en un Company Dashboard para que gerentes, seguridad, finanzas, HR y duenos actuen desde registros actuales.',
    landingOfficeValueManagerPitch: 'Los gerentes ven que esta pasando, donde estan las cuadrillas, que activos estan fuera de servicio y que necesita accion antes del proximo despacho.',
    landingOfficeValueFinancePitch: 'Finanzas recibe hojas de tiempo, recibos, contexto de costo por trabajo, evidencia de millas y soporte de facturacion sin perseguir papel.',
    landingOfficeValueSafetyPitch: 'Seguridad mantiene JSAs, reportes de incidentes, capacitacion, reconocimientos de politicas, fotos y auditorias con GPS en un solo lugar.',
    landingOfficeValueOwnerPitch: 'Los duenos ven operaciones, seguridad, utilizacion, costos y senales de riesgo en un dashboard en vez de llamadas y hojas dispersas.',
    landingOfficeValueRoleManager: 'Visibilidad gerencial',
    landingOfficeValueRoleFinance: 'Finanzas y costos',
    landingOfficeValueRoleSafety: 'Seguridad y cumplimiento',
    landingOfficeValueRoleHr: 'HR e incorporacion',
    landingOfficeValueRoleOwner: 'KPIs del dueno',
    landingOfficeValueEquipmentTitle: 'Control de equipo y vehiculos',
    landingOfficeValueEquipmentDesc: 'Inspecciones pre/post viaje con fotos, estado fuera de servicio, patrones PM, evidencia de reparacion e historial de costos por vehiculo.',
    landingOfficeValueCostTitle: 'Gastos y costo por trabajo',
    landingOfficeValueCostDesc: 'Captura recibos con GPS y hora, etiqueta costos por cuadrilla, ubicacion y fecha, y respalda reembolsos y disputas de factura.',
    landingOfficeValueSafetyTitle: 'Prueba de seguridad y cumplimiento',
    landingOfficeValueSafetyDesc: 'Riesgos en vivo, JSAs, reportes de incidentes, vencimientos de certificados, reconocimientos de politicas, firmas de capacitacion y auditorias listas para exportar.',
    landingOfficeValueCrewTitle: 'Programacion y utilizacion de cuadrillas',
    landingOfficeValueCrewDesc: 'Ve cuadrillas vinculadas, horas, disponibilidad, certificaciones y estado actual para que programacion y nomina no dependan de llamadas dispersas.',
    landingOfficeValueFieldIntelTitle: 'Inteligencia de campo y rutas',
    landingOfficeValueFieldIntelDesc: 'Busca pozos e instalaciones, usa mapas, clima, riesgos, production atlas y worklists para responder a clientes y reducir rutas equivocadas.',
    landingOfficeValueRiskTitle: 'Defensa de riesgo y reportes',
    landingOfficeValueRiskDesc: 'Resume KPIs, tendencias, prueba GPS y con hora, fotos, firmas e historial para disputas, reclamos, auditorias y revision del dueno.',
    landingFieldIntelEyebrow: 'Suite de inteligencia de campo',
    landingFieldIntelTitle: 'Sabe que esta pasando alrededor de tus cuadrillas',
    landingFieldIntelDesc: 'ZiaWellNav da a duenos y equipos de campo inteligencia operacional para reportes diarios, incidentes regulatorios, operaciones activas, pozos nuevos, senales de produccion, contexto de mercado y visibilidad de emisiones.',
    landingFieldIntelOfficeTitle: 'Creado para despacho, seguridad, ventas y duenos',
    landingFieldIntelOfficeDesc: 'Usa inteligencia de campo para informar a cuadrillas antes del despacho, ver riesgos cercanos, detectar actividad nueva, seguir condiciones de mercado y convertir observaciones diarias en historial de compania.',
    landingFieldIntelChipOps: 'Senales de operaciones',
    landingFieldIntelChipRegulatory: 'Conciencia regulatoria',
    landingFieldIntelChipWells: 'Pozos e instalaciones nuevas',
    landingFieldIntelChipMarket: 'Mercado y emisiones',
    landingFieldIntelDailyReportTitle: 'Reporte Diario de Campo',
    landingFieldIntelDailyReportDesc: 'Captura lo que paso hoy con cuadrilla, ubicacion, trabajo realizado, notas, fotos y contexto del trabajo para que la oficina tenga un registro diario confiable.',
    landingFieldIntelOcdIncidentsTitle: 'Incidentes OCD cercanos',
    landingFieldIntelOcdIncidentsDesc: 'Muestra reportes OCD menores, medios y mayores cerca del area de trabajo para que JSAs y planeacion de seguridad empiecen con riesgo historico cercano.',
    landingFieldIntelActiveOperationsTitle: 'Operaciones Activas',
    landingFieldIntelActiveOperationsDesc: 'Rastrea senales de trabajo activo y actividad operacional alrededor de la cuenca para que despacho, ventas y gerencia sepan donde hay movimiento de campo.',
    landingFieldIntelNewWellsDigestTitle: 'Digest de Pozos Nuevos',
    landingFieldIntelNewWellsDigestDesc: 'Revisa actividad nueva de pozos en formato digest para detectar oportunidades, movimiento de clientes y nuevas areas de interes.',
    landingFieldIntelNewWellsNmTitle: 'Pozos Nuevos NM',
    landingFieldIntelNewWellsNmDesc: 'Enfocate en actividad de pozos en Nuevo Mexico con registros por ubicacion y enlaces al mapa y detalle del pozo.',
    landingFieldIntelMarketPulseTitle: 'Pulso de Mercado',
    landingFieldIntelMarketPulseDesc: 'Combina contexto de production atlas, vistas por operador, senales de commodities y notas de precios para decisiones con contexto actual.',
    landingFieldIntelEmissionsTitle: 'Leaderboard de Emisiones',
    landingFieldIntelEmissionsDesc: 'Compara senales de emisiones y vistas leaderboard para que duenos vean exposicion operacional, tendencias y areas que necesitan revision.',
    landingBuiltInAiEyebrow: 'Integrada en la app',
    landingBuiltInAiTitle: 'Asistente de Conocimiento con IA',
    landingBuiltInAiProviderChip: 'Llama, Qwen, Gemma, GPT-OSS, Grok, ChatGPT, Mistral, DeepSeek',
    landingBuiltInAiRecordsChip: 'Respuestas de compania con fuentes citadas',
    landingBuiltInAiDesc: 'ZiaWellNav incluye herramientas de IA para diagnostico en campo, limpieza de notas de voz, resumen de JSA y reportes, redaccion de riesgos y respuestas desde formularios, politicas, capacitacion, hojas de tiempo, seguridad e historial de flota indexados.',
    landingBuiltInAiPrivacyNote: 'El conocimiento privado de compania se filtra por identidad verificada de Telegram: los duenos consultan registros de compania y los trabajadores solo ven sus registros propios o asignados.',
    landingBuiltInAiFeatureProviders: 'Multiples proveedores de IA',
    landingBuiltInAiFeatureProvidersDesc: 'Elige modelos alojados en Cloudflare como Llama, Qwen, Gemma y GPT-OSS, o proveedores configurados como Grok, ChatGPT, Mistral, DeepSeek, Cocoon y Ollama.',
    landingBuiltInAiFeatureKnowledge: 'Respuestas desde registros',
    landingBuiltInAiFeatureKnowledgeDesc: 'Pregunta contra formularios, plantillas de politicas, paquetes de capacitacion, registros enviados, hojas de tiempo, seguridad e historial de flota con citas.',
    landingBuiltInAiFeatureFieldWork: 'Redaccion lista para campo',
    landingBuiltInAiFeatureFieldWorkDesc: 'Limpia notas de voz, resume JSAs y reportes, redacta guias de diagnostico y convierte notas de riesgo en texto claro para conductores.',
    landingBuiltInAiFeatureCompanySafe: 'Acceso seguro de compania',
    landingBuiltInAiFeatureCompanySafeDesc: 'La autenticacion firmada de Telegram y permisos del servidor mantienen registros privados limitados a duenos, trabajadores asignados y acceso verificado.',
    landingBotIntegrationEyebrow: 'Implementacion de bot personalizado',
    landingBotIntegrationTitle: 'Integracion de Bot de Empresa',
    landingBotIntegrationPrice: '$1,000 cargo unico de integracion de bot',
    landingBotIntegrationPrivacyChip: 'La privacidad esta incluida con los registros de compania',
    landingBotIntegrationDesc: 'La integracion de bot personalizado agrega un bot de Telegram con marca de la compania, menus dedicados y rutas privadas de trabajo para que cuadrillas, taller, seguridad, capacitacion, despacho y duenos se comuniquen desde el mismo flujo de ZiaWellNav en vez de textos y capturas dispersas.',
    landingBotIntegrationFeeNote: 'El cargo de configuracion cubre creacion del bot, menus, rutas, pruebas y entrega. Es opcional: los registros privados de compania, historial de formularios y dashboards guardados no requieren un bot personalizado.',
    landingBotIntegrationCta: 'Revisar configuracion en precios',
    landingBotIntegrationCompanyBotTitle: 'Bot de Comando de Compania',
    landingBotIntegrationCompanyBotDesc: 'Un Telegram bot con marca de la compania y menus para ZiaWellNav, formularios, politicas, capacitacion, flota, soporte y acceso al workspace.',
    landingBotIntegrationFleetBotTitle: 'Bot de Flota / Taller',
    landingBotIntegrationFleetBotDesc: 'Enruta solicitudes de taller, alertas PM, evidencia de reparacion, cierres y avisos de ruta fallida a los contactos correctos.',
    landingBotIntegrationSafetyBotTitle: 'Bot de Seguridad + Capacitacion',
    landingBotIntegrationSafetyBotDesc: 'Envia recordatorios JSA, seguimiento de incidentes, tareas de capacitacion/onboarding, avisos de certificados y alertas de seguridad a los trabajadores correctos.',
    landingBotIntegrationAdminBotTitle: 'Alertas de Dueno/Admin',
    landingBotIntegrationAdminBotDesc: 'Mantiene informados a duenos y gerentes sobre aprobaciones, excepciones, exportaciones y senales diarias sin revisar cada chat.',
    landingBotIntegrationCommunicationTitle: 'Como mejora la comunicacion de la compania',
    landingBotIntegrationCommunicationPointRouting: 'Enruta mensajes por flujo para que taller, seguridad, despacho y dueno vean la actualizacion correcta.',
    landingBotIntegrationCommunicationPointMissedCalls: 'Reduce llamadas perdidas, capturas repetidas y reenvios manuales entre cuadrillas y oficina.',
    landingBotIntegrationCommunicationPointRecords: 'Mantiene la comunicacion conectada a registros, formularios, evidencia e historial del dashboard de ZiaWellNav.',
    landingBusinessServiceModalTitle: 'Comprar / Solicitar Servicio Empresarial',
    landingBusinessServiceModalDesc: 'Ingresa datos de contacto y cantidad de servicio. Despues del pago, ZiaWellNav dara seguimiento para programar el trabajo.',
    landingBusinessServiceHourQuantity: 'Horas',
    landingBusinessServiceFixedQuantity: 'Cantidad fija en 1 paquete',
    landingBusinessServiceContactName: 'Nombre de contacto',
    landingBusinessServiceContactEmail: 'Correo de contacto',
    landingBusinessServiceCompanyName: 'Nombre de compania (opcional)',
    landingBusinessServicePhone: 'Telefono (opcional)',
    landingBusinessServiceNotes: 'Notas del servicio (opcional)',
    landingBusinessServiceModalCta: 'Continuar a Stripe',
    landingBusinessServiceSelectionError: 'Selecciona un servicio empresarial.',
    landingBusinessServiceQuantityError: 'Ingresa 1-{0} horas.',
    landingBusinessServiceContactError: 'Nombre y correo de contacto son requeridos.',
    landingBusinessServiceCheckoutTotal: '{0} × {1} = ${2}',
    landingClosePricing: 'Cerrar precios',
    landingSmsFieldUpdatesChip: 'Actualizaciones por SMS',
    landingSmsOptInOnlyChip: 'Solo con opt-in',
    landingSmsTitle: 'Recibe actualizaciones de campo de ZiaWellNav por texto',
    landingSmsDesc: 'Actualizaciones petroleras del Permian, demos de la app y noticias de ZiaWellNav. Solo enviamos textos a opt-ins verificados. Responde STOP para darte de baja.',
    landingSmsVerified: 'Tu número de teléfono está verificado para actualizaciones SMS de ZiaWellNav.',
    landingSmsPending: 'Ingresa el código de verificación enviado a tu teléfono para terminar el opt-in por SMS.',
    landingSmsTestCode: 'Código de prueba: {0}',
    landingSmsMobilePhone: 'Teléfono móvil',
    landingSmsVerificationCode: 'Código de verificación',
    landingSmsConsent: 'Acepto recibir mensajes de texto de marketing de ZiaWellNav. Pueden aplicar tarifas de mensajes y datos. Responde STOP para darte de baja.',
    landingSmsConsentRequired: 'Se requiere consentimiento de SMS antes del opt-in.',
    landingSmsOptInFailed: 'Falló el opt-in por SMS. Inténtalo de nuevo.',
    landingSmsVerificationFailed: 'Falló la verificación por SMS. Inténtalo de nuevo.',
    landingSmsInvalidPhone: 'Ingresa un número de teléfono móvil válido de EE. UU.',
    landingSmsInvalidCode: 'Ingresa el código de verificación enviado a tu teléfono.',
    landingSmsExpiredCode: 'Ese código de verificación expiró. Solicita un código nuevo.',
    landingSmsUnauthorized: 'El opt-in por SMS no está disponible temporalmente. Inténtalo más tarde.',
    landingSmsSubmitting: 'Enviando...',
    landingSmsVerifyPhone: 'Verificar teléfono',
    landingSmsRequestUpdates: 'Solicitar actualizaciones por texto',
    landingFleetManagementTitle: 'Gestion de Flota',
    landingFleetManagementDesc: 'Rastrea equipos, solicitudes de taller, mantenimiento preventivo, evidencia de reparacion, costos, tiempo muerto e historial de activos desde un dashboard de compania.',
    landingFleetManagementCta: 'Abrir pestaña de Flota',
    landingFleetManagementFeatureAssets: 'Activos de flota',
    landingFleetManagementFeatureAssetsDesc: 'Rastrea camionetas, remolques, equipo, datos de propiedad e historial de activos en un solo lugar.',
    landingFleetManagementFeatureRequests: 'Solicitudes de taller',
    landingFleetManagementFeatureRequestsDesc: 'Enruta necesidades de reparacion al taller con estado, notas, rutas e historial de notificaciones.',
    landingFleetManagementFeaturePm: 'Programas PM',
    landingFleetManagementFeaturePmDesc: 'Muestra ventanas de mantenimiento preventivo antes de que los problemas causen tiempo muerto en campo.',
    landingFleetManagementFeatureEvidence: 'Fotos/archivos de evidencia',
    landingFleetManagementFeatureEvidenceDesc: 'Adjunta fotos y archivos para documentar condicion, trabajo completado y prueba de cierre.',
    landingFleetManagementFeatureCosts: 'Control de costos',
    landingFleetManagementFeatureCostsDesc: 'Captura costos de reparacion, tiempo muerto y senales de mantenimiento para revision del dueno.',
    landingFleetManagementFeatureExport: 'Exportar historial de activo',
    landingFleetManagementFeatureExportDesc: 'Exporta registros de flota e historial de activos cuando clientes, duenos o auditores necesiten prueba.',
    landingOilfieldFormsCategoryElectrical: 'Formularios Electricos',
    landingOilfieldFormsCategoryElectricalSafetyAudits: 'Auditorias de Seguridad Electrica',
    landingOilfieldFormsCategoryOccidental: 'Formularios Occidental',
    landingOilfieldFormsCategoryIncidentNearMiss: 'Incidente / Casi Accidente',
    landingOilfieldFormsCategoryEquipmentInspections: 'Inspecciones de Equipo',
    landingOilfieldFormsCategorySafetyPrograms: 'Programas de Seguridad',
    landingOilfieldFormsCategoryDailyFieldReports: 'Reportes Diarios de Campo',
    landingOilfieldFormsCategoryCrewSignOff: 'Firma de Cuadrilla',
    landingOilfieldFormsCategoryWorkAtHeights: 'Trabajo en Alturas',
    landingOilfieldFormEnergizedElectricalWorkPermitBenefit: 'Controla aprobaciones electricas y comunicacion de cuadrilla.',
    landingOilfieldFormArcFlashShockPpeChecklistBenefit: 'Verifica EPP de arco antes de exposicion.',
    landingOilfieldFormHotCrossingPhaseHolderBenefit: 'Alinea peligros, herramientas y senales live-line.',
    landingOilfieldFormFallProtectionInspectionBenefit: 'Documenta arnes, lanyard y SRL listos.',
    landingOilfieldFormAutoCraneInspectionBenefit: 'Confirma controles de grua y protecciones.',
    landingOilfieldFormGeneralEquipmentInspectionBenefit: 'Detecta defectos antes de llegar al sitio.',
    landingOilfieldFormPumpHosePreOpBenefit: 'Revisa equipo de presion antes de bombear.',
    landingOilfieldFormMaintenanceRequestBenefit: 'Canaliza reparaciones antes de fallas mayores.',
    landingOilfieldFormNearMissReportBenefit: 'Convierte casi accidentes en accion correctiva.',
    landingOilfieldFormFirstReportIncidentBenefit: 'Captura hechos para notificacion rapida.',
    landingOilfieldFormIncidentWitnessStatementBenefit: 'Preserva detalles frescos de testigos.',
    landingOilfieldFormFullIncidentInvestigationBenefit: 'Documenta causas, testigos, acciones y firma.',
    landingOilfieldFormFallRescuePlanBenefit: 'Coordina contactos, acceso y tiempo de rescate.',
    landingOilfieldFormFallDistanceClearanceBenefit: 'Verifica distancia libre antes de anclarse.',
    landingOilfieldFormSuspensionTraumaBenefit: 'Prepara rescate, equipo y comunicacion.',
    landingOilfieldFormBehaviorBasedSafetyBenefit: 'Captura conductas seguras y de riesgo antes de incidentes.',
    landingOilfieldFormOnSiteExcavationBenefit: 'Confirma one-call, localizacion de lineas y controles de excavacion.',
    landingOilfieldFormCriticalTaskHotWorkBenefit: 'Revisa controles de trabajo caliente y tareas electricas de alto riesgo.',
    landingOilfieldFormStopWorkAuthorityBenefit: 'Documenta paro, correcciones y aprobacion de reinicio.',
    landingOilfieldFormAerialLiftSafetyBenefit: 'Revisa controles, distancia libre y proteccion contra caidas.',
    landingOilfieldFormHotWorkPermitBenefit: 'Controla chispas, vigilancia, EPP y aprobacion.',
    landingOilfieldFormCraneSignalingBenefit: 'Alinea senalistas, comunicacion, visibilidad y paro.',
    landingOilfieldFormVacuumTruckOperationsBenefit: 'Revisa vapores, monitoreo, equipo y emergencias.',
    landingOilfieldFormOverheadLinesBenefit: 'Verifica soporte, distancia y EPP electrico.',
    landingOilfieldFormMedicalRecordsAccessBenefit: 'Registra acceso a exposicion y autorizacion privada.',
    landingOilfieldFormSilicaExposureChecklistBenefit: 'Confirma controles de polvo, respiradores y capacitacion.',
    landingOilfieldFormSilicaPlanReviewBenefit: 'Revisa ECP, muestreo, controles y registros.',
    landingOilfieldFormAmmoniaAwarenessBenefit: 'Revisa amoniaco, EPP y respuesta de emergencia.',
    landingOilfieldFormPoleTransportSafetyBenefit: 'Revisa sobresalida, banderas, luces y amarre.',
    landingOilfieldFormDailyFieldReportBenefit: 'Mantiene trabajo y peligros visibles.',
    landingOilfieldFormCrewSignOffBenefit: 'Registra entendimiento compartido con firmas.',
    allStates: 'Todos los estados',
    checkoutSubscriptionActivated: 'Suscripción Activada',
    checkoutTrialStarted: 'Tu prueba gratis de 7 días ha comenzado.',
    checkoutSignInUsing: 'Inicia sesión en ZiaWellNav usando:',
    checkoutEmailFallback: 'el correo que ingresaste en el pago',
    checkoutStepOpenApp: 'Paso 2 - Abre la App',
    checkoutOpenTelegram: 'Abrir ZiaWellNav en Telegram',
    checkoutNewToTelegram: '¿Nuevo en Telegram?',
    checkoutTelegramInstallHelp: 'Telegram es una app gratis y segura de mensajería. ZiaWellNav funciona dentro de Telegram - instala Telegram primero:',
    checkoutOrLoginBrowser: 'O inicia sesión por navegador',
    checkoutOpenTelegramAfterLogin: 'Luego toca "Abrir ZiaWellNav en Telegram" arriba',
    arLiveViewTitle: 'Vista AR en Vivo',
    arLiveViewPlatform: '(iOS)',
    arLiveViewDesc: 'Apunta la cámara y ve pozos de aceite y gas cercanos superpuestos en la vista de campo. Toca la etiqueta de un pozo para ver distancia, número API y tipo con radio ajustable de 1 a 5 millas.',
    arLiveViewSubtext: 'Encuentra pozos con tu cámara, no solo con el mapa.',
    advancedJsaTitle: 'JSA',
    advancedJsaDesc: 'Crea un Análisis de Seguridad JSA completo desde el FAB principal. Agrega pasos, peligros, PPE, contactos de emergencia y punto de reunión; luego compártelo con la cuadrilla por Telegram y reábrelo para firmas.',
    advancedJsaSubtext: 'Mantén a la cuadrilla sincronizada con un toque desde la pantalla principal.',
    prePostTripTitle: 'Inspecciones Pre y Post Viaje',
    prePostTripDesc: 'Listas de revisión del vehículo con fotos, GPS y registros con hora. Desbloquea post-viaje después de pre-viaje y comparte reportes al instante por Telegram.',
    prePostTripSubtext: 'Mantén las unidades en cumplimiento - una inspección activa a la vez.',
    apiNumberSearchTitle: 'Búsqueda por Número API',
    apiNumberSearchDesc: 'Ve directo a un pozo por API. Búsqueda rápida desde el FAB del mapa, con formato automático y detección de estado para NM y TX.',
    apiNumberSearchSubtext: 'Validación integrada para reducir errores de dedo.',
    safetyGuyReportingTitle: 'Reportes de Seguridad',
    safetyGuyReportingDesc: 'Reportes rápidos de peligros y casi accidentes con fotos, GPS y alertas por Telegram. Envíalos rápido a cuadrillas y bitácora.',
    safetyGuyReportingSubtext: 'Mantén informados a los responsables de seguridad cuando lleguen reportes.',
    pavelDurovSagaTitle: 'La Historia de Pavel Durov',
    pavelDurovSagaDesc: 'El hombre que creó Telegram y lo que le costó.',
    pavelDurovFounder: 'Fundador de Telegram - más de 1B usuarios mensuales',
    pavelDurovTelegramLink: '@durov en Telegram',
    pavelReadMore: 'Leer más',
    pavelLexFridmanLink: 'Entrevista con Lex Fridman',
    pavelPaperAirplaneTitle: 'El truco del avión de papel',
    pavelPaperAirplaneBody: 'Durov dobló billetes de 5,000 rublos, unos $155 cada uno, en aviones de papel y los lanzó desde la ventana de la oficina de VK en San Petersburgo. Abajo hubo peleas mientras la gente corría por ellos. Ese avión de papel después se volvió el logo icónico de Telegram.',
    pavelEscapedRussiaTitle: 'Escapó de Rusia',
    pavelEscapedRussiaBody: 'El FSB exigió que entregara datos de usuarios sobre manifestantes ucranianos. Durov se negó, fue obligado a vender VK a propietarios ligados al Kremlin por un precio bajo, y luego salió de Rusia para siempre.',
    pavelPoisonedTitle: 'Envenenado - Casi muere',
    pavelPoisonedBody: 'Horas después de negarse a entregar al FSB las claves de cifrado de Telegram, Durov colapsó con dolor agudo, pérdida de visión y audición, vasos sanguíneos reventados y sin poder ponerse de pie. Más tarde describió el episodio públicamente en una entrevista con Lex Fridman.',
    pavelArrestedTitle: 'Arrestado en Francia',
    pavelArrestedBody: 'Autoridades francesas lo detuvieron en el aeropuerto Le Bourget por las políticas de moderación de Telegram. Fue retenido 96 horas y liberado bajo fianza, mientras críticos en todo el mundo lo llamaron un ataque a la libertad de expresión.',
    pavelBuiltMachineTitle: 'Construido como máquina',
    pavelBuiltMachineBody: 'Cada mañana: flexiones, sentadillas, agua fría, nados largos, dieta estricta y ventanas de ayuno. Su punto es disciplina sobre comodidad de corto plazo.',
    telegramBrowserTitle: 'Telegram Mini App vs Demo gratis de Chrome',
    telegramBrowserDesc: 'Chrome es una demo gratis para navegación pública de campo. Telegram es la experiencia firmada para registros de empresa, notificaciones del bot y flujos privados o pagados.',
    telegramSupportPercentChip: 'Telegram Mini App: {0}% soporte de plataforma',
    browserDemoPercentChip: 'Demo gratis de Chrome: {0}% vista previa',
    supportMatrixBasisChip: '10 grupos de funciones: {0} demo + {1} solo Telegram',
    telegramMiniFullAccessTitle: 'Telegram Mini App - 100% soporte de plataforma',
    browserLimitedAccessTitle: 'Modo Demo gratis de Chrome - 50% vista previa',
    telegramFullFeatureInspections: 'Inspecciones Pre/Post Viaje',
    telegramFullFeatureJsa: 'Análisis de Seguridad (JSA) + firma automática',
    telegramFullFeatureCrew: 'Gestión de cuadrilla y enlaces de invitación',
    telegramFullFeatureMarchingOrders: 'Órdenes de trabajo y temporizador',
    telegramFullFeatureReceipts: 'Recibos, bóveda de certificados y OCR',
    telegramFullFeatureTracking: 'Rastreo de vehículos y amigos',
    telegramFullFeatureNotifications: 'Todas las notificaciones y alertas push',
    telegramFullFeatureSearch: 'Búsqueda de pozos, navegación y mapas',
    telegramFullFeatureWeather: 'Clima, calidad del aire y peligros',
    telegramFullFeatureMarketplace: 'Asistente IA, ofertas y mercado',
    browserFeatureSearch: 'Búsqueda pública de pozos e instalaciones',
    browserFeatureNavigation: 'Envío a navegación de Google Maps',
    browserFeatureWeather: 'Peligros, clima e inteligencia de campo',
    browserFeatureHazards: 'Ver/reportar peligros',
    browserFeatureRoutes: 'Favoritos, listas de trabajo y vista previa de rutas',
    browserFeatureInspections: 'Formularios firmados, inspecciones, JSA y hojas de tiempo',
    browserFeatureCrew: 'Dashboard de empresa, cuadrillas, reuniones y alertas del bot',
    browserFeatureCerts: 'Bóveda de certificados, recibos y registros privados sincronizados',
    browserFeatureTracking: 'Flota, políticas, capacitación y flujos en vivo de trabajadores',
    browserFeatureMarketplace: 'IA/RAG de conocimiento de empresa, ofertas y suscripciones',
    browserLockedFeaturesNote: 'Esta función requiere acceso firmado de Telegram Mini App, no Modo Demo de Chrome. Abre ZiaWellNav dentro de Telegram para 100% de soporte.',
    telegramRequiredTitle: 'Abre en Telegram para esta función',
    telegramRequiredMessage: 'Esta función sí funciona en ZiaWellNav, pero requiere la sesión firmada de la Mini App completa de Telegram. Abre @vamosar_race_bot e inténtalo otra vez.',
    telegramRequiredChromeDemoContext: 'Chrome Demo muestra la navegación pública; Telegram desbloquea registros de compañía, formularios, AI, hojas de tiempo, flota, políticas, capacitación, juntas y notificaciones del bot.',
    telegramRequiredOpenAction: 'Abrir en Telegram',
    gpsUnsupportedTitle: 'Abre Telegram para GPS del teléfono',
    gpsUnsupportedMessage: 'El GPS sí funciona en la Mini App completa de Telegram. Chrome Demo puede no ofrecer GPS del teléfono aquí. Abre @vamosar_race_bot en tu teléfono para navegación con GPS.',
    gpsUnsupportedChromeDemoContext: 'Chrome Demo puede mostrar una vista previa de navegación pública, pero el GPS del teléfono es más confiable dentro de la Mini App de Telegram.',
    gpsUnsupportedOpenAction: 'Abrir en Telegram',
    supportedDeviceIphone: 'iPhone',
    supportedDeviceIpad: 'iPad',
    supportedDeviceAndroid: 'Android',
    supportedDeviceMacosApp: 'App macOS',
    supportedDeviceWindowsApp: 'App Windows',
    supportedDeviceChromeosApp: 'App ChromeOS',
    supportedDeviceChromeBrowser: 'Navegador Chrome',
    supportedDeviceSafariBrowser: 'Navegador Safari',
    
    // Landing Page - Feature Cards
    comingSoon: 'Próximamente',
    premium: 'Premium',
    exclusive: 'Exclusivo',
    voiceNavigationTitle: 'Navegación por Voz',
    voiceNavigationDesc: 'Búsqueda de pozos y ayuda de ruta sin manos mientras tus manos siguen en el volante',
    voiceNavigationSubtext: 'Di el pozo, API, operador o ubicación',
    landingFieldFormsTitle: 'Formularios Importantes de Campo',
    landingFieldFormsDesc: 'Completa JSAs, inspecciones, reportes de incidentes, permisos y firmas de cuadrilla en un solo lugar.',
    landingFieldFormsSubtext: 'Formularios críticos de seguridad para cuadrillas en campo.',
    telegramChannelsTitle: 'Canales de Telegram',
    telegramChannelsDesc: 'Canales privados, mensajería segura y transmisión de video',
    telegramChannelsSubtext: 'Todo integrado en Telegram',
    facilityTypesTitle: '62 Tipos de Instalaciones',
    facilityTypesDesc: 'Pozos, tanques, compresores, tuberías, SWDs y más',
    facilityTypesSubtext: 'La mayoría de navegadores solo cubren pozos básicos',
    dragDropLandmarksTitle: 'Arrastrar y Soltar Marcadores',
    dragDropLandmarksDesc: 'Coloca marcadores en guardaganados, molinos y curvas. Traza rutas por territorio sin marcar y encuentra la salida cuando estés en terreno desconocido.',
    amigosTitle: 'Amigos',
    amigosDesc: 'Próximamente - Comparte tu ubicación con amigos y véanse en tiempo real en el mapa.',
    offlineMapsTitle: 'Mapas Sin Conexión',
    offlineMapsDesc: 'Descarga cuencas enteras para acceso sin conexión. ¿Sin señal? No hay problema.',
    weatherAlertsTitle: 'Clima y Peligros',
    weatherAlertsDesc: 'Datos climáticos en tiempo real y advertencias de peligros en la carretera para mantenerte seguro.',
    crewTrackingTitle: 'Rastreo de Equipos',
    crewTrackingDesc: 'Ve las ubicaciones de tu equipo en tiempo real. Coordina mejor, trabaja más seguro.',
    basinCommunitiesTitle: 'Comunidades de Cuenca',
    basinCommunitiesDesc: 'Conéctate con operadores en tu cuenca. Comparte información, encuentra equipos, publica trabajos.',
    oilfieldMappingTitle: 'Mapeo de Campos Petroleros',
    oilfieldMappingDesc: '1.4M+ pozos e instalaciones entre NM y TX, actualizado regularmente. Encuentra locaciones antes que en muchos mapas públicos.',
    oilfieldMappingSubtext: 'Sigue tendencias de actividad conforme se actualizan los datos.',
    calicheRoutesTitle: 'Rutas de Caliche',
    calicheRoutesDesc: 'Navega caminos que Google no conoce. Traza rutas por caminos petroleros sin marcar, marca puntos de referencia y comparte con tu equipo.',
    calicheRoutesSubtext: 'Nunca te pierdas regresando a casa—incluso en territorio desconocido.',
    routePhotosTitle: 'Fotos de Ruta',
    routePhotosDesc: 'Toma y comparte fotos del tramo final hacia las instalaciones. Con una subida, todo el equipo las ve al instante en la app.',
    drawRouteFingerTitle: 'Dibuja Ruta con el Dedo',
    drawRouteFingerDesc: 'Traza un camino con tu dedo; se ajusta a los caminos y se guarda para navegación paso a paso.',
    amenitiesTitle: 'Amenidades',
    amenitiesDesc: 'Encuentra y comparte baños, tacos, combustible, agua y más—con filtros fáciles y datos de la comunidad.',
    mapLayersTitle: 'Capas de Mapa',
    mapLayersDesc: 'Alterna terreno, satélite, noche, ciber, solo carreteras y topo para ver justo lo que necesitas.',
    ufoRadarTapMoveTitle: 'Radar UFO (Tocar y Mover)',
    ufoRadarTapMoveDesc: 'Toca cualquier punto del mapa para colocar el radar UFO al instante y vuelve a tocar para reubicarlo mientras exploras instalaciones.',
    ufoRadarTapMoveSubtext: 'Colocación rápida + ajuste por arrastre en campo.',
    heavyHaulDirectoryTitle: 'Directorio de Transporte Pesado',
    heavyHaulDirectoryDesc: 'Encuentra operadores de transporte pesado, servicios de camiones y alquiler de equipos en tu área.',
    jobsBoardTitle: 'Tablero de Trabajos',
    jobsBoardDesc: 'Publica trabajos, encuentra trabajo, haz ofertas en contratos. Conéctate directamente con operadores y contratistas.',
    hazardsAlertsTitle: 'Alertas de Peligros en Camino',
    hazardsAlertsDesc: 'Reporta peligros en caminos, casi accidentes, clima difícil e incidentes de campo para que equipos cercanos puedan reaccionar más rápido.',
    landingHazardSubtext: 'Hecho para tomar decisiones más seguras antes y durante el viaje.',
    dotAlertsTitle: 'Reportar Oficiales DOT',
    dotAlertsDesc: 'Marca retenes de transporte para alertar a las cuadrillas cercanas en tiempo real.',
    certVaultTitle: 'Certificados y Licencias',
    certVaultDesc: 'Captura el frente/reverso de tarjetas de entrenamiento, licencias y certificados. Guardado localmente; sincroniza a la nube (auth Telegram) para acceder en otros dispositivos.',
    aiAssistantTitle: 'Copiloto IA (Grok)',
    aiAssistantDesc: 'Tu IA personal que construye memoria de tus rutas, paradas frecuentes y patrones de trabajo. Cuanto más manejas, más inteligente se vuelve.',
    aiAssistantSubtext: '🧠 Aprende tu rutina diaria—mejorando constantemente',
    privacyFirstTitle: 'Diseño que Prioriza la Privacidad',
    privacyFirstDesc: 'No se necesita cuenta. Claves API ocultas del lado del servidor. Tu ubicación nunca se almacena. Reportes de peligros anónimos.',
    privacyFirstSubtext: 'Cifrado E2E vía Telegram • Sin rastreo • Sin anuncios 🔒',
    weatherDataTitle: 'Datos del Clima',
    weatherDataDesc: 'Impulsado por Google. Lluvia, UV, viento, temperatura con conmutación automática.',
    weatherDataSubtext: 'Alertas de inundaciones repentinas para seguridad en arroyos 🌊',
    nwsWeatherAlertsTitle: 'Alertas NWS del Clima',
    nwsWeatherAlertsDesc: 'Alertas en vivo del Servicio Meteorológico Nacional mostradas en toda la app y enviadas por vamosar_race_bot.',
    nwsWeatherAlertsSubtext: 'El riesgo del clima permanece visible mientras trabaja la cuadrilla.',
    dataTrustReportTitle: 'Reporte de Confianza de Datos',
    dataTrustReportDesc: 'Ve si los datos petroleros son en vivo, importados por horario, compilados de reportes públicos, antiguos, faltantes o estimados.',
    dataTrustReportSubtext: 'Sabe lo que la app sabe y de dónde viene.',
    productionAtlasMarketPulseTitle: 'Atlas de Producción / Pulso de Mercado',
    productionAtlasMarketPulseDesc: 'Resúmenes de producción, contexto de precios de materias primas, vistas por operador y avisos de estimación.',
    productionAtlasMarketPulseSubtext: 'Inteligencia petrolera con límites claros.',
    sosEmergencyCheckInTitle: 'SOS / Registro de Emergencia',
    sosEmergencyCheckInDesc: 'Marca un peligro de emergencia, deja que respondedores vean, naveguen o usen AR hacia ti, y ciérralo cuando estés a salvo.',
    sosEmergencyCheckInSubtext: 'Hecho para respuesta rápida en campo.',
    fullRadWideScanGlobeTitle: 'RAD Completo / Escaneo Amplio / Globo 3D',
    fullRadWideScanGlobeDesc: 'Escaneo de instalaciones de radio amplio, modo radar/lista y contexto petrolero 3D para planear antes de llegar.',
    fullRadWideScanGlobeSubtext: 'Ve más que el camino frente a ti.',
    workerProfilesPrivacyTitle: 'Perfiles de Trabajador + Privacidad',
    workerProfilesPrivacyDesc: 'Tarjetas públicas con iconos de rol, negocio, sitio web y teléfono opcionales, mientras Telegram permanece oculto salvo permiso.',
    workerProfilesPrivacySubtext: 'Una tarjeta de presentación de campo con privacidad primero.',
    englishSpanishTitle: 'Inglés y Español',
    englishSpanishDesc: 'Soporte completo de la aplicación en ambos idiomas. Sirviendo a la diversa fuerza laboral del campo petrolero.',
    englishSpanishSubtext: 'Más idiomas en camino',
    crewsTimesheetsTitle: 'Mis Cuadrillas',
    crewsTimesheetsDesc: 'Invitaciones con código QR, rastreo GPS en vivo, puntos de reunión con registros y hojas de horas semanales enviadas automáticamente a tu jefe.',
    crewsTimesheetsSubtext: 'Compatible con BYOD • Compartir ubicación que prioriza la privacidad',
    quadNavigationTitle: 'Navegación Google Maps',
    quadNavigationDesc: 'Soporte completo de waypoints para rutas de caliche. Navega por caminos de tierra sin mapear con coordenadas GPS.',
    quadNavigationSubtext: 'La única app con soporte multi-waypoint',
    landingApiRegistryEyebrow: 'Registro de APIs',
    landingApiRegistryTitle: 'Red de APIs de ZiaWellNav',
    landingApiRegistryDesc: 'Vista pública segura de servicios conectados, fuentes de datos avanzadas y rutas internas de Cloudflare que impulsan ZiaWellNav.',
    landingApiRegistryTotalLabel: 'Entradas del Registro de APIs',
    landingApiRegistryActiveExternalLabel: '{0} APIs Externas Activas',
    landingApiRegistryAdvancedLabel: '{0} APIs de Datos Avanzados',
    landingApiRegistryInternalLabel: '~{0} Rutas Internas de la App',
    landingApiRegistryRouteGroupsLabel: '{0} Grupos de Rutas Cloudflare',
    landingSmartJsaTitle: 'JSA Inteligentes',
    landingSmartJsaSubtitle: 'Análisis de seguridad del trabajo que funciona con tu equipo, no contra él',
    landingSmartJsaCrewNotificationsTitle: 'Avisos a la Cuadrilla',
    landingSmartJsaCrewNotificationsDesc: 'Cuando alguien de tu cuadrilla abre una ubicación con la misma aplicación, se le avisa al instante que tu equipo tiene un JSA activo que debe firmar',
    landingSmartJsaIncidentAwarenessTitle: 'Aviso de Incidentes OCD',
    landingSmartJsaIncidentAwarenessDesc: 'Cada vez que un usuario empieza un JSA, los reportes de incidentes OCD dentro de 1 milla se muestran automáticamente, incluyendo incidentes menores, medios y mayores enviados a OCD',
    landingSmartJsaAutoExpirationTitle: 'Expiración Automática',
    landingSmartJsaAutoExpirationDesc: 'Cuando 3 personas firman el JSA, se mantiene activo mientras cualquiera que lo firmó siga en sitio. Expira automáticamente cuando se va el último firmante',
    landingSmartJsaSafetyTrackingTitle: 'Seguimiento del Encargado de Seguridad',
    landingSmartJsaSafetyTrackingDesc: 'El encargado de seguridad puede rastrear todos los JSA, cumplimiento de cuadrilla y firmas dentro del panel Safety',
    landingSmartTimesheetsTitle: 'Hojas de Tiempo Inteligentes',
    landingSmartTimesheetsSubtitle: 'Nómina y cumplimiento que funcionan automáticamente, no manualmente',
    landingSmartTimesheetsDailySubmitTitle: 'Envío Diario Automático',
    landingSmartTimesheetsDailySubmitDesc: 'Las entradas de tiempo se envían automáticamente al panel de tu compañía todos los días; sin exportaciones manuales ni transferencias de archivos',
    landingSmartTimesheetsRealtimeTitle: 'Panel en Tiempo Real',
    landingSmartTimesheetsRealtimeDesc: 'Tu compañía ve horas y millas en tiempo real. Rastrea productividad de cuadrilla y facturación al instante desde cualquier lugar',
    landingSmartTimesheetsCrewVisibilityTitle: 'Visibilidad de Toda la Cuadrilla',
    landingSmartTimesheetsCrewVisibilityDesc: 'Ve todas las horas de la cuadrilla de un vistazo. Rastrea quién trabajó dónde, cuándo y cuánto tiempo; hecho para costos por trabajo y manejo de cuadrilla',
    landingSmartTimesheetsAuditTitle: 'Listo para Cumplimiento y Auditoría',
    landingSmartTimesheetsAuditDesc: 'Las marcas de tiempo y coordenadas GPS crean una auditoría. Todo queda documentado y listo para cumplimiento o resolución de disputas',
    googleApisTitle: 'APIs de Google',
    googleApisDesc: '22 APIs de Google integradas ahora: lugares, rutas, clima, elevación, mosaicos y más.',
    googleApisSubtext: 'Capacidades en constante expansión',
    semiHazmatTitle: 'Rutas para Camiones y Materiales Peligrosos',
    semiHazmatDesc: 'Enrutamiento optimizado para camiones y cargas de materiales peligrosos. Evita puentes bajos, límites de peso y carreteras restringidas.',
    semiHazmatSubtext: 'Diseñado para conductores profesionales',
    cyberThemeTitle: 'Tema Cibernético',
    cyberThemeDesc: 'Modo oscuro elegante con acentos de neón brillantes para turnos nocturnos. Modo de alto contraste para condiciones de luz diurna brillante.',
    cyberThemeSubtext: 'Fácil para los ojos, 24/7',
    materialDesignTitle: 'Material Design 3',
    materialDesignDesc: 'Construido sobre la última filosofía de Material Design 3 de Google. UI premium con colores dinámicos, elevación y movimiento.',
    materialDesignSubtext: 'El mismo lenguaje de diseño que las aplicaciones de Google',
    cloudflareTitle: 'Protegido por Cloudflare',
    cloudflareDesc: 'Seguridad de nivel empresarial con red global edge. Protección DDoS, SSL y tiempos de carga ultrarrápidos desde más de 300 centros de datos.',
    cloudflareSubtext: 'Base de datos D1 + Workers = respuestas instantáneas ⚡',
    realTimeDataTitle: 'Datos en Tiempo Real',
    realTimeDataDesc: 'Información de instalaciones actualizada regularmente desde múltiples fuentes',
    realTimeDataSubtext: 'Las actualizaciones llegan conforme las fuentes publican',
    offlineTitle: 'Descargar para Sin Conexión',
    offlineDesc: 'Accede a mapas y datos en el desierto, montañas o en cualquier lugar sin señal. Las descargas sin conexión funcionan mejor en Google Chrome; en Telegram dependen del almacenamiento del dispositivo y los límites de conexión—usa la descarga en Chrome para mejores resultados.',
    offlineSubtext: 'Descarga los 1.4 millones de pozos para búsqueda sin conexión—977K TX + 424K NM.',
    basinSafetyTitle: 'Canales de Seguridad de Cuenca',
    basinSafetyDesc: 'Recibe alertas de accidentes, tráfico e incidentes de campo cuando estén disponibles',
    basinSafetySubtext: 'La cobertura varía por cuenca',
    readyToStartTitle: '¿Listo para Comenzar?',
    readyToStartDesc: 'Inicia sesión con Telegram para datos de instalaciones en tiempo real, navegación por voz y canales de seguridad de cuenca. La mensajería se realiza en Telegram con cifrado de extremo a extremo.',
    compatibilityTitle: 'Compatibilidad y Beneficios de Telegram',
    supportedDevicesTitle: 'Dispositivos Compatibles',
    supportedDevicesDesc: 'iPhone, iPad, Android y la app de Telegram Desktop para macOS, Windows y ChromeOS. También funciona excelente en los navegadores Chrome y Safari.',
    telegramBenefitsTitle: '¿Por qué Telegram Mini App?',
    telegramBenefitsDesc: 'Inicio de sesión instantáneo, mensajería con cifrado de extremo a extremo y actualizaciones más rápidas para cuadrillas en campo.',
    telegramBenefitInstant: 'Acceso instantáneo — sin contraseñas, solo tu cuenta de Telegram',
    telegramBenefitEncrypted: 'Mensajería con cifrado de extremo a extremo para toda la cuadrilla',
    telegramBenefitUpdates: 'Actualizaciones más rápidas para cuadrillas en campo',
    freeTrialHeading: '🎁 Prueba Gratuita de 7 Días',
    forFieldProfessionals: 'Para Profesionales de Campo',
    individualPrice: '$10',
    individualSubheading: 'Herramientas para usuario de campo: navegación, formularios, JSA, temporizador, hojas de tiempo, certs, IA y alertas',
    individualAccessNote: 'Los planes Individuales no incluyen Company Dashboard. Elige Empresarial para gestión de cuadrillas, políticas, capacitación, flota, seguridad y registros de la compañía.',
    individualFeature1: '✓ 1.4 Millones de Pozos e Instalaciones (NM + TX)',
    individualFeature2: '✓ Navegación por Voz e Instrucciones Paso a Paso',
    individualFeature3: '✓ Inspecciones Pre/Post Viaje',
    individualFeature4: '✓ Análisis de Seguridad (JSA) con Firma del Equipo',
    individualFeature5: '✓ Herramientas Personales de Equipo y Órdenes de Trabajo',
    individualFeature6: '✓ Temporizador y Hojas de Tiempo',
    individualFeature7: '✓ Asistente IA (Grok)',
    individualFeature8: '✓ Reporte y Alertas de Peligros Viales',
    individualFeature9: '✓ Clima, Calidad del Aire y Polen',
    individualFeature10: '✓ Bóveda de Certs y Licencias',
    individualFeature11: '✓ Gastos, Recibos y OCR de Tickets',
    individualFeature12: '✓ Rutas Comunitarias, Poop Pins y Taqueros',
    individualFeature13: '✓ Mapas Sin Conexión y Sincronización (PWA)',
    individualFeature14: '✓ Inglés y Español',
    individualFeature15: '✓ Bolsa de Trabajo y Mercado de Servicios',
    individualFeature16: '✓ Enlace de navegación con Google Maps',
    businessPlansHeading: 'Planes Empresariales',
    starterLabel: 'INICIAL',
    starterPrice: '$7',
    perUserMonth: '/usuario/mes',
    starterRange: '5-25 usuarios',
    teamLabel: 'EQUIPO',
    teamPrice: '$6',
    teamRange: '26-100 usuarios',
    fleetLabel: 'FLOTA',
    fleetPrice: '$5',
    fleetRange: '101-250 usuarios',
    enterpriseLabel: 'EMPRESA',
    enterprisePrice: '$4',
    enterpriseRange: '251+ usuarios',
    founding50Heading: '🏆 Programa Fundadores 50',
    founding50Desc: 'Cualquier empresa de servicios petroleros en el Condado de Lea (Hobbs, Lovington, Eunice, Tatum, etc.) • Primeras 50 empresas',
    founding50Price: '$4/usuario/mes fijo por 3 años (prepago anual)',
    founding50Spots: 'lugares restantes',
    founding50Locked: 'Tarifa fija por 3 años • Hasta 250 asientos a la tarifa fundadora',
    // Pricing card feature lists (emoji prefix, used in PricingSection.tsx)
    pricingIndFeature1: '🗺️ 1.4M+ Pozos e Instalaciones — NM y TX con nav por voz',
    pricingIndFeature2: '📋 Inspecciones DOT, JSA y Firmas Digitales',
    pricingIndFeature3: '⏱️ Temporizador, Hojas de Tiempo y Herramientas Personales de Equipo',
    pricingIndFeature4: '🤖 Asistente IA, Clima, Peligros y Alertas',
    pricingIndFeature5: '📱 Mapas offline, recibos, certs y bilingüe (EN/ES)',
    pricingIndFeatureSubtext: '20+ herramientas para profesionales petroleros',
    pricingIndFeatureMonthlyCharity: '💚 10% va a Weekend Hunger Initiative',
    pricingIndFeatureYearlyBonus: '🎁 2 meses GRATIS (ahorro de $20)',
    pricingIndFeatureYearlyCharity: '💚 20% va a Weekend Hunger Initiative',
    pricingBizFeature1: '👥 Todo lo Individual para cada usuario pagado',
    pricingBizFeature2: '🏢 Company Dashboard: políticas, capacitación, flota, seguridad y registros',
    pricingBizFeature3: '💰 Precios por volumen desde $4/usuario/mes (100+)',
    pricingBizFeature4: '🎯 Soporte dedicado y verificación de empresa',
    pricingBizFeatureCharity: '💚 10% mensual / 20% anual a Weekend Hunger Initiative',
    allBusinessPlansInclude: 'Todos los Planes Empresariales Incluyen:',
    businessFeature1: '✓ Todo lo Individual para cada usuario pagado',
    businessFeature2: '✓ Company Dashboard para políticas, capacitación, flota, seguridad, registros e invitaciones de cuadrilla',
    businessFeature3: '✓ Precios por volumen desde $4/usuario/mes (100+)',
    businessFeature4: '✓ Soporte dedicado y verificación de empresa',
    businessAccessNote: 'Los planes Empresariales incluyen Company Dashboard para cuadrillas, políticas, capacitación, flota, seguridad y registros de la compañía.',
    comparisonHeading: 'Individual vs Empresarial',
    individualPlanTitle: 'Individual — $10/mes',
    businessPlanTitle: 'Empresarial — $4-7/usuario/mes',
    privacyFirstHeading: '🔒 Tu Privacidad Primero:',
    privacyFirstText: 'No se requiere cuenta: Telegram maneja la autenticación. Todas las claves API (Google, OpenWeather) están solo del lado del servidor; nunca las ves ni las transmites. Tu ubicación se procesa del lado del cliente y nunca se almacena en nuestros servidores. La identidad del reportero de peligros es siempre anónima: solo alertas a nivel de cuenca, sin coordenadas exactas. Cifrado E2E a través de Telegram. Auto-eliminación después de 24 horas. Sin rastreo, sin anuncios, sin ventas de datos.',
    pricingDisclaimer: '💡 La prueba de 7 días aplica al plan seleccionado • Company Dashboard requiere Empresarial • Cancela en cualquier momento',
    loginTermsText: 'Al iniciar sesión, aceptas los',
    termsOfService: 'Términos de Servicio',
    and: 'y la',
    privacyPolicy: 'Política de Privacidad',
    madeWithLove: 'Hecho con ❤️ por',
    ziatechsLink: 'Zia Techs',
    charityText: 'Donamos un porcentaje de cada suscripción a',
    packsForHunger: 'WHI Hobbs',
    donationBadgeLabel: 'WHI Hobbs',
    donationMilestoneMessage: '🎉 ¡Increíble! ¡Has ayudado a proporcionar {0} comidas!',
    donationFirstTimeMessage: '💚 ¡Bienvenido! Tu suscripción dona a WHI Hobbs a través de Stripe Connect.',
    // Flock Cameras
    // Worker Profile
    workerProfileTitle: '¿Cuál es tu rol?',
    workerProfileDesc: 'Elige tu tipo de trabajador petrolero. Otros trabajadores verán tu tarjeta en AR.',
    workerProfileSaved: '¡Perfil de trabajador guardado!',
    workerProfileSkip: 'Omitir por ahora',
    flockCameraTitle: 'Cámara Flock',
    flockCameraAlert: '🐦 Cámara Flock Adelante',
    flockCameraAlertDesc: 'Cámara ALPR reportada a {0}',
    flockCameraReported: '¡Cámara Flock reportada!',
    flockCameraVoteHelpful: 'Sigue Ahí',
    flockCameraGone: 'Ya No Está',
    copyright: '© 2026 Zia Well Nav',
    
    // Community Impact Section
    communityImpactTitle: 'Impacto Comunitario',
    communityImpactDesc: 'Una parte de cada suscripción apoya a WHI Hobbs, ayudando a alimentar familias en los mismos pueblos que apoyan al campo petrolero.',
    viewImpactReport: 'Ver Informe de Impacto',
    monthlyDonation: 'de suscripciones mensuales',
    annualDonation: 'todas las suscripciones comerciales',
    packsForHungerDesc: 'La Weekend Hunger Initiative entrega bolsas de comida de fin de semana a más de 1,200 estudiantes de Hobbs ISD que enfrentan inseguridad alimentaria cada viernes. Cada bolsa contiene comidas nutritivas para asegurar que ningún niño pase hambre cuando las comidas escolares no están disponibles.',
    quarterlyImpact: '📊 Publicamos informes de impacto trimestrales mostrando exactamente cómo tu suscripción ayuda a alimentar a niños locales.',
    dailyImpact: '📊 Donaciones diarias en cadena • Recibos y totales publicados en la app.',
    
    // FAB labels (more comprehensive)
    search: 'Buscar',
    aiAssistant: 'Asistente IA',
    favoritesTooltip: 'Favoritos',
    mapSettings: 'Configuración de Mapa',
    calicheRoutesTooltip: 'Rutas de Caliche',
    activity: 'Actividad',
    jobs: 'Trabajos',
    suggestions: 'Sugerencias',
    timer: 'Temporizador',
    networkStatus: 'Estado de Red',
    qrShare: 'Compartir QR',
    voice: 'Voz',
    services: 'Servicios',
    basinCommunity: 'Comunidad de Cuenca',
    crews: 'Equipos',
    friends: 'Amigos',
    
    // Common UI elements
    openWellNavigator: 'Abrir Navegador de Pozos',
    subscription: 'Suscripción',
    subscriptionInfo: 'Info de Suscripción',
    individual: 'Individual',
    business: 'Empresarial',
    perMonth: '/mes',
    perYear: '/año',
    savePercent: 'Ahorra {0}%',
    choosePlan: 'Elige tu Plan',
    trialSubheading: 'Prueba de 7 días en el plan seleccionado • Individual es acceso de campo • Empresarial incluye Company Dashboard',
    monthly: 'Mensual',
    annualTwoMonthsFree: 'Anual (2 meses GRATIS)',
    saveYearly: '¡Ahorra $20/año (2 meses gratis!)',
    goesToPacksForHunger: 'va a Weekend Hunger Initiative',
    startingCheckout: 'Iniciando pago...',
    startFreeTrial: 'Comenzar Prueba de 7 Días',
    howManyLicenses: '¿Cuántas licencias necesitas?',
    tierLabel: 'Nivel',
    usersLabel: 'usuarios',
    seatSubtotalLabel: 'Subtotal de asientos',
    documentationFeeLabel: 'Tarifa de documentación',
    businessTotalLabel: 'Total empresarial',
    charitySeatsOnlyNote: 'Incluye el 20% de la tarifa de documentación',
    customBotSetupLabel: 'Configuración de bot personalizado',
    customBotSetupTitle: 'Agregar integración de bot personalizado',
    customBotSetupDescription: 'Bot de Telegram opcional con marca de la compañía para avisos, recordatorios de reuniones, prompts de capacitación y políticas, seguimiento de formularios, enlaces de cuadrilla y soporte. Los registros privados siguen privados sin bot personalizado; este complemento mejora la comunicación con marca.',
    customBotSetupPrice: '$1,000 configuración única',
    customBotDesiredName: 'Nombre o usuario deseado del bot',
    customBotContactEmail: 'Correo de contacto para configuración',
    customBotUseCase: 'Caso de uso o notas de configuración',
    startTrialForUsers: 'Comenzar Prueba para {0} Usuarios',
    charityBannerTitle: '10% mensual / 20% anual a Weekend Hunger Initiative 🎒',
    charityBannerDesc: 'Donaciones diarias en cadena • Recibos publicados en la app',
    stripeFooter: 'Pago asegurado por Stripe 🔒 • Cobro automático tras la prueba de 7 días si no cancelas',
    preparingCheckout: 'Preparando pago seguro…',
    minLicensesError: 'Se requieren mínimo {0} licencias para planes empresariales',
    maxLicensesError: 'Máximo {0} licencias soportadas en el pago automático',
    features: 'Características',
    
    // Messages & Toasts
    homeSaved: '¡Ubicación de inicio guardada!',
    navigatingHome: 'Navegando a casa...',
    locationCaptured: '¡Ubicación capturada! Agrega un nombre y guarda.',
    geolocationNotSupported: 'La geolocalización no es compatible con tu navegador',
    failedToSave: 'Error al guardar',
    routeDeleted: 'Ruta eliminada',
    routeSaved: 'Ruta guardada',
    photoUploaded: 'Foto subida',
    addFavoritesFirst: '¡Agrega algunos favoritos primero para verlos en el mapa!',
    
    // Directions & Navigation
    findingNearestWell: 'Buscando el pozo más cercano...',
    couldNotSearch: 'No se pudo buscar "{0}". {1}',
    noCachedResults: 'No hay resultados en caché disponibles.',
    pleaseTryAgain: 'Inténtalo de nuevo.',
    
    // Cache & Data
    cacheVerified: 'Caché Verificado: Todos los datos en caché son válidos',
    noCachedData: 'No hay datos en caché para verificar. Descarga algunas cuencas primero.',
    failedToVerify: 'Error al verificar la integridad del caché',
    cacheImported: 'Caché Importado: El caché del equipo se ha fusionado con éxito',
    failedToImport: 'Error al importar el caché',
    historyCleared: 'Historial Borrado: El historial de búsqueda ha sido eliminado',
    failedToClear: 'Error al borrar el historial de búsqueda',
    cacheCleared: 'Caché Borrado: Todos los datos en caché han sido eliminados',
    failedToClearCache: 'Error al borrar el caché',
    dataUpdated: 'Datos Actualizados: Los datos de instalaciones se actualizaron durante la noche',
    
    // Voice Navigation specific
    voiceSearchNotSupported: '¡La búsqueda por voz no es compatible con Telegram en Android. Por favor usa la barra de búsqueda para escribir tu búsqueda, o toca los botones de tipo de instalación abajo!',
    speakToSearch: 'Habla para buscar',
    typeToSearch: 'Escribe para buscar',
    voiceNotSupportedDevice: 'Reconocimiento de voz no compatible con este dispositivo. Intenta escribir tu búsqueda en su lugar.',
    commandNotRecognized: 'Comando no reconocido. Inténtalo de nuevo.',
    commandNotImplemented: 'Comando aún no implementado',
    failedToProcessCommand: 'Error al procesar el comando',
    locationAccessRequired: 'Se requiere acceso a la ubicación',
    searchFailedRetry: 'Error en la búsqueda. Por favor, inténtalo de nuevo.',
    gpsCrewActive: 'GPS y equipo activo',
    gpsActive: 'GPS activo',
    gpsControls: 'Controles de GPS',
    gpsSharingRequiredTitle: '🔒 Compartir ubicación requerido',
    gpsSharingRequiredMessageNamed: 'Como miembro de "{0}", tu ubicación debe compartirse con tu equipo para coordinación de seguridad. Solo los dueños del equipo pueden modificar esta configuración.',
    gpsSharingRequiredMessageGeneric: 'Como miembro de un equipo, tu ubicación debe compartirse con tu equipo para coordinación de seguridad. Solo los dueños del equipo pueden modificar esta configuración.',
    understood: 'Entendido',
    gpsLocationOn: 'Ubicación ACTIVADA',
    gpsLocationOff: 'Ubicación DESACTIVADA',
    gpsRequiredForNavigation: 'Requerido para navegar',
    gpsSharingRequiredLabel: '🔒 Compartir requerido',
    gpsCrewSharingOn: 'Compartir equipo ACTIVADO',
    gpsCrewSharingOff: 'Compartir equipo DESACTIVADO',
    gpsLockedByMembershipNamed: 'Bloqueado por pertenecer a {0}',
    gpsLockedByMembershipGeneric: 'Bloqueado por pertenecer al equipo',
    gpsShareWithCrew: 'Comparte con tu equipo',
    arBackToVoiceNavigation: 'Volver a navegación por voz',
    arRecoverFrozenView: 'Recuperar vista AR congelada',
    arStalledTapRecover: 'AR parece detenida — toca para recuperar',
    arNoCameraFound: 'No se encontró cámara en este dispositivo.',
    arFindWithCamera: 'Buscar con Cámara',
    arWaitingForGps: 'Esperando GPS',
    arWaitingGpsBeforeCamera: 'Esperando GPS antes de buscar instalaciones con la cámara.',
    arWaitingGpsLocation: 'Esperando ubicación GPS',
    arFinding: 'Buscando',
    arLoadingLower: 'cargando',
    arFoundCount: '{0} encontrados',
    arAllFacilities: 'Todas las Instalaciones',
    arMoreTypes: 'Más Tipos',
    arWideScan: 'Escaneo Amplio',
    arBirds: 'Aves',
    arDots: 'Puntos',
    arOperators: 'Operadores',
    arAllOps: 'Todas Ops',
    arFacilityTypes: 'Tipos de Instalación',
    arLoadMore: 'Cargar Más',
    arTapToExpand: 'Toca para expandir',
    safetyWindSockH2S: 'H2S',
    safetyWindSockRunCrosswind: 'CORRE VIENTO CRUZADO',
    safetyWindSockRunToward: 'CORRE {0}',
    safetyWindSockWindFrom: 'Viento de',
    safetyWindSockDownwind: 'A favor del viento',
    safetyWindSockUnavailable: 'Viento no disponible',
    safetyWindSockStale: 'Desactualizado',
    safetyWindSockUpdated: 'Actualizado {0}',
    safetyWindSockGusts: 'Ráfagas {0} mph',
    safetyWindSockAria: 'Guía H2S de viento cruzado. Viento de {0} a {1} mph. Corre {2}.',
    safetyWindSockUnavailableAria: 'Guía H2S de viento cruzado no disponible. Se necesitan GPS y clima.',
    
    // Location Errors
    locationPermissionDenied: '📍 Permiso de ubicación denegado. Por favor habilita la ubicación en la configuración de tu navegador/dispositivo para reportar avistamientos de osos.',
    locationUnavailable: '📍 Ubicación no disponible. Asegúrate de que el GPS esté habilitado en tu dispositivo.',
    locationTimeout: '📍 Tiempo de espera de ubicación agotado. Por favor intenta de nuevo en un área con mejor señal GPS.',
    locationErrorGeneric: '📍 No se pudo obtener tu ubicación. Por favor verifica la configuración de ubicación e inténtalo de nuevo.',
    
    // Hazard/Bear Reporting
    failedToReportBear: '⚠️ Error al reportar oso. Por favor verifica tu conexión a internet e inténtalo de nuevo.',
    hazardReportTitle: 'Reportar peligro en carretera',
    hazardReportedTitle: '¡Peligro reportado!',
    hazardReportedThanks: 'Gracias por ayudar a mantener seguros a otros conductores.',
    hazardLocationRequired: 'Ubicación requerida',
    hazardUpdateLocation: 'Actualizar',
    hazardGetLocation: 'Obtener ubicación',
    hazardTypePrompt: '¿Qué tipo de peligro?',
    hazardDetailsLabel: 'Detalles adicionales (opcional)',
    hazardDetailsPlaceholder: "p. ej., 'Solo carril norte', 'Cerca del marcador 42'",
    hazardInfoText: 'Otros conductores pueden votar para confirmar o descartar peligros. Los reportes con múltiples confirmaciones duran más, mientras que los disputados se eliminan más rápido.',
    hazardReporting: 'Reportando...',
    hazardReportButton: 'Reportar peligro',
    hazardLocationAccuracyWarning: '⚠️ La precisión de ubicación es ±{0} m. Si no parece correcta, inténtalo de nuevo.',
    hazardLocationErrorDefault: 'No se pudo obtener tu ubicación. Habilita el GPS e inténtalo de nuevo.',
    hazardLocationUnavailable: 'No se pudo obtener la ubicación.',
    hazardCrashLabel: 'Choque',
    hazardCrashDesc: 'Accidente o colisión en la carretera',
    hazardCrashDuration: '3 horas',
    hazardSlowdownLabel: 'Lentitud',
    hazardSlowdownDesc: 'Tráfico lento o congestionado',
    hazardSlowdownDuration: '1 hora',
    hazardConstructionLabel: 'Construcción',
    hazardConstructionDesc: 'Obras viales o zona de construcción',
    hazardConstructionDuration: '8 horas',
    hazardLaneClosureLabel: 'Cierre de carril',
    hazardLaneClosureDesc: 'Uno o más carriles bloqueados',
    hazardLaneClosureDuration: '4 horas',
    hazardObjectOnRoadLabel: 'Objeto en la vía',
    hazardObjectOnRoadDesc: 'Escombros, llanta, animal u obstáculo en la vía',
    hazardObjectOnRoadDuration: '1 hora',
    hazardFloodedRoadLabel: 'Carretera inundada',
    hazardFloodedRoadDesc: 'Agua sobre la vía: da la vuelta, no te arriesgues',
    hazardFloodedRoadDuration: '6 horas',
    hazardLowVisibilityLabel: 'Baja visibilidad',
    hazardLowVisibilityDesc: 'Niebla, tormenta de polvo, humo o lluvia intensa',
    hazardLowVisibilityDuration: '2 horas',
    hazardCopLabel: 'Policía',
    hazardCopDesc: 'Policía detectada: se convierte en control tras 30 min',
    hazardCopDuration: '30 min + fantasma',
    hazardSafetyInspectorLabel: 'Inspector de seguridad',
    hazardSafetyInspectorDesc: 'Inspector de seguridad detectado: punto de control en sitio',
    hazardSafetyInspectorDuration: '30 min + fantasma',
    hazardFireLabel: 'Incendio',
    hazardFireDesc: 'Incendio activo reportado. Mantente alejado y sigue los protocolos de seguridad.',
    hazardFireDuration: '4 horas',
    hazardDotOfficerLabel: 'Oficial DOT',
    hazardDotOfficerDesc: 'Oficial del DOT detectado - punto de inspección adelante',
    hazardDotOfficerDuration: '30 min + fantasma',
    hazardPersonalInjuryLabel: 'Lesión Personal',
    hazardPersonalInjuryDesc: 'Estás herido - alerta a trabajadores cercanos para ayuda',
    hazardPersonalInjuryDuration: '4 horas',
    hazardInjuredWorkerLabel: 'Trabajador Herido',
    hazardInjuredWorkerDesc: 'Otro trabajador está herido - reporta su ubicación para ayuda',
    hazardInjuredWorkerDuration: '4 horas',
    hazardTruckBrokeDownLabel: 'Camión Averiado',
    hazardTruckBrokeDownDesc: 'Camión averiado en la carretera - advierte a los conductores de la obstrucción',
    hazardTruckBrokeDownDuration: '4 horas',
    
    // Route Messages
    routeNoLandmarks: 'La ruta no tiene puntos de referencia',
    routeNoFinish: 'La ruta no tiene ubicación de finalización',
    route: 'ruta',
    routes: 'rutas',
    points: 'puntos',
    inAppNav: 'Navegación en la app',
    viewRoute: 'Ver ruta',
    googleMaps: 'Google Maps',
    calicheRoute: 'Ruta de caliche',
    routeFromMainRoad: 'Ruta desde la carretera principal',
    routeToFacility: 'Ruta a la instalación',
    routesNoneTitle: 'Aún no se han compartido rutas',
    routesNoneSubtitle: '¡Sé el primero en dibujar una ruta!',
    routesSortedByVotes: '{0} {1} • ordenadas por votos',
    routesCountLabel: '{0} {1}',
    topRoute: 'MEJOR RUTA',
    showNotes: 'Mostrar notas',
    hideNotes: 'Ocultar notas',
    anonymousUser: 'Anónimo',
    routesShareTitle: 'Ruta de caliche',
    routesShareStartLabel: 'Inicio',
    routesShareFindMore: 'Ver más',
    routesLoadFailed: 'No se pudieron cargar las rutas',
    routesLoadError: 'Error al cargar rutas',
    waypointTurn: 'Giro',
    waypointLandmark: 'Punto de referencia',
    waypointGate: 'Puerta',
    waypointWarning: 'Advertencia',
    waypointMarker: 'Marcador',
    routeReviewTitle: 'Revisar ruta',
    routeLandmarksCaptured: '{0} / {1} puntos de referencia capturados',
    routeNameLabel: 'Nombre de la ruta *',
    routeNamePlaceholder: 'p. ej., Acceso principal desde la carretera 285',
    routeDescriptionLabel: 'Descripción (opcional)',
    routeDescriptionPlaceholder: 'Consejos para otros conductores...',
    routeDifficultyLabel: 'Dificultad:',
    routeDifficultyEasy: 'Fácil',
    routeDifficultyModerate: 'Med',
    routeDifficultyHard: 'Difícil',
    routeSurfaceLabel: 'Superficie:',
    routeSurfacePaved: 'Pavimento',
    routeSurfaceCaliche: 'Caliche',
    routeSurfaceDirt: 'Tierra',
    routeDestinationLabel: 'Destino: {0}{1}',
    routePhotosMarkedForRetake: '{0} {1} para repetir',
    routeLandmarksWithoutPhotos: '{0} {1} sin fotos - aún se pueden enviar',
    routeCapturedPhotosLabel: 'Fotos capturadas:',
    routeNeedsRetakeLabel: 'Repetir',
    routeNoPhotosCaptured: 'No hay fotos capturadas',
    routeSaveWithoutPhotos: 'La ruta aún se puede guardar sin fotos',
    routeSaveDraft: 'Guardar borrador',
    routeSaving: 'Guardando...',
    routePublishing: 'Publicando...',
    routePublish: 'Publicar',
    routeNameRequiredError: 'Por favor ingresa un nombre de ruta',
    routeRetakeBeforePublishError: 'Por favor repite o elimina las fotos marcadas antes de publicar.',
    routeLandmarkLabel: 'Punto de referencia {0}',
    photo: 'foto',
    photos: 'fotos',
    landmark: 'punto de referencia',
    landmarks: 'puntos de referencia',
    routeRecordingDefaultName: 'Grabación de ruta',
    recordingLabel: 'REC',
    autoCaptureOn: 'Captura automática ACTIVADA',
    autoCaptureOff: 'Captura automática DESACTIVADA (solo manual)',
    routeProgress: 'Progreso de ruta',
    waypointsProgress: '{0}/{1} puntos',
    nextWaypoint: 'SIGUIENTE PUNTO',
    waypointNumber: 'Punto {0}',
    capturingPhoto: '📸 Capturando foto...',
    waypoint: 'Punto',
    lastCapture: 'Última captura',
    savedLabel: '✓ Guardado',
    acquiringGps: 'Adquiriendo GPS...',
    failedToExportCache: 'Error al exportar caché',
    
    // Dialog Titles
    downloadOfflineMap: 'Descargar Mapa Sin Conexión',
    
    // Dialog Content
    selectBasin: 'Selecciona en qué cuenca trabajarás:',
    selectCounty: 'Selecciona el condado para filtrar pozos, o busca todos:',
    searchPlaceholderFull: 'Buscar pozos, operadores, números API...',
    
    // Onboarding/Help
    voiceSearchTitle: 'Búsqueda por Voz',
    voiceSearchDesc: 'Búsqueda sin manos mientras conduces. Di un pozo, API, operador o ubicación.',
    voiceSearchIOS: 'iOS: Toca la barra de búsqueda, luego "Toca para Búsqueda por Voz" y habla.',
    voiceSearchAndroid: 'Android: Toca la barra de búsqueda y luego el ícono del micrófono en el teclado (abajo a la izquierda).',
    dayAndNight: 'Día y Noche',
    chipComingSoon: '🔜 Próximamente',
    chipOptOut: 'Opcional',
    chip32Types: '62 Tipos',
    chip3Options: '3 Opciones',
    chip22GoogleApis: '22 APIs de Google',
    chipCDLReady: 'Listo CDL',
    chipGoogleM3: 'Google M3',
    chipGlobalCDN: 'CDN Global',
    fabButtonsTitle: 'Botones FAB',
    tapToOpen: '• Tocar: Abrir la función',
    longPressToDrag: '• Presión larga: Arrastrar para reordenar o mover',
    moveFabsBetweenZones: '• Arrastra entre las zonas superior, izquierda, derecha e inferior',
    helpCoreFeaturesTitle: 'Funciones Principales',
    helpCoreFeaturesDesc: 'Las herramientas de campo principales que más usan las cuadrillas dentro de la app.',
    helpCoreFeatureVoiceSearchTitle: 'Búsqueda por Voz',
    helpCoreFeatureVoiceSearchDesc: 'Busca sin manos mientras conduces diciendo un pozo, API, operador, instalación o ubicación.',
    helpCoreFeatureVoiceSearchHint: 'Encuéntralo: Barra de búsqueda: Búsqueda por Voz',
    helpCoreFeatureHazardsTitle: 'Peligros',
    helpCoreFeatureHazardsDesc: 'Reporta y ve peligros en caminos, policías, DOT, clima difícil e incidentes de campo.',
    helpCoreFeatureHazardsHint: 'Encuéntralo: FAB: Peligros / Reportar Peligro',
    helpCoreFeature2dMapTitle: 'Mapa 2D',
    helpCoreFeature2dMapDesc: 'Usa el mapa normal para pozos, favoritos, peligros, capas y rutas.',
    helpCoreFeature2dMapHint: 'Encuéntralo: FAB: Ver en el Mapa',
    helpCoreFeatureArViewTitle: 'Vista AR',
    helpCoreFeatureArViewDesc: 'Apunta la cámara para ver pozos e instalaciones cercanas en la vista de campo.',
    helpCoreFeatureArViewHint: 'Encuéntralo: Vista AR',
    helpCoreFeatureApiQuickDialTitle: 'Marcador API Rápido',
    helpCoreFeatureApiQuickDialDesc: 'Ingresa rápido un número API conocido y salta directo al pozo.',
    helpCoreFeatureApiQuickDialHint: 'Encuéntralo: FAB: Quick Dial API #',
    helpCoreFeatureApiListTitle: 'Lista API',
    helpCoreFeatureApiListDesc: 'Explora números API y pozos cuando no tienes memorizado el número exacto.',
    helpCoreFeatureApiListHint: 'Encuéntralo: FAB: Browse API Numbers',
    helpCoreFeatureFavoritesTitle: 'Favoritos',
    helpCoreFeatureFavoritesDesc: 'Guarda pozos e instalaciones importantes para abrirlos o navegar rápido después.',
    helpCoreFeatureFavoritesHint: 'Encuéntralo: FAB: Favoritos',
    helpCoreFeatureFacilityChipsTitle: 'Chips de Instalaciones',
    helpCoreFeatureFacilityChipsDesc: 'Explora pozos e instalaciones por tipo en vez de escribir una búsqueda.',
    helpCoreFeatureFacilityChipsHint: 'Encuéntralo: FAB: Facility Chips',
    helpCoreFeatureJsaTitle: 'JSA',
    helpCoreFeatureJsaDesc: 'Crea un Análisis de Seguridad con peligros, PPE, contactos de emergencia y firmas de la cuadrilla.',
    helpCoreFeatureJsaHint: 'Encuéntralo: FAB: New JSA',
    helpCoreFeaturePrePostTripTitle: 'Pre/Post Viaje',
    helpCoreFeaturePrePostTripDesc: 'Completa formularios de inspección vehicular antes y después del viaje.',
    helpCoreFeaturePrePostTripHint: 'Encuéntralo: Menú: Pre/Post Viaje',
    helpCoreFeatureSearchTitle: 'Búsqueda',
    helpCoreFeatureSearchDesc: 'Busca por nombre de pozo, API, operador, instalación o dirección.',
    helpCoreFeatureSearchHint: 'Encuéntralo: FAB: Search Facilities',
    helpCoreFeatureAiTitle: 'IA',
    helpCoreFeatureAiDesc: 'Pregunta al copiloto IA sobre rutas, pozos, formularios y dudas de campo.',
    helpCoreFeatureAiHint: 'Encuéntralo: FAB: AI',
    
    // SearchResults UI
    selectALetter: 'Selecciona una primera letra para profundizar',
    removeFromFavoritesTooltip: 'Quitar de Favoritos',
    addToFavoritesTooltip: 'Agregar a Favoritos',
    viewDetailsAction: 'Ver Detalles',
    viewDetailsTooltip: 'Ver Detalles',
    viewOnMapTooltip: 'Ver en el Mapa',
    shareTooltip: 'Compartir',
    inAppNavTooltip: 'Navegación Interna',
    googleTooltip: 'Google',
    appleTooltip: 'Apple',
    wazeTooltip: 'Waze',
    photoGalleryTooltip: 'Galería de Fotos',
    shownOfTotal: '{0}/{1} mostrados',
    loadingMore: 'Cargando más...',
    facilityPhotos: 'Fotos de {0}',
    
    // Crew Panel
    timesheet: 'Hoja de Horas',
    refresh: 'Actualizar',
    locationSharing: 'Compartir Ubicación',
    locationVisible: 'Tu ubicación es visible para los miembros del equipo',
    locationPrivate: 'Tu ubicación es privada (amigable con BYOD)',
    createCrew: 'Crear Equipo',
    joinCrew: 'Unirse al Equipo',
    description: 'Descripción (opcional)',
    descriptionPlaceholder: '¿Para qué es este equipo?',
    create: 'Crear',
    inviteCode: 'Código de Invitación',
    inviteCodePlaceholder: 'ej., ABC123',
    join: 'Unirse',
    members: 'miembros',
    member: 'miembro',
    inviteCodeCopied: '¡Código de invitación copiado!',
    inviteShared: '¡Invitación compartida!',
    confirmLeave: '¿Estás seguro de que quieres salir de este equipo?',
    leftCrew: 'Has salido del equipo',
    confirmDelete: '¿Estás seguro de que quieres eliminar este equipo? Esta acción no se puede deshacer.',
    crewDeleted: 'Equipo eliminado',
    activeMeetings: 'Reuniones Activas',
    checkIns: '{0} registros',
    radiusMeters: 'radio de {0}m',
    checkIn: 'Registrarse',
    setMeetingPoint: 'Establecer Punto de Reunión',
    leadTimesheetSettings: 'Configuración de Líder y Hoja de Horas',
    createMeetingPoint: 'Crear Punto de Reunión',
    meetingLocationDesc: 'Esto creará un punto de reunión en tu ubicación actual.',
    meetingName: 'Nombre de la Reunión',
    meetingNamePlaceholder: 'ej., Reunión Matutina',
    checkInRadius: 'Radio de registro: {0}m',
    makeAdmin: 'Hacer Administrador',
    removeAdmin: 'Quitar Administrador',
    removeFromCrew: 'Quitar del Equipo',
    scanToJoin: 'Escanear para Unirse',
    orShareCode: 'O comparte este código:',
    leadName: 'Nombre del Líder/Supervisor',
    leadNamePlaceholder: 'ej., Juan Pérez',
    leadEmail: 'Email del Líder',
    leadEmailPlaceholder: 'ej., lider@empresa.com',
    companyName: 'Nombre de la Empresa',
    companyNamePlaceholder: 'ej., Servicios Energéticos ABC',
    autoSubmitTimesheet: 'Enviar hoja de horas automáticamente cada semana',
    submitOn: 'Enviar el',
    monday: 'Lunes',
    tuesday: 'Martes',
    wednesday: 'Miércoles',
    thursday: 'Jueves',
    friday: 'Viernes',
    saturday: 'Sábado',
    sunday: 'Domingo',
    settingsSaved: '¡Configuración guardada!',
    timesheetSettingsDesc: 'Configura dónde se envían automáticamente las hojas de horas semanales.',
    liveMemberLocations: 'Ubicaciones de Miembros en Vivo',
    noMembersSharedLocation: 'Ningún miembro ha compartido su ubicación recientemente.',
    submitWeeklyTimesheet: 'Enviar Hoja de Horas Semanal',
    timesheetSubmitDesc: 'Esto enviará la hoja de horas de la semana actual a tu líder ({0}).',
    noEmailConfigured: 'sin email configurado',
    week: 'Semana',
    notesOptional: 'Notas (opcional)',
    notesPlaceholder: 'Notas adicionales para tu líder...',
    noLeadEmailWarning: 'No hay email de líder configurado. Por favor configura los ajustes del líder primero.',
    submitToLead: 'Enviar al Líder',
    locationNotAvailable: 'Ubicación no disponible. Por favor habilita los servicios de ubicación.',
    roleUpdated: 'Rol actualizado a {0}',
    memberRemoved: 'Miembro eliminado',
    failedToShare: 'Error al compartir invitación',
    confirmRemove: '¿Quitar a {0}?',
    notPartOfCrews: 'Aún no eres parte de ningún equipo.',
    createOrJoinCrew: '¡Crea uno o únete con un código de invitación!',
    
    // MorningPulse
    loadingBasinPulse: 'Cargando resumen del basin...',
    unableToLoadPulse: 'No se pudo cargar el resumen del basin',
    noDataAvailable: 'Sin datos disponibles',
    digestStaleFallback: 'Mostrando datos del {0} — el período actual aún no tiene entradas nuevas.',
    freshnessBannerStale: '{0} fuente(s) sin actualizar — algunos datos pueden estar desactualizados.',
    freshnessBannerMissing: '{0} fuente(s) no disponibles — cobertura incompleta.',
    layerSourceUnavailable: 'Fuente de la capa no disponible — mostrando 0 resultados.',
    tryAgain: 'Intentar de Nuevo',
    activeCount: 'activos',
    hazard: 'peligro',
    hazards: 'peligros',
    homeSafe: 'llegaron seguros',
    activeHazards: 'Peligros Activos',
    worker: 'Trabajador',
    reports: 'reportes',
    confirms: 'confirmaciones',
    homeSafeCheck: 'Llegué seguro ✓',
    madeItHome: 'Llegué a casa',
    guardian: 'guardián',
    trusted: 'confiable',
    verified: 'verificado',
    activeWorker: 'activo',
    newWorker: 'nuevo',
    
    // ErrorBoundary
    somethingWentWrong: 'Algo salió mal',
    errorDescription: 'La aplicación encontró un error inesperado. Tus favoritos guardados están seguros - intenta recargar.',
    reloadApp: 'Recargar App',
    
    // ProductionChart
    loadingProductionData: 'Cargando datos de producción...',
    productionDataUnavailable: 'Los datos de producción pueden no estar disponibles para todos los pozos',
    productionNoData: 'No hay datos de producción disponibles',
    productionLoadFailed: 'No se pudieron cargar los datos de producción',
    productionHistoryTitle: 'Historial de Producción',
    productionWellTitle: 'Producción de {0}',
    productionLatestWellRateLabel: 'BBL/DÍA DE PETRÓLEO',
    productionLatestLeaseLabel: 'ÚLTIMO MES DEL ARRENDAMIENTO',
    productionLatestReportedMonth: 'Último mes reportado',
    productionProducingDays: '{0} días de producción',
    productionGasRate: 'Gas {0} mcf/día',
    productionWaterRate: 'Agua {0} bbl/día',
    productionLeaseOil: 'Petróleo',
    productionLeaseGas: 'Gas',
    productionLeaseCondensate: 'Condensado',
    productionTotalsOil: 'Petróleo Total (bbls)',
    productionTotalsGas: 'Gas Total (mcf)',
    productionTotalsWater: 'Agua Total (bbls)',
    productionTotalsCondensate: 'Condensado Total (bbls)',
    productionSourceTxLease: 'Fuente: producción de arrendamiento PDQ de TX RRC • Últimos {0} meses',
    productionSourceNmWell: 'Fuente: reportes C-115 de NM OCD • Últimos {0} meses',
    productionSeriesOil: 'Petróleo',
    productionSeriesGas: 'Gas',
    productionSeriesWater: 'Agua',
    productionSeriesCondensate: 'Condensado',
    productionUnitBbls: 'bbls',
    productionUnitMcf: 'mcf',
    productionChartArea: 'Área',
    productionChartBar: 'Barras',
    productionChartMix: 'Mixto',
    productionIntelligenceTitle: 'Inteligencia de Producción',
    productionNetValuePerDay: 'VALOR NETO / DÍA',
    productionBrentUnavailable: 'BRENT N/D',
    productionBrentUnavailableLong: 'Precios de energía no disponibles',
    productionBrentUnavailableChart: 'Los precios de energía no están disponibles. Las vistas de petróleo, gas, agua y mixto aún muestran volúmenes de producción.',
    productionBrentWaterPrice: 'Brent ${0} • Agua ${1}/bbl',
    productionEnergyPrices: 'WTI ${0} • Brent ref ${1} • Henry Hub ${2} • Agua ${3}/bbl',
    productionOilRateShort: 'PETR + COND',
    productionGasRateShort: 'GAS',
    productionWaterRateShort: 'AGUA',
    productionWaterPenaltyShort: 'COSTO AGUA/DÍA',
    productionViewNet: 'NETO',
    productionViewOil: 'PETR',
    productionViewGas: 'GAS',
    productionViewWater: 'AGUA',
    productionViewMix: 'MIX',
    productionSeriesOilRate: 'Tasa de petróleo',
    productionSeriesCondensateRate: 'Tasa de condensado',
    productionSeriesLiquidRate: 'Tasa de líquidos',
    productionSeriesGasRate: 'Tasa de gas',
    productionSeriesWaterRate: 'Tasa de agua',
    productionSeriesOilValue: 'Valor petróleo',
    productionSeriesGasValue: 'Valor gas',
    productionSeriesGrossValue: 'Valor bruto',
    productionSeriesWaterPenalty: 'Penalización de agua',
    productionSeriesNetValue: 'Valor neto',
    
    // SuggestionsDialog
    suggestFeature: 'Sugerir una Función',
    supportRequest: 'Solicitud de Soporte',
    featureRequest: 'Solicitud de Función',
    bugReport: 'Reporte de Error',
    improvement: 'Mejora',
    thankYou: '¡Gracias!',
    suggestionSubmitted: '¡Tu sugerencia ha sido enviada. Apreciamos tus comentarios!',
    supportSubmitted: 'Tu solicitud de soporte ha sido enviada. Te responderemos pronto.',
    category: 'Categoría',
    title: 'Título',
    titlePlaceholder: 'Resumen breve de tu sugerencia',
    supportTitlePlaceholder: 'Resumen breve de tu problema',
    suggestionDescription: 'Descripción',
    suggestionDescriptionPlaceholder: 'Describe tu sugerencia en detalle. ¿Qué problema resuelve? ¿Cómo funcionaría?',
    supportDescription: 'Detalles del Problema',
    supportDescriptionPlaceholder: 'Describe el problema, los pasos para reproducirlo y cualquier captura o mensaje de error.',
    suggestFeatureEmailLabel: '¿Solicitud de función? Escribe a',
    suggestFeatureEmailAddress: 'sales@ziatechs.com',
    suggestFeatureTelegramLabel: 'También puedes escribirnos en Telegram:',
    submitSuggestion: 'Enviar Sugerencia',
    submitSupportRequest: 'Enviar Solicitud de Soporte',
    submitting: 'Enviando...',
    fillBothFields: 'Por favor completa el título y la descripción',
    newFeature: 'Nueva Función',
    navigation: 'Navegación',
    mapMarkers: 'Mapa y Marcadores',
    other: 'Otro',
    
    // DrawOverAppsPrompt
    drawOverEnhanceNav: 'Mejora tu Navegación',
    drawOverDesc: 'Habilita el permiso "Dibujar sobre otras apps" para Telegram para facilitar el regreso a ZiaWellNav mientras usas otras aplicaciones.',
    drawOverWhyEnable: '¿Por qué habilitar Dibujar sobre Apps?',
    drawOverWhyEnableDesc: 'Cuando cambias de Telegram a otra aplicación, ZiaWellNav puede mostrar superposiciones de navegación sobre tu pantalla. Esto facilita regresar a la navegación sin abrir Telegram nuevamente.',
    drawOverOpenSettings: 'Abrir Ajustes',
    drawOverOpenSettingsDesc: 'Toca el botón de abajo para abrir los ajustes de tu dispositivo. Busca el permiso "Mostrar sobre otras apps" o "Dibujar sobre otras apps".',
    drawOverEnableForTelegram: 'Habilitar para Telegram',
    drawOverEnableForTelegramDesc: 'Encuentra Telegram en la lista y habilita el permiso. Una vez habilitado, regresa aquí y toca "Listo".',
    drawOverSkip: 'Omitir por ahora',
    drawOverNext: 'Siguiente',
    drawOverDone: 'Listo',
    
    // GoHomeFAB
    goHomeSetLocation: 'Establecer Ubicación de Casa',
    goHomeUpdateLocation: 'Actualizar Ubicación de Casa',
    goHomeTooltip: 'Ir a {0} (mantener para editar)',
    goHomeTooltipNoHome: 'Establecer Ubicación de Casa',
    goHomeLocationDesc: 'Tu ubicación de casa se usa para la navegación "Ir a Casa" y para detener automáticamente el temporizador cuando llegas.',
    goHomeCurrent: 'Actual: <strong>{0}</strong>',
    goHomeLocationCaptured: '¡Ubicación capturada!',
    goHomeUseCurrentLocation: 'Usar Ubicación Actual',
    goHomeGettingLocation: 'Obteniendo Ubicación...',
    goHomeNameLabel: 'Nombre de Casa (opcional)',
    goHomeNamePlaceholder: 'ej. Mi Casa, El Rancho',
    goHomeSaveButton: 'Guardar Casa',
    goHomeNavigateQuestion: '¿Navegar a Casa?',
    goHomeNavigateTo: '¿Navegar a <strong style="color: {0}">{1}</strong>?',
    goHomeNavigateDesc: 'Esto abrirá Google Maps con direcciones a tu ubicación de casa.',
    goHomeAutoStopNote: '✓ El temporizador se detendrá automáticamente cuando llegues',
    goHomeGoButton: 'Ir a Casa',
    goHomeNavigateTitle: '🏠 Navegar a Casa',
    goHomeNavigateMessage: 'Ir a {0}',
    goHomeGoogleMaps: '🗺️ Google Maps',
    goHomeAppleMaps: '🍎 Apple Maps',
    goHomeWaze: '👻 Waze',
    goHomeToastSaved: '¡Ubicación de casa guardada! 🏠',
    goHomeToastFailed: 'Error al guardar la ubicación de casa',
    goHomeToastLocationCaptured: '¡Ubicación capturada! 📍 Agrega un nombre y guarda.',
    goHomeToastGeoNotSupported: 'La geolocalización no es compatible con tu navegador',
    goHomeToastLocationError: 'No se pudo obtener la ubicación',
    goHomeToastPermissionDenied: 'Permiso de ubicación denegado. Por favor habilita la ubicación en la configuración de tu navegador.',
    goHomeToastLocationUnavailable: 'Ubicación no disponible. Por favor intenta de nuevo.',
    goHomeToastLocationTimeout: 'Tiempo de espera de ubicación agotado. Por favor intenta de nuevo.',
    goHomeToastNavigating: '¡Navegando a casa! 🚗',
    
    // WorkTimerFAB
    workTimerStartTooltip: 'Iniciar Temporizador',
    workTimerPauseTooltip: 'Pausar (mantener para detener)',
    workTimerResumeTooltip: 'Reanudar (mantener para detener)',
    workTimerSelectCrew: 'Seleccionar Cuadrilla para Entrada de Tiempo',
    workTimerWhichCrew: '¿A qué cuadrilla se debe registrar este tiempo?',
    workTimerStopQuestion: '¿Detener Temporizador?',
    workTimerCurrentTime: 'Tiempo actual: <strong style="color: {0}">{1}</strong>',
    workTimerLoggingTo: 'Registrando a: {0}',
    workTimerKeepRunning: 'Seguir Ejecutando',
    workTimerStopButton: 'Detener Temporizador',
    workTimerYoureHome: '¡Estás en Casa!',
    workTimerArrivedAt: 'Parece que has llegado a <strong>{0}</strong>.',
    workTimerTotalTime: 'Tiempo total: <strong style="color: {0}">{1}</strong>',
    workTimerStopQuestion2: '¿Te gustaría detener el temporizador?',
    workTimerFailedStart: 'Error al iniciar',
    workTimerFailedPause: 'Error al pausar',
    workTimerFailedResume: 'Error al reanudar',
    workTimerFailedStop: 'Error al detener',
    
    // UserSupportFAB
    userSupportTooltip: 'Contactar Soporte ($1/mensaje)',
    
    // VPNWarningSnackbar
    vpnWarningMessage: '¡VPN detectado! Esto puede afectar la precisión de navegación. Considera desactivar tu VPN para un mejor rendimiento de GPS.',
    vpnDetected: 'VPN Detectado',
    vpnLearnMore: 'Saber Más',
    vpnWhyAffects: '¿Por qué el VPN afecta la navegación?',
    vpnInterferenceIntro: 'Los VPNs pueden interferir con los servicios de ubicación de varias maneras:',
    vpnIPLocation: 'La ubicación basada en IP puede mostrar un área incorrecta',
    vpnGPSBackup: 'Algunos servicios GPS usan la ubicación de red como respaldo',
    vpnMapTiles: 'La carga de mosaicos del mapa puede ser más lenta',
    vpnBestResults: 'Para mejores resultados en el campo petrolero, desactiva el VPN mientras navegas.',
    
    // OfflineSyncIndicator
    offlineTooltip: 'Fuera de línea - {0} envío{1} pendiente',
    offlineSyncing: 'Sincronizando...',
    offlinePendingTap: '{0} pendiente{1} - Toca para sincronizar',
    offlineAllSynced: 'Todo sincronizado',
    
    // ExpiredTrialBanner
    trialEnded: 'Tu prueba ha terminado. ¡Actualiza para desbloquear todas las funciones premium!',
    trialEndingSoon: '{0} — Actualiza ahora para mantener el acceso',
    upgradeNow: '✨ Actualizar Ahora',
    
    // SearchPanel
    searchButtonText: 'Buscar pozos por API, operador o ubicación...',
    searchInputPlaceholder: 'Buscar pozos...',
    searchResultsWillAppear: 'Los resultados de búsqueda aparecerán aquí...',
    
    // Profile Card
    profilePhone: 'Teléfono',
    profileEmail: 'Correo',
    profileSharePhone: 'Compartir Teléfono',
    profileEnterPhone: 'Ingrese teléfono',
    profileSave: 'Guardar',
    profileEmailNotLinked: 'No vinculado',
    profilePhoneNotShared: 'No compartido',
    profilePhoneOpenTelegram: 'Abrir en Telegram para compartir',

    // TelegramLogin
    telegramLoginLoading: 'Cargando...',
    telegramLoginOpenBot: 'Abrir @{0} en Telegram',

    // QRShareDialog
    qrShareTitle: 'Compartir VAMOS AR',
    qrLoadingReferral: 'Cargando información de referido...',
    qrSuccessfulReferrals: '¡{0} referido{1} exitoso{1}!',
    qrScanOrShare: 'Escanea este código QR o comparte el enlace a continuación',
    qrCopyLink: 'Copiar Enlace',
    qrCopied: '¡Copiado!',
    qrShareButton: 'Compartir',
    qrEarnCredits: 'Gana Créditos Compartiendo',
    qrFreeUserSignup: 'Usuario gratuito se registra',
    qrUserConvertsPaid: 'Usuario se convierte en pagado',
    qrBusinessSignup: 'Empresa se registra',
    qrFiveReferrals: 'Hito de 5 referidos',
    qrFreeMonth: '1 MES GRATIS',
    qrShareText: '🛢️ ¡Descubre ZiaWellNav - la mejor aplicación de navegación para campos petroleros!\n\n📍 Encuentra pozos, plataformas y SWDs en toda la Cuenca Pérmica\n🗺️ Navegación GPS paso a paso a cualquier instalación\n👥 Crea y gestiona tus cuadrillas\n🔧 Encuentra servicios de campo petrolero cerca de ti\n\n¡GRATIS durante el desarrollo! Únete ahora:',
    
    // PollenAlertWidget
    pollenLoadingData: 'Cargando datos de polen...',
    pollenLabel: 'Polen',
    pollenPlantsInSeason: '{0} plantas en temporada',
    pollenInSeasonPlants: 'Plantas en Temporada:',
    pollenMorePlants: '+{0} más',
    
    // NearbyServicesWidget
    nearbyServicesTitle: 'Servicios Cercanos',
    nearbyGasStations: 'Gasolineras',
    nearbyRestaurants: 'Restaurantes',
    nearbyHotels: 'Hoteles',
    nearbyMedical: 'Médico',
    nearbyAutoRepair: 'Reparación de Autos',
    nearbyStores: 'Tiendas',
    nearbyATMs: 'Cajeros Automáticos',
    nearbyFindingPlaces: 'Buscando {0} cercanos...',
    nearbyNoPlaces: 'No se encontraron {0} en un radio de 20 millas',
    nearbyNavigateTo: '🧭 Navegar a {0}',
    nearbyChooseApp: 'Elige aplicación de navegación',
    nearbyGoogleMaps: '🗺️ Google Maps',
    nearbyAppleMaps: '🍎 Apple Maps',
    nearbyWaze: '👻 Waze',
    nearbyOpenNow: 'Abierto ahora',
    nearbyClosed: 'Cerrado',
    nearbyOpen: 'Abierto',
    nearbyGetDirections: 'Obtener Direcciones',
    
    // AutoCaptureCamera
    cameraError: 'Error de Cámara',
    cameraStarting: 'Iniciando cámara...',
    
    // AirQualityWidget
    aqiPrefix: 'ICA',
    aqiError: 'ICA: {0}',
    aqiGood: 'Buena',
    aqiModerate: 'Moderada',
    aqiUnhealthySensitive: 'Poco Saludable (Sensibles)',
    aqiUnhealthy: 'Poco Saludable',
    aqiVeryUnhealthy: 'Muy Poco Saludable',
    aqiHazardous: 'Peligrosa',
    aqiRespiratoryWarning: 'Considere protección respiratoria',
    aqiIndexLabel: 'Índice de Calidad del Aire',
    aqiPollutants: 'Contaminantes',
    aqiHealthAdvisory: 'Aviso de Salud',
    aqiUpdated: 'Actualizado: {0}',
    aqiDataUnavailable: 'Datos de calidad del aire no disponibles',
    aqiFetchFailed: 'Error al obtener calidad del aire',
    
    // ElevationWidget
    elevSafe: 'SEGURO',
    elevCaution: 'PRECAUCIÓN',
    elevWarning: 'ADVERTENCIA',
    elevDanger: 'PELIGRO',
    elevProfile: 'Perfil de Elevación',
    elevFailed: 'Error al obtener elevación',
    elevUnavailable: 'Elevación no disponible',
    elevMaxGrade: 'Pendiente Máx',
    elevTotalAscent: 'Ascenso Total',
    elevTotalDescent: 'Descenso Total',
    elevFeet: 'pies',
    elevMiles: 'mi',
    elevUphill: 'Cuesta arriba',
    elevDownhill: 'Cuesta abajo',
    elevGrade: 'Pendiente',
    elevLoading: 'Calculando elevación...',
    
    // WeatherOverlay
    weatherWindCalm: 'CALMADO',
    weatherWindModerate: 'MODERADO',
    weatherWindCaution: 'PRECAUCIÓN - RÁFAGAS',
    weatherWindWarning: 'ADVERTENCIA - VIENTO FUERTE',
    weatherWindDanger: 'PELIGRO - VIENTO MUY FUERTE',
    weatherWindHurricane: 'FUERZA DE HURACÁN',
    weatherWindWarningLabel: '{0} - {1} mph',
    weatherFloodLow: 'Bajo riesgo de inundación',
    weatherFloodModerate: 'Riesgo moderado de inundación - Tenga cuidado cerca de arroyos secos',
    weatherFloodHigh: '⚠️ ALTO riesgo de inundación repentina - ¡Evite áreas bajas y arroyos!',
    weatherFloodExtreme: '⚠️ RIESGO EXTREMO DE INUNDACIÓN REPENTINA - ¡Busque terreno alto inmediatamente!',
    weatherThunderstormWarning: 'Advertencia de Tormenta',
    weatherHeavyRain: 'Alerta de Lluvia Intensa',
    weatherThunderstormWarningDesc: '{0}% de probabilidad de tormentas eléctricas. Busca refugio y evita áreas abiertas.',
    weatherHeavyRainDesc: '{0}% de probabilidad de precipitación. Vigila condiciones de inundación repentina.',
    weatherProviderGoogle: 'Google Weather',
    weatherWind: 'Viento',
    weatherTemp: 'Temp',
    weatherFeelsLike: 'Sensación',
    weatherHumidity: 'Humedad',
    weatherVisibility: 'Visibilidad',
    weatherClouds: 'Nubes',
    weatherUVIndex: 'Índice UV',
    weatherPrecipProb: 'Precipitación',
    weatherUpdated: 'Actualizado: {0}',
    weatherWindGusts: '(ráfagas {0} mph)',
    weatherAlertCount: '{0} {1}',
    alert: 'alerta',
    alerts: 'alertas',
    weatherWindSpeedLabel: 'Velocidad del viento',
    weatherGusts: 'Ráfagas',
    weatherGustsUpTo: 'Ráfagas de hasta {0} mph',
    weatherUnavailable: 'Datos meteorológicos no disponibles',
    weatherFetchFailed: 'Error al obtener datos meteorológicos',
    weatherNotConfigured: 'API meteorológica no configurada',
    weatherSixDayForecast: 'Pronóstico de 6 Días',
    weatherTemperatureTrend: 'Tendencia de temperatura',
    weatherWindTrend: 'Tendencia del viento',
    weatherSixDayHighLow: 'Máxima / mínima de 6 días',
    weatherSixDayWindGust: 'Viento sostenido / ráfaga de 6 días',
    weatherTrendUnavailable: 'Tendencia del pronóstico no disponible',
    weatherNow: 'Ahora',
    today: 'Hoy',

    // OfflineCacheManager
    offlineCacheTitle: 'Caché sin conexión',
    offlineCacheLowSignalTag: 'Para zonas con poca señal',
    offlineCacheMapTilesTab: 'Tiles del mapa',
    offlineCacheFacilityDataTab: 'Datos de instalaciones',
    offlineCacheTotalCached: 'Total en caché',
    offlineCacheMapTiles: 'Tiles del mapa',
    offlineCacheAreasCached: 'Zonas en caché',
    offlineCacheRefresh: 'Actualizar',
    offlineCacheClearAllMapCache: 'Borrar toda la caché del mapa',
    offlineCacheDownloading: 'Descargando: {0}',
    offlineCacheProgressTiles: '{0} / {1} tiles',
    offlineCacheFailedCount: '{0} fallidos',
    offlineCacheWorkAreasTitle: 'Áreas de trabajo de la Cuenca Pérmica',
    offlineCacheCachedTiles: 'En caché: {0} tiles ({1} MB)',
    offlineCacheEstimatedTiles: '~{0} tiles • ~{1} MB',
    offlineCacheClearCache: 'Borrar caché',
    offlineCacheDownloadingButton: 'Descargando...',
    offlineCacheDownloadButton: 'Descargar',
    offlineCacheMapTilesLabel: 'Tiles del mapa',
    offlineCacheMapTilesHelp: 'Descarga tiles del mapa para zonas donde trabajas con frecuencia. Una vez en caché, los mapas cargarán incluso sin señal.',
    offlineCacheFacilityData: 'Datos de instalaciones',
    offlineCacheBasinsCached: 'Cuencas en caché',
    offlineCacheVerified: 'Verificado',
    offlineCacheVerifyIntegrity: 'Verificar integridad',
    offlineCacheClearAllFacilityCache: 'Borrar toda la caché de instalaciones',
    offlineCacheDownloadByBasin: 'Descargar datos por cuenca',
    offlineCacheDownloadedCounties: 'Descargado • {0}',
    offlineCacheUpdateButton: 'Actualizar',
    offlineCacheFacilityDataLabel: 'Datos de instalaciones',
    offlineCacheFacilityDataHelp: 'Descarga información de pozos e instalaciones para búsqueda sin conexión. La búsqueda funciona sin internet una vez en caché.',
    offlineCacheLoadFailed: 'No se pudieron cargar los datos de caché. Asegúrate de que la API esté en ejecución.',
    offlineCacheBasinDownloadFailed: 'No se pudo descargar {0}. Inténtalo de nuevo.',
    offlineCacheIntegrityFailed: 'La verificación de integridad falló. Considera volver a descargar.',
    offlineCacheVerifyFailed: 'No se pudo verificar la integridad de la caché.',
    offlineBasinDelaware: 'Cuenca de Delaware',
    offlineBasinPermian: 'Cuenca Pérmica',
    offlineBasinSanJuan: 'Cuenca de San Juan',
    offlineBasinRaton: 'Cuenca de Raton',
    offlineBasinTxPermian: 'Cuenca Pérmica de TX',
    offlineBasinDelawareCounties: 'Eddy + Lea (NM)',
    offlineBasinPermianCounties: 'Sureste de NM',
    offlineBasinSanJuanCounties: 'Noroeste de NM',
    offlineBasinRatonCounties: 'Noreste de NM',
    offlineBasinTxPermianCounties: 'Midland, Ector, Andrews, + más',
    
    // StreetViewModal
    streetViewTitle: 'Vista Previa de Street View',
    streetViewNorth: 'Norte',
    streetViewEast: 'Este',
    streetViewSouth: 'Sur',
    streetViewWest: 'Oeste',
    streetViewNotAvailable: 'Street View no disponible en esta ubicación',
    streetViewUnavailable: 'Street View no disponible',
    streetViewLoading: 'Cargando Street View...',
    streetViewFailed: 'Error al cargar Street View',
    streetViewRotateLeft: 'Rotar izquierda',
    streetViewRotateRight: 'Rotar derecha',
    streetViewPitchUp: 'Mirar arriba',
    streetViewPitchDown: 'Mirar abajo',
    streetViewClose: 'Cerrar',
    streetViewPanorama: 'Panorama Completo',
    streetViewMetadata: 'Metadatos de Street View',
    
    // PhotoGallery
    photoNoPhotos: 'Aún no hay fotos',
    photoTapToAdd: 'Toca para agregar la primera foto',
    photoDeleteConfirm: '¿Eliminar esta foto? Esto no se puede deshacer.',
    photoDeleted: 'Foto eliminada',
    photoDeleteFailed: 'Error al eliminar foto',
    photoReportTitle: 'Reportar Foto',
    photoReportMessage: '¿Por qué estás reportando esta foto?',
    photoReportInappropriate: '🚫 Inapropiada',
    photoReportWrongLocation: '❌ Ubicación Incorrecta',
    photoReportSpam: '📧 Spam',
    photoReportSubmitted: 'Reporte enviado. ¡Gracias!',
    photoReportFailed: 'Error al enviar reporte',
    photoOf: 'Foto {0} de {1}',
    photoFullscreen: 'Ver en pantalla completa',
    photoSwipeToNavigate: 'Desliza para navegar',
    photo360: '360°',
    photoFacilityPhoto: 'Foto de instalación',
    photoDelete: 'Eliminar',
    photoReport: 'Reportar',
    
    // OnboardingDialog
    onboardingTitle: 'Datos Sin Conexión',
    onboardingSubtitle: 'Descargar para uso en campo',
    onboardingDescription: 'Accede a pozos e instalaciones incluso sin señal celular.',
    onboardingPriority: '⭐ Prioridad',
    onboardingRecommended: 'Recomendado',
    onboardingAllCounties: '📦 Todos los Condados',
    onboardingCompleteCoverage: 'Cobertura completa • 32 condados de NM',
    onboardingFastCDN: 'Modo CDN Rápido',
    onboardingDontShowAgain: 'No mostrar de nuevo',
    onboardingDownloading: 'Descargando...',
    onboardingSkipForNow: 'Omitir por ahora',
    onboardingContinueUsing: 'Continuar Usando la App',
    onboardingBackgroundNote: 'Puedes cerrar esto y seguir usando la app. Las descargas se ejecutan en segundo plano.',
    onboardingRemaining: '{0} restante',

    // Timer Locations (Home/Work)
    timerLocationsTooltip: 'Ubicaciones del temporizador',
    timerLocationsTitle: 'Configuraci\u00f3n de Casa y Trabajo',
    timerLocationsSubtitleOnboarding: 'Usado para tu temporizador de trabajo',
    timerLocationsSubtitleEdit: 'Editar ubicaciones guardadas',
    timerLocationsPrivacy1: 'Se guarda solo en tu dispositivo.',
    timerLocationsPrivacy2: 'No guardamos ni vemos tu direcci\u00f3n de casa/trabajo en nuestros servidores.',
    timerLocationsPurpose: 'Esto ayuda a iniciar/detener el temporizador por ubicaci\u00f3n (para registrar tus horas y compartirlas por Telegram).',
    timerLocationsHomeLabel: 'Direcci\u00f3n de casa',
    timerLocationsWorkLabel: 'Direcci\u00f3n del trabajo',
    timerLocationsAddressPlaceholder: 'Busca una direcci\u00f3n\u2026',
    timerLocationsUseCurrentLocation: 'Usar ubicaci\u00f3n actual',
    timerLocationsSkipForNow: 'Omitir por ahora',
    timerLocationsClose: 'Cerrar',
    timerLocationsSave: 'Guardar',
    timerLocationsConfirmIncomplete: '\u00bfGuardar con solo una ubicaci\u00f3n? Te lo recordaremos m\u00e1s tarde hasta que ambas est\u00e9n configuradas.',
    timerLocationsLocationRequired: 'Se requiere ubicaci\u00f3n',
    timerLocationsLocationFailed: 'No se pudo obtener tu ubicaci\u00f3n',
    
    // LocationPermissionDialog
    locationPermissionTitle: 'Acceso de Ubicación',
    locationPermissionDescription: 'ZiaWellNav quiere acceder a tu ubicación',
    locationPermissionGrant: 'Permitir',
    locationPermissionLater: 'Ahora No',
    locationPermissionNever: 'Nunca Permitir',
    locationPermissionIndefinitely: 'Permitir Indefinidamente',
    locationPermissionIndefinitelyDesc: 'Permitir acceso de ubicación siempre sin preguntar de nuevo',
    locationPermissionSession: 'Permitir Mientras Uso la App',
    locationPermissionSessionDesc: 'Permitir hasta cerrar la app o por 24 horas',
    locationPermissionOnce: 'Permitir Una Vez',
    locationPermissionOnceDesc: 'Permitir solo esta vez, preguntar de nuevo la próxima vez',
    
    // SubscriptionPanel
    subscriptionTitle: 'Actualizar a Premium',
    subscriptionMonthly: 'Mensual',
    subscriptionYearly: 'Anual',
    subscriptionFreeTrial: 'Prueba Gratuita',
    subscriptionSubscribe: 'Suscribirse Ahora',
    subscriptionCancel: 'Cancelar en Cualquier Momento',
    subscriptionFeature1: 'Búsquedas ilimitadas',
    subscriptionFeature2: 'Mapas sin conexión',
    subscriptionFeature3: 'Soporte premium',
    
    // WellDetailsModal
    wellDetailsTitle: 'Detalles del Pozo',
    wellDetailsAPI: 'Número API',
    wellDetailsOperator: 'Operador',
    wellDetailsStatus: 'Estado',
    wellDetailsType: 'Tipo',
    wellDetailsLocation: 'Ubicación',
    wellDetailsElevation: 'Elevación',
    wellDetailsDepth: 'Profundidad',
    wellDetailsProduction: 'Producción',
    wellDetailsClose: 'Cerrar',
    
    // AddFacilityForm
    addFacilityTitle: 'Agregar Instalación',
    addFacilityName: 'Nombre de la Instalación',
    addFacilityType: 'Tipo de Instalación',
    addFacilityLocation: 'Ubicación',
    addFacilityNotes: 'Notas',
    addFacilitySubmit: 'Enviar',
    addFacilityCancel: 'Cancelar',
    
    // HomeSpeedDial
    homeAndLocation: 'Inicio y Ubicación',
    homeResetMapView: 'Restablecer Vista del Mapa',
    homeSetLocation: 'Establecer Ubicación de Inicio',
    homeUpdateHome: 'Actualizar Inicio',
    homeNavigateHome: 'Navegar a Inicio',
    
    // FriendsPanel
    friendsTitle: 'Amigos',
    friendsShareInvite: 'Compartir Enlace de Invitación',
    friendsShareLocation: 'Compartir Mi Ubicación',
    friendsShareLocationDesc: 'Permite que tus amigos vean tu ubicación en tiempo real en el mapa',
    friendsTabFriends: 'Amigos',
    friendsTabRequests: 'Solicitudes',
    friendsAddByUsername: 'Agregar Amigo por Nombre de Usuario',
    friendsNoFriends: 'Aún no hay amigos. ¡Agrega amigos para compartir ubicaciones!',
    friendsNoPendingRequests: 'No hay solicitudes de amistad pendientes',
    friendsLocationAvailable: 'Ubicación disponible',
    friendsWaitingLocation: 'Esperando ubicación...',
    friendsLocationNotShared: 'Ubicación no compartida',
    friendsStopSharing: 'Dejar de compartir ubicación',
    friendsStartSharing: 'Compartir tu ubicación',
    friendsNavigateTo: 'Navegar hacia amigo',
    friendsRemoveFriend: 'Eliminar amigo',
    friendsAddFriend: 'Agregar Amigo',
    friendsEnterUsername: 'Ingresa el nombre de usuario de Telegram de tu amigo',
    friendsSendRequest: 'Enviar Solicitud',
    friendsWantsToBeFriend: 'Quiere ser tu amigo',
    // Vehicle Inspection
    preTrip: 'Pre-Viaje',
    postTrip: 'Post-Viaje',
    preTripUnlocksAfter: 'El Post-Viaje se desbloquea después de guardar un Pre-Viaje.',
    vehicleInspection: 'Inspección de Vehículo',
    vehicleType: 'Tipo de Vehículo',
    otherVehicle: 'Otro vehículo',
    unitNumber: 'Camión # / Unidad #',
    truckTagNumber: 'Placa del Camión #',
    trailerNumber: 'Remolque #',
    trailerTagNumber: 'Placa del Remolque #',
    equipmentNumbers: 'Equipo # (artículos en remolque — separados por coma)',
    equipmentNumbersPlaceholder: 'ej. EQ-101, EQ-202',
    odometer: 'Odómetro',
    engineHours: 'Horas de Motor',
    addEngineHours: 'Agregar horas de motor',
    defectsNotes: 'Defectos / Notas',
    hasTrailer: 'Tiene Remolque',
    yourName: 'Tu Nombre',
    shareNote: 'Nota para compartir en Telegram (opcional)',
    shareNotePlaceholder: 'ej. Reportes Pre/Post viaje para Camión 12',
    driverSeatInCab: 'Asiento del Conductor (En Cabina)',
    driverSideFront: 'Lado del Conductor (Frente)',
    frontOfVehicle: 'Frente del Vehículo',
    passengerSideFront: 'Lado del Pasajero (Frente)',
    rearOfVehicle: 'Parte Trasera del Vehículo',
    underHoodEngine: 'Bajo el Cofre / Motor',
    emergencyEquipment: 'Equipo de Emergencia',
    trailerWalkAround: 'Inspección del Remolque',
    ratingGreat: 'Excelente',
    ratingOk: 'Bien',
    ratingBad: 'Malo',
    submitPreTrip: 'Guardar Inspección Pre-Viaje',
    submitPostTrip: 'Guardar Inspección Post-Viaje',
    inspectionSaved: '¡Inspección guardada!',
    preTripHistory: 'Historial Pre-Viaje',
    postTripHistory: 'Historial Post-Viaje',
    viewPreTripHistory: 'Historial Pre-Viaje',
    viewPostTripHistory: 'Historial Post-Viaje',
    preTripReminderToast: 'Completa tu inspección pre-viaje antes de salir.',
    postTripReminderToast: 'Has vuelto a {0}. Completa tu inspección post-viaje.',
    noInspectionsFound: 'No se encontraron inspecciones',
    signatureRequired: 'Por favor firme o escriba su nombre para enviar.',
    walkAroundChecklist: 'Lista de Verificación',
    signAndSubmit: 'Firmar y Enviar',
    typeYourName: 'Escribir Nombre',
    drawSignature: 'Firma Dibujada',
    clearSignature: 'Borrar',
    sendToTelegram: 'Enviar a Telegram',
    sendToCrew: 'Enviar a la Cuadrilla',
    shareInspection: 'Compartir Inspección',
    inspectionType: 'Tipo de Inspección',
    vehicleInfo: 'Info del Vehículo',
    checklistComplete: 'Lista completa',
    defectsFound: 'Defectos encontrados',
    noDefects: 'Sin defectos',
    tapToRate: 'Toca para calificar',
    locationRecorded: 'Ubicación registrada',
    addPhoto: 'Agregar Foto',
    viewPhotos: 'Ver Fotos',
    inspectionDetails: 'Detalles de Inspección',
    submittedBy: 'Enviado por',
    submittedAt: 'Enviado el',
    closeInspection: 'Cerrar',
    // JSA (Job Safety Analysis)
    jsaHistory: 'Historial de JSA',
    jobSafetyAnalysis: 'Análisis de Seguridad Laboral',
    locationAndJob: 'Ubicación y Trabajo',
    hazardsAndControls: 'Peligros y Controles',
    emergencyInfo: 'Info de Emergencia',
    reviewAndSign: 'Revisar y Firmar',
    apiNumberLabel: 'Número API',
    apiNumberPlaceholder: '30-039-12345',
    wellFacilityName: 'Pozo / Nombre de Instalación',
    operatorLabel: 'Operador',
    otherOperator: 'Otro Operador',
    countyLabel: 'Condado',
    otherCounty: 'Otro Condado',
    stateLabel: 'Estado',
    otherState: 'Otro Estado',
    jobTypeLabel: 'Tipo de Trabajo',
    otherJobType: 'Otro Tipo de Trabajo',
    jobDescriptionLabel: 'Descripción del Trabajo',
    describeJobStep: 'Describe el paso del trabajo...',
    addStep: 'Agregar Paso',
    removeStep: 'Eliminar Paso',
    hazardLabel: 'Peligro',
    customHazard: 'Peligro personalizado...',
    controlMitigation: 'Control / mitigación',
    riskLevelLabel: 'Nivel de Riesgo',
    riskLow: 'Bajo',
    riskMedium: 'Medio',
    riskHigh: 'Alto',
    riskCritical: 'Crítico',
    addHazard: 'Agregar Peligro',
    removeHazard: 'Eliminar Peligro',
    ppeRequiredLabel: 'EPP Requerido',
    windDirectionLabel: 'Dirección del Viento',
    musterPointLabel: 'Punto de Reunión',
    selectMusterPoint: 'Seleccionar Punto de Reunión',
    musterPointPin: 'Pin',
    musterPointDraw: 'Dibujar',
    tapMapDropPin: 'Toca el mapa para colocar un pin de punto de reunión. Arrastra para reposicionar.',
    drawFingerHighlight: 'Dibuja con tu dedo para resaltar el área de reunión.',
    nearestHospitalLabel: 'Hospital más Cercano',
    hospitalDirectionsLabel: 'Direcciones al Hospital',
    emergencyContacts: 'Contactos de Emergencia',
    addContact: 'Agregar Contacto',
    contactName: 'Nombre',
    contactPhone: 'Teléfono',
    contactRole: 'Rol',
    h2sPresent: 'H₂S Presente',
    h2sReading: 'Lectura de H₂S (ppm)',
    stopWorkAuthority: 'Autoridad de Parar Trabajo',
    stopWorkAcknowledge: 'Reconozco la Autoridad de Parar Trabajo — pararé el trabajo si las condiciones se vuelven inseguras.',
    signerName: 'Tu Nombre / Firma',
    signerRole: 'Rol / Título',
    addSigner: 'Agregar Otro Firmante',
    removeSigner: 'Eliminar Firmante',
    saveAndSignJsa: 'Guardar y Firmar JSA',
    shareJsa: 'Compartir JSA para Firmar',
    jsaSaved: '¡JSA guardado y firmado!',
    noJsasFound: 'No se encontraron JSAs',
    jsaStep1: 'Paso 1',
    jsaStep2: 'Paso 2',
    jsaStep3: 'Paso 3',
    jsaStep4: 'Paso 4',
    jsaNumber: 'JSA #',
    jsaStatus: 'Estado',
    jsaActive: 'activo',
    jsaCompleted: 'completado',
    jsaDraft: 'borrador',
    jsaCreatedAt: 'Creado',
    jsaOpenForSigning: 'Abierto para Firma',
    jsaAlreadySigned: 'Ya Firmado',
    jsaSignedBy: 'Firmado por',
    jsaAt: 'el',
    drawYourSignature: 'Dibuja tu firma',
    clearSignatureDraw: 'Borrar',
    typeInsteadDraw: 'Escribir en su lugar',
    drawInstead: 'Dibujar en su lugar',
    enterNamePlaceholder: 'Ingresa tu nombre...',
    jobSteps: 'Pasos del Trabajo',
    noStepsAdded: 'No se han agregado pasos',
    noHazardsAdded: 'No se han agregado peligros',
    notesLabel: 'Notas',
    company: 'Empresa',
    // WellDetailsModal
    routePreviewLabel: '📍 Vista de Ruta',
    distanceLabel: 'Distancia',
    estTimeLabel: 'Tiempo Est.',
    viaSummary: 'vía {0}',
    calicheRoutesLabel: '🛣️ Rutas Caliche',
    routeFromLabel: 'Desde: {0}',
    waypointsCount: '{0} puntos de paso',
    wellOperatorLabel: 'Operador',
    wellCountyLabel: 'Condado',
    wellBasinLabel: 'Cuenca',
    wellCoordsLabel: 'Coordenadas',
    wellRegulatoryTitle: 'Detalle Regulatorio',
    wellTxRegulatoryTitle: 'Detalle Regulatorio de Texas',
    wellRegulatorySubtitle: 'Arrendamiento, campo, yacimiento, profundidad, fechas regulatorias y perfil del pozo.',
    wellLeaseProductionBadge: 'Producción de Arrendamiento',
    wellRegulatoryLoading: 'Cargando detalle enriquecido del pozo...',
    wellRegulatoryEmpty: 'Todavía no hay detalle regulatorio disponible para este pozo.',
    wellRegulatoryLease: 'Arrendamiento',
    wellRegulatoryDistrict: 'Distrito',
    wellRegulatoryOilGas: 'Petróleo/Gas',
    wellRegulatoryWellNumber: 'Número de Pozo',
    wellRegulatoryField: 'Campo',
    wellRegulatoryPool: 'Yacimiento',
    wellRegulatoryWellType: 'Tipo de Pozo',
    wellRegulatorySpud: 'Inicio',
    wellRegulatoryCompletion: 'Terminación',
    wellRegulatoryPlugDate: 'Fecha de Taponamiento',
    wellRegulatoryTotalDepth: 'Profundidad Total',
    wellRegulatoryLateral: 'Lateral',
    wellTxPermitTitle: 'Detalle de Permiso de Texas',
    wellTxPermitSubtitle: 'Permiso RRC más reciente vinculado a este pozo.',
    wellTxPermitLoading: 'Cargando detalle de permiso vinculado...',
    wellTxPermitPermit: 'Permiso',
    wellTxPermitStatus: 'Estado',
    wellTxPermitPermitDate: 'Fecha del Permiso',
    wellTxPermitSubmitted: 'Enviado',
    wellTxPermitType: 'Tipo de Permiso',
    wellTxPermitOperatorNumber: 'No. de Operador',
    wellTxPermitField: 'Campo',
    wellTxPermitPlannedDepth: 'Profundidad Planeada',
    wellTxPermitLateral: 'Lateral',
    wellTxH2STitle: 'Registro de H2S de Texas',
    wellTxH2SSubtitle: 'Datos oficiales de cumplimiento del Formulario H-9 de la RRC de Texas vinculados a este sitio.',
    wellTxH2SLoading: 'Cargando detalle H-9 vinculado...',
    wellTxH2SReportedPpm: 'H2S Reportado',
    wellTxH2SReportedFlow: 'Flujo Reportado',
    wellTxH2SRoe100: 'ROE de 100 ppm',
    wellTxH2SRoe500: 'ROE de 500 ppm',
    wellTxH2SApprovalDate: 'H-9 Aprobado',
    wellTxH2STermDate: 'Fecha de Vigencia H-9',
    wellTxH2SAmendedDate: 'H-9 Enmendado',
    wellTxH2SDrillDepth: 'Profundidad de Cumplimiento de Perforación',
    wellTxH2SOperator: 'Operador',
    wellTxH2SOperatorNumber: 'No. de Operador',
    wellTxH2SLease: 'Arrendamiento / Instalación',
    wellTxH2SFacilityNumber: 'No. de Arrendamiento / Instalación',
    wellTxH2SFacilityId: 'ID de Instalación',
    wellTxH2SFacilityType: 'Tipo de Instalación',
    wellTxH2SField: 'Campo',
    wellTxH2SCounty: 'Condado',
    wellTxH2SMatchBasis: 'Base de Coincidencia',
    wellTxH2SSource: 'Fuente',
    wellTxH2SComments: 'Comentarios',
    wellTxH2SMatchLease: 'Coincidencia por Número de Arrendamiento',
    wellTxH2SMatchFacilityNumber: 'Coincidencia por Número de Instalación',
    wellTxH2SMatchFacilityId: 'Coincidencia por ID de Instalación',
    wellTxH2STermActive: 'Vigencia Activa',
    wellTxH2STermExpired: 'Vigencia Vencida',
    wellTxH2SCard: 'Registro H2S',
    wellTxOfficialWaterTitle: 'Agua Oficial de Texas',
    wellTxOfficialWaterSubtitle: 'Tasa oficial de agua de prueba de estado RRC W-10/G-10. No es un total mensual de agua producida.',
    wellTxOfficialWaterLoading: 'Cargando tasa oficial de prueba de agua de Texas...',
    wellTxOfficialWaterRate: 'Tasa de Prueba de Agua',
    wellTxOfficialWaterSource: 'Formulario Fuente',
    wellTxOfficialWaterTestDate: 'Fecha de Prueba',
    wellTxOfficialWaterEffectiveDate: 'Fecha Efectiva',
    wellTxOfficialWaterCycle: 'Mes del Ciclo',
    wellTxOfficialWaterLeaseKey: 'Clave de Arrendamiento',
    wellTxOfficialWaterMatchedApi: 'API Vinculado',
    wellTxOfficialWaterMatch: 'Confianza de Coincidencia',
    wellTxOfficialWaterAvailable: 'Oficial',
    wellTxOfficialWaterUnavailable: 'No Disponible',
    wellTxOfficialWaterUnavailableText: 'Tasa oficial de prueba de agua de Texas no disponible.',
    wellTxOfficialWaterWarning: 'Tasa oficial de prueba, no total mensual de agua producida.',
    wellLifecycleTitle: 'Cronología del Pozo',
    wellLifecycleSubtitle: 'Hitos clave de permiso, perforación, terminación y producción.',
    wellLifecycleLoading: 'Cargando cronología...',
    wellLifecycleEmpty: 'Todavía no hay hitos de cronología disponibles para este sitio.',
    wellLifecyclePermitSubmitted: 'Permiso Enviado',
    wellLifecyclePermitApproved: 'Permiso Aprobado',
    wellLifecycleSpud: 'Spud',
    wellLifecycleCompletion: 'Terminación',
    wellLifecycleFirstProduction: 'Primera Producción',
    wellLifecycleLatestProduction: 'Producción Más Reciente',
    wellLifecyclePlug: 'Fecha de Taponamiento',
    wellLifecycleLatestActivity: 'Actividad Más Reciente',
    wellLifecycleLatestActivityPermit: 'Permiso',
    wellLifecycleLatestActivityProduction: 'Producción',
    wellLifecycleLatestActivityCompletion: 'Terminación',
    wellLifecycleLatestActivityPlug: 'Taponamiento',
    wellLifecycleLatestActivitySpud: 'Spud',
    wellTxActivityTitle: 'Resumen de Actividad de Texas',
    wellTxActivitySubtitle: 'Identidad del operador actual y producción reciente del arrendamiento para este pozo.',
    wellTxActivityLoading: 'Cargando actividad reciente de Texas...',
    wellTxActivityOperator: 'Operador',
    wellTxActivityOperatorNumber: 'No. de Operador',
    wellTxActivityLease: 'Arrendamiento',
    wellTxActivityField: 'Campo',
    wellTxActivityLatestMonth: 'Mes Reportado Más Reciente',
    wellTxActivityLatestVolumes: 'Volúmenes Más Recientes',
    wellTxActivityTrailing3: 'Total de 3 Meses',
    wellTxActivityTrailing6: 'Total de 6 Meses',
    wellTxActivityTrailing12: 'Total de 12 Meses',
    wellTxActivityTrendUp: 'Tendencia al Alza',
    wellTxActivityTrendDown: 'Tendencia a la Baja',
    wellTxActivityTrendFlat: 'Tendencia Estable',
    wellTxActivityOilAmount: '{0} bbl petróleo',
    wellTxActivityGasAmount: '{0} mcf gas',
    wellTxActivityCondensateAmount: '{0} bbl condensado',
    wellTxViolationTitle: 'Detalle de Violaciones de Texas',
    wellTxViolationSubtitle: 'Hallazgos recientes de inspección RRC vinculados a este pozo o arrendamiento.',
    wellTxViolationLoading: 'Cargando detalle de violaciones vinculado...',
    wellTxViolationCount: '{0} recientes',
    wellTxViolationOpenCount: '{0} abiertas',
    wellTxViolationInspection: 'Inspección',
    wellTxViolationPenalty: 'Multa',
    wellTxViolationInspected: 'Inspeccionado',
    wellTxViolationResolved: 'Resuelto',
    wellTxViolationApiMatch: 'Coincidencia API',
    wellTxViolationLeaseMatch: 'Coincidencia de Arrendamiento',
    wellNearbyOpsTitle: 'Contexto de Operaciones Cercanas',
    wellNearbyOpsSubtitle: 'Pozos del mismo arrendamiento y las instalaciones de apoyo de Texas más cercanas.',
    wellNearbyOpsLoading: 'Cargando contexto de operaciones cercanas...',
    wellNearbyOpsEmpty: 'Todavía no hay contexto de operaciones cercanas disponible para este sitio.',
    wellNearbyOpsSameLease: 'Pozos del Mismo Arrendamiento',
    wellNearbyOpsSameField: 'Pozos del Mismo Campo',
    wellNearbyOpsRoutes: 'Rutas',
    wellNearbyOpsNearestSwd: 'SWD Más Cercano',
    wellNearbyOpsNearestGasPlant: 'Planta de Gas Más Cercana',
    wellNearbyOpsNearestPipeline: 'Oleoducto/Gasoducto Más Cercano',
    wellNearbyOpsMiles: '{0} mi',
    wellFacilityOpsTitle: 'Detalle de Instalación',
    wellFacilityOpsSwdTitle: 'Detalle de SWD',
    wellFacilityOpsRigTitle: 'Detalle de Perforadora',
    wellFacilityOpsPipelineTitle: 'Detalle de Tubería',
    wellFacilityOpsSubtitle: 'Detalle operativo y de registro para esta instalación.',
    wellFacilityOpsLoading: 'Cargando detalle de instalación...',
    wellFacilityDetailPermit: 'Permiso',
    wellFacilityDetailSerial: 'Serie',
    wellFacilityDetailCapacity: 'Capacidad',
    wellFacilityDetailCapacityMcf: 'Capacidad de Planta',
    wellFacilityDetailWellDepth: 'Profundidad',
    wellFacilityDetailWellType: 'Tipo de Pozo',
    wellFacilityDetailPool: 'Yacimiento',
    wellFacilityDetailRigType: 'Tipo de Perforadora',
    wellFacilityDetailContractor: 'Contratista',
    wellFacilityDetailCurrentWell: 'Pozo Actual',
    wellFacilityDetailSystem: 'Sistema',
    wellFacilityDetailSubsystem: 'Subsistema',
    wellFacilityDetailCommodity: 'Producto',
    wellFacilityDetailDiameter: 'Diámetro',
    wellFacilityDetailSystemType: 'Tipo de Sistema',
    wellFacilityDetailLength: 'Longitud',
    wellFacilityDetailInterstate: 'Interestatal',
    wellFacilityDetailCommonCarrier: 'Transportista Común',
    wellFacilityDetailDistrict: 'Distrito',
    wellFacilityDetailSymbology: 'Simbología',
    wellFacilityDetailSource: 'Fuente',
    wellFacilityDetailYes: 'Sí',
    wellFacilityDetailNo: 'No',
    unknownLabel: 'Desconocido',
    notAvailable: 'N/D',
    wellRelatedWells: 'Pozos Relacionados',
    wellRelatedWellsSubtitle: 'Contexto cercano del mismo arrendamiento o de registros coincidentes de campo/yacimiento.',
    wellLoadingDetail: 'Cargando detalle',
    wellRouteCountSingle: '{0} Ruta',
    wellRouteCountMultiple: '{0} Rutas',
    wellRouteToDestination: 'Ruta a {0}',
    googleMapsBtn: 'Google Maps',
    createJsaBtn: 'Crear JSA',
    createJobSafetyAnalysis: 'Crear Análisis de Seguridad Laboral',
    startInAppNav: 'Ruta visual 2D',
    startArNav: 'Iniciar Navegación AR',
    arNavigation: 'Navegación AR',
    calculating: 'Calculando...',
    appLoadingBrand: 'Cargando ZiaWellNav...',
    inspectionReportTitle: 'Reporte de Inspección Vehicular',
    downloadPdfBtn: 'Descargar PDF',
    loadingInspection: 'Cargando inspección...',
    inspectionLoadFailedHttp: 'No se pudo cargar la inspección (HTTP {0})',
    inspectionLoadFailed: 'No se pudo cargar la inspección',
    jsaReportTitle: 'Reporte JSA',
    loadingJsa: 'Cargando JSA...',
    jsaNotFound: 'JSA no encontrado',
    jsaLoadFailedHttp: 'No se pudo cargar el JSA (HTTP {0})',
    jsaLoadFailed: 'No se pudo cargar el JSA',
    jsaSitePhotoLimitToast: 'Las fotos de sitio del JSA están limitadas a 6',
    jsaSitePhotoLimitDetail: 'Solo se pueden adjuntar 6 fotos de sitio a un JSA',
    jsaSavedSignedWithPhotoFailures: 'JSA guardado y firmado. {0} foto{1} de sitio no se pudo subir.',
    jsaSavedSignedNumber: '¡JSA {0} guardado y firmado!',
    failedToSaveJsa: 'No se pudo guardar el JSA',
    signThisJsa: 'Firma este JSA: {0}{1}',
    signJsaTitle: 'Firmar JSA',
    failedToShareJsa: 'No se pudo compartir el JSA',
    optionalJsaPhotosPdf: 'Las fotos opcionales se incluyen en el PDF del JSA.',
    previousJsaTemplateLoaded: 'JSA anterior cargado como plantilla; modifícalo según sea necesario',
    jsaAutoExpiresDistance: 'El JSA expira automáticamente cuando todos los firmantes están a esta distancia del sitio',
    jsaSummaryTitle: 'Resumen del JSA',
    signJsa: 'Firmar JSA',
    archivedJsa: 'JSA Archivado',
    archivedJsaReadOnly: '{0} ha sido archivado y no se puede editar ni firmar. Vea el PDF como registro.',
    activeJsaNeedsSignature: 'El JSA activo en {0} necesita tu firma',
    stationaryJsaPrompt: 'Has estado en ubicación {0}+ minutos en {1}. ¿Completar un JSA?',
    jsaSavedToast: 'JSA guardado',
    shareViaTelegram: 'Compartir por Telegram',
    timesheetPanelTitle: 'Mi Hoja de Tiempo',
    timesheetMyTime: 'Mi Tiempo',
    timesheetCrewTime: 'Tiempo de Cuadrilla',
    thisWeek: 'Esta Semana',
    thisMonth: 'Este Mes',
    unknownUser: 'Usuario Desconocido',
    inProgress: 'En Progreso',
    hoursThisWeek: 'Horas Esta Semana',
    milesThisWeek: 'Millas Esta Semana',
    exportCsv: 'Exportar CSV',
    dailyBreakdown: 'Desglose Diario',
    timeEntriesCount: 'Entradas de Tiempo ({0})',
    noTimeEntriesPeriod: 'No se encontraron entradas de tiempo para este periodo. Inicia el temporizador para comenzar a rastrear.',
    gpsTrailPoints: 'Rastro GPS ({0} puntos)',
    viewMapTrail: 'Ver Rastro en Mapa',
    noGpsDataRecorded: 'No hay datos GPS registrados para esta entrada',
    submittedTimesheets: 'Hojas de Tiempo Enviadas',
    timesheetSubmittedStatus: 'Enviado',
    timesheetAcknowledgedStatus: 'Reconocido',
    timesheetRejectedStatus: 'Rechazado',
    timesheetDraftStatus: 'Borrador',
    gpsTrailTitle: 'Rastro GPS - {0}',
    noGpsCoordinatesEntry: 'No hay coordenadas GPS registradas para esta entrada',
    timesheetLeadEmailDetail: 'Email del jefe: {0}',
    timesheetChargeReadyDetail: '{0}/{1} entradas listas para cobrar para {2}.',
    timesheetNoUnsubmittedDetail: 'No hay entradas completadas sin enviar para {0}.',
    verifyingSubscription: 'Verificando suscripción...',
    subscriptionGateSubtitle: 'Suscríbete para acceder a navegación, seguridad y herramientas de IA',
    subscriptionActivating: 'Activando suscripción...',
    subscriptionRequiredAccess: 'Se requiere una suscripción para acceder a la app.',
    subscriptionVerifyFailed: 'No pudimos verificar tu suscripción en este momento. Revisa tu conexión o vincula tu compra.',
    subscriptionLinkTitle: '¿Ya pagaste? Vincula tu compra',
    subscriptionLinkSubtitle: 'Usa primero tu cuenta actual de Telegram. Si no encuentra la compra, vincúlala con el correo usado en Stripe.',
    linkTelegramPurchaseBtn: 'Vincular con Telegram',
    subscriptionEmailFallbackLabel: 'O vincula con el correo de compra',
    purchaseEmailPlaceholder: 'tu@correo.com',
    linkPurchaseBtn: 'Vincular Compra',
    linkingPurchase: 'Vinculando...',
    purchaseLinkedLoading: '¡Compra vinculada! Cargando tu suscripción...',
    purchaseLinkedRefreshing: '¡Compra vinculada! Actualizando...',
    purchaseNotFound: 'No se encontró una compra para ese correo.',
    telegramPurchaseNotFound: 'No se encontró una compra para esta cuenta de Telegram.',
    subscriptionShowPlans: '¿Necesitas suscribirte? Ver planes ▼',
    subscriptionHidePlans: 'Ocultar planes ▲',
    // CertVaultDialog
    businessSeatsTitle: 'Asientos de Empresa',
    businessSeatsDesc: 'Ingresa el correo de facturación que usaste al pagar para cargar tus claves de asiento. Comparte una clave con cada compañero; cada clave se puede reclamar una vez.',
    loadBtnLabel: 'Cargar',
    loadFromCloudBtn: 'Cargar de la Nube',
    syncToCloudBtn: 'Sincronizar a la Nube',
    passphraseLabel: 'Frase de contraseña (opcional)',
    passphraseHelperText: 'Agrega cifrado extra; debe coincidir en todos los dispositivos.',
    cardTitleLabel: 'Título de la Tarjeta',
    categoryOrCourse: 'Categoría / Curso',
    issuerLabel: 'Emisor',
    issuedLabel: 'Emitido',
    expiresLabel: 'Vence',
    addFrontBtn: 'Agregar Frente',
    replaceFrontBtn: 'Reemplazar Frente',
    addBackBtn: 'Agregar Reverso (opcional)',
    replaceBackBtn: 'Reemplazar Reverso',
    saveCardBtn: 'Guardar Tarjeta',
    noCardsSaved: 'No hay tarjetas guardadas aún.',
    frontLabel: 'Frente',
    backLabel: 'Reverso',
    claimBtn: 'Reclamar',
    pasteLicenseKey: 'Pegar clave de licencia',
    claimLicenseDesc: 'O pega una clave de licencia para reclamar este asiento para tu cuenta.',
    certSyncing: 'Sincronizando…',
    // LandmarksBottomSheet
    tapToSelectThenMap: 'Toca para seleccionar, luego toca el mapa',
    dragLandmarksOntoMap: 'Arrastra puntos de referencia al mapa',
    closeLandmarks: 'Cerrar puntos de referencia',
    undoLandmarkTooltip: 'Deshacer último punto ({0} colocados)',
    noLandmarksToUndo: 'No hay puntos de referencia para deshacer',
  }
} as const;

export type TranslationKey = keyof typeof translations.en;
export type Language = 'en' | 'es';

// Hook for using translations
export function useTranslation() {
  const language = useAppStore((state) => state.language);
  
  const t = (key: TranslationKey, ...args: (string | number)[]): string => {
    let text: string = translations[language][key] || translations.en[key] || key;
    
    // Replace placeholders like {0}, {1}, etc.
    args.forEach((arg, index) => {
      text = text.replace(`{${index}}`, String(arg));
    });
    
    return text;
  };
  
  return { t, language };
}

// Non-hook version for use outside of components
export function getTranslation(language: Language, key: TranslationKey, ...args: (string | number)[]): string {
  let text: string = translations[language][key] || translations.en[key] || key;
  
  args.forEach((arg, index) => {
    text = text.replace(`{${index}}`, String(arg));
  });
  
  return text;
}
